
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7U1nR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1e6357a99e20a8f7be8123461f296b5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5c0ed629f392b4e3$var$_react = $5c0ed629f392b4e3$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $5c0ed629f392b4e3$var$_baseNew = $5c0ed629f392b4e3$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $5c0ed629f392b4e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5c0ed629f392b4e3$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $5c0ed629f392b4e3$var$_react.default.createElement($5c0ed629f392b4e3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.75 1v7.44l2.72-2.72 1.06 1.06-4 4a.75.75 0 0 1-1.06 0l-4-4 1.06-1.06 2.72 2.72V1z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$5c0ed629f392b4e3$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $5c0ed629f392b4e3$var$_default = module.exports.default = $5c0ed629f392b4e3$var$ArrowDownIcon;

});

parcelRegister("5wA5J", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b97c8602ff8ab17fec6352425b80eb5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $405befeb64227266$var$_react = $405befeb64227266$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $405befeb64227266$var$_baseNew = $405befeb64227266$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $405befeb64227266$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $405befeb64227266$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $405befeb64227266$var$_react.default.createElement($405befeb64227266$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.47 1.22a.75.75 0 0 1 1.06 0l4 4-1.06 1.06-2.72-2.72V11h-1.5V3.56L2.53 6.28 1.47 5.22z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$405befeb64227266$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $405befeb64227266$var$_default = module.exports.default = $405befeb64227266$var$ArrowUpIcon;

});

parcelRegister("iOD6S", function(module, exports) {

$parcel$export(module.exports, "TableState", () => $a3a2e4569718778b$export$3d6dc94c3b008646);
$parcel$export(module.exports, "TableType", () => $a3a2e4569718778b$export$ec659152c0ce3638);
$parcel$export(module.exports, "CharlieTable", () => $a3a2e4569718778b$export$653047d99c89ec70);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $klCKg = parcelRequire("klCKg");

var $ccHMk = parcelRequire("ccHMk");
var $1qfLF = parcelRequire("1qfLF");

var $7gpC4 = parcelRequire("7gpC4");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $9hlns = parcelRequire("9hlns");

var $4JDbp = parcelRequire("4JDbp");

var $2T0BN = parcelRequire("2T0BN");

var $fmn3m = parcelRequire("fmn3m");

var $9RXAh = parcelRequire("9RXAh");

var $cjz3t = parcelRequire("cjz3t");

var $iQ2sA = parcelRequire("iQ2sA");

var $aZrok = parcelRequire("aZrok");

var $guDfp = parcelRequire("guDfp");

var $7jsiw = parcelRequire("7jsiw");

var $28Rio = parcelRequire("28Rio");

var $cYjS3 = parcelRequire("cYjS3");

var $6fw8B = parcelRequire("6fw8B");

var $hGblJ = parcelRequire("hGblJ");

var $gl38E = parcelRequire("gl38E");

var $zfg5A = parcelRequire("zfg5A");
const $a3a2e4569718778b$export$3d6dc94c3b008646 = {
    loaded: 'LOADED',
    loading: 'LOADING',
    error: 'ERROR'
};
const $a3a2e4569718778b$export$ec659152c0ce3638 = {
    inventory: 'INVENTORY',
    input: 'INPUT'
};
/**
 * CharlieTableStyles
 */ const $a3a2e4569718778b$var$ExpandableRowCellPadding = (0, $ecnYn.xcss)({
    paddingInlineStart: 'space.100'
});
const $a3a2e4569718778b$var$RowCursorPointer = (0, $ecnYn.xcss)({
    cursor: 'pointer'
});
const $a3a2e4569718778b$var$TDExtraStyle = (0, $ecnYn.xcss)({
    borderBottom: '1px solid',
    borderInlineEnd: '1px solid',
    borderColor: 'color.border'
});
const $a3a2e4569718778b$var$OverflowHiddenStyle = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $a3a2e4569718778b$var$LoadMoreWrapperStyle = (0, $ecnYn.xcss)({
    marginBlockStart: 'space.100'
});
const $a3a2e4569718778b$var$CheckboxWrapperStyle = (0, $ecnYn.xcss)({
    width: 'fit-content',
    marginInlineStart: 'space.negative.100'
});
const $a3a2e4569718778b$var$SubRowButtonWrapperStyle = (0, $ecnYn.xcss)({
    marginInlineEnd: 'space.050'
});
const $a3a2e4569718778b$var$SubRowExpandableStyle = (0, $ecnYn.xcss)({
    // @ts-expect-error - this saves us from rerendering all the cells
    position: 'var(--col-group-position)',
    left: '0',
    whiteSpace: 'nowrap',
    borderBottom: '1px solid',
    borderInlineStart: '1px solid',
    borderColor: 'color.border',
    zIndex: '1'
});
const $a3a2e4569718778b$var$LoadingTableStyle = (0, $ecnYn.xcss)({
    opacity: 0.7,
    pointerEvents: 'none'
});
const $a3a2e4569718778b$var$TableWrapperStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    height: '100%',
    overflow: 'auto',
    borderTopLeftRadius: '7px',
    borderTopRightRadius: '7px'
});
const $a3a2e4569718778b$var$FooterStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'sticky',
    left: 'space.0'
});
const $a3a2e4569718778b$var$FooterDividerStyles = (0, $ecnYn.xcss)({
    border: 'none',
    borderBottom: `2px solid ${"var(--ds-border, #091E4224)"}`,
    marginTop: 'space.250',
    width: '10%'
});
const $a3a2e4569718778b$var$LoadingOverlayStyle = (0, $ecnYn.xcss)({
    position: 'absolute',
    justifyContent: 'center',
    alignItems: 'center',
    pointerEvents: 'none',
    top: 'space.0',
    left: 'space.0',
    right: 'space.0',
    bottom: 'space.0'
});

const $a3a2e4569718778b$export$653047d99c89ec70 = ({ labels: labels = {
    sortButton: 'Column sort button',
    selectAllRows: 'Select all rows',
    selectRow: 'Select row',
    expandRow: 'Expand row',
    loadMore: 'Load more'
}, manualSorting: manualSorting = true, manualPagination: manualPagination = true, enableResizing: enableResizing = false, tableType: tableType = $a3a2e4569718778b$export$ec659152c0ce3638.input, tableState: tableState = $a3a2e4569718778b$export$3d6dc94c3b008646.loaded, rowSpacing: rowSpacing = 'default', xcssOverrides: xcssOverrides, enableKeyboardNavigation: enableKeyboardNavigation = false, ...props })=>{
    const [parentSize, setParentSize] = (0, $gwFzn.useState)(0);
    const tableRef = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useImperativeHandle)(props.refs?.tableRef, ()=>tableRef.current);
    const { tableNavigationControllers: tableNavigationControllers } = (0, $fmn3m.useKeyboardNavigation)();
    const infiniteScrollRef = (0, $2T0BN.useInfiniteScroll)({
        onScrollTo: ()=>{
            props.onLoadNext?.();
        }
    });
    const CharlieTableDndWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("1MT74")).then((module)=>({
                default: module.CharlieTableDndWrapper
            })));
    const CharlieWrapper = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useMemo(()=>{
        if (props.enableColumnReorder || enableResizing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef(({ charlieTableState: charlieTableState, tableRef: tableRef, ...props }, ref)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Suspense, {
                fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    ...props
                }),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)(CharlieTableDndWrapper, {
                    ref: ref,
                    charlieTableState: charlieTableState,
                    ...props,
                    tableRef: tableRef
                })
            }));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef(({ charlieTableState: charlieTableState, ...props }, ref)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                ref: ref,
                ...props
            }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.enableColumnReorder,
        enableResizing
    ]);
    const dummyId = 'charlie-table-reserved-checkbox';
    const oldModifiedColumns = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useMemo(()=>{
        if (props.columnDefs) return undefined;
        const dummyCheckboxOldColumn = {
            content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {}),
            key: dummyId,
            width: 44,
            minWidth: 44,
            isSortable: false,
            cell: {
                render: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {})
            }
        };
        return props.enableRowSelection ? [
            dummyCheckboxOldColumn,
            ...props.columns ?? []
        ] : props.columns;
    }, [
        props.columns,
        props.enableRowSelection,
        props.columnDefs
    ]);
    const tanModifiedColumns = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useMemo(()=>{
        if (!props.columnDefs) return undefined;
        const dummyCheckboxTanColumn = {
            header: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {}),
            id: dummyId,
            size: 44,
            minSize: 44,
            enableSorting: false,
            cell: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {})
        };
        return props.enableRowSelection ? [
            dummyCheckboxTanColumn,
            ...props.columnDefs
        ] : props.columnDefs;
    }, [
        props.columnDefs,
        props.enableRowSelection
    ]);
    const appendDummyCheckboxToList = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useCallback((list)=>props.enableRowSelection && list ? [
            dummyId,
            ...list ?? []
        ] : list, [
        props.enableRowSelection
    ]);
    const modifiedColumnOrder = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useMemo(()=>appendDummyCheckboxToList(props.state?.columnOrder), [
        appendDummyCheckboxToList,
        props.state?.columnOrder
    ]);
    const modifiedInitialColumnOrder = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useMemo(()=>appendDummyCheckboxToList(props.initialState?.columnOrder), [
        appendDummyCheckboxToList,
        props.initialState?.columnOrder
    ]);
    const modifiedColumnPinningStart = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useMemo(()=>appendDummyCheckboxToList(// @ts-expect-error ignoring anything with old charlietable
        props.state?.columnPinning?.start ?? props.state?.columnPinning?.left), [
        appendDummyCheckboxToList,
        // @ts-expect-error ignoring anything with old charlietable
        props.state?.columnPinning?.start,
        props.state?.columnPinning?.left
    ]);
    const modifiedInitialColumnPinningStart = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useMemo(()=>appendDummyCheckboxToList(// @ts-expect-error ignoring anything with old charlietable
        props.initialState?.columnPinning?.start ?? props.initialState?.columnPinning?.left), [
        appendDummyCheckboxToList,
        // @ts-expect-error ignoring anything with old charlietable
        props.initialState?.columnPinning?.start,
        props.initialState?.columnPinning?.left
    ]);
    const modifiedColumnPinning = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useMemo(()=>modifiedColumnPinningStart ? {
            ...props.state?.columnPinning,
            start: modifiedColumnPinningStart
        } : props.state?.columnPinning, [
        modifiedColumnPinningStart,
        props.state?.columnPinning
    ]);
    const modifiedInitialColumnPinning = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useMemo(()=>modifiedInitialColumnPinningStart ? {
            ...props.initialState?.columnPinning,
            start: modifiedInitialColumnPinningStart
        } : props.initialState?.columnPinning, [
        modifiedInitialColumnPinningStart,
        props.initialState?.columnPinning
    ]);
    const convertedCharles = (0, $zfg5A.useConvertCharlieTableToTanStack)({
        ...props,
        columnDefs: tanModifiedColumns,
        columns: oldModifiedColumns,
        manualPagination: manualPagination,
        manualSorting: manualSorting,
        state: {
            ...props.state,
            columnPinning: modifiedColumnPinning,
            columnOrder: modifiedColumnOrder
        },
        initialState: {
            ...props.initialState,
            columnPinning: modifiedInitialColumnPinning,
            columnOrder: modifiedInitialColumnOrder
        }
    });
    const columns = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useMemo(()=>convertedCharles.columns, [
        convertedCharles.columns
    ]);
    const data = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useMemo(()=>convertedCharles.data, [
        convertedCharles.data
    ]);
    const table = (0, $klCKg.useReactTable)({
        ...convertedCharles,
        columns: columns,
        data: data,
        autoResetExpanded: props.autoResetExpanded
    });
    const hasWidths = [
        ...Object.keys(table.getState().columnSizing ?? {})
    ].length > 0 || enableResizing;
    const totalTableWidth = table.getTotalSize();
    const columnCssVars = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useMemo(()=>{
        const cols = table.getAllLeafColumns();
        const colCss = {};
        cols.forEach((col)=>{
            const isPinned = col.getIsPinned();
            if (!isPinned || !col) return;
            const colKeyPrefix = `--col-${col.id}`;
            colCss[`${colKeyPrefix}-left`] = isPinned === 'left' ? `${col.getStart('left')}px` : undefined;
            colCss[`${colKeyPrefix}-right`] = isPinned === 'right' ? `${col.getAfter('right')}px` : undefined;
            // @ts-expect-error-next-line - none of the zIndex ADS tokens equate to 1
            colCss[`${colKeyPrefix}-zIndex`] = 1;
            colCss[`${colKeyPrefix}-position`] = 'sticky';
        });
        if (table?.getState()?.columnPinning?.left && table.getState().columnPinning.left.length > 0) colCss[`--col-group-position`] = 'sticky';
        return colCss;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        table.options.state
    ]);
    const isEmptyState = table.options.data.length === 0 && tableState === $a3a2e4569718778b$export$3d6dc94c3b008646.loaded;
    return(//normally you shouldn't do this, but was having trouble passing the generic with the lazy loaded component
    //@ts-expect-error lazy loading isses
    /*#__PURE__*/ (0, $7UHDa.jsxs)(CharlieWrapper, {
        xcss: $a3a2e4569718778b$var$TableWrapperStyle,
        ref: props.refs?.tableContainerRef,
        ...(props.enableColumnReorder || enableResizing) && {
            charlieTableState: table,
            tableRef: tableRef
        },
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4JDbp.WidthObserver), {
                setWidth: setParentSize
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $hGblJ.Table), {
                testId: props.testId,
                ref: tableRef,
                xcss: [
                    props.isLoading || tableState === $a3a2e4569718778b$export$3d6dc94c3b008646.loading ? $a3a2e4569718778b$var$LoadingTableStyle : false,
                    (0, $ecnYn.xcss)({
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- this is needed to prevent rerenders
                        ...columnCssVars,
                        borderCollapse: 'separate',
                        borderSpacing: '0px',
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                        tableLayout: hasWidths ? 'fixed' : 'auto',
                        width: '100%',
                        overflow: 'auto',
                        margin: 'space.0'
                    })
                ],
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cjz3t.Colgroup), {
                        children: table.getHeaderGroups().map((headerGroup)=>{
                            return headerGroup.headers.map((header)=>{
                                if (header?.column == null) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {});
                                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9RXAh.Col), {
                                    xcss: (0, $ecnYn.xcss)({
                                        width: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                                        (!header.column.getIsLastColumn() || parentSize && parentSize < totalTableWidth) && enableResizing ? `${header.column.getSize()}px` : undefined,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                    })
                                }, header.id);
                            });
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gl38E.THead), {
                        children: table.getHeaderGroups().map((headerGroup)=>{
                            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $guDfp.TR), {
                                children: headerGroup.headers.map((header, idx)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $7jsiw.CharlieTableHeader), {
                                        labels: labels,
                                        charlieTableColumn: header,
                                        index: idx,
                                        enableResizing: enableResizing && header.column.getCanResize(),
                                        charlieTableState: table,
                                        tableType: tableType,
                                        enableColumnReorder: props.enableColumnReorder,
                                        enableRowSelection: props.enableRowSelection,
                                        hasWidths: hasWidths,
                                        xcss: typeof xcssOverrides?.headerCell === 'function' ? xcssOverrides.headerCell(header, table.getState()) : undefined
                                    }, header.id))
                            }, headerGroup.id);
                        })
                    }),
                    (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useMemo(()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $28Rio.TBody), {
                            ref: props.refs?.tableBodyRef,
                            children: table.getRowModel().rows ? table.getRowModel().rows.map((row, index)=>{
                                return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
                                    children: [
                                        row.original?.overrideRender || row.getIsGrouped() && props.renderOptions?.groupingRow ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {
                                            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $cYjS3.Row), {
                                                spacing: rowSpacing,
                                                onClick: (e)=>{
                                                    // @ts-expect-error Prevent row click if a link was clicked
                                                    if (e.target.closest('a')) return;
                                                    props.onRowClick?.(row);
                                                },
                                                xcss: props.onRowClick && $a3a2e4569718778b$var$RowCursorPointer,
                                                children: [
                                                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aZrok.TD), {
                                                        xcss: [
                                                            $a3a2e4569718778b$var$SubRowExpandableStyle,
                                                            typeof xcssOverrides?.rowCell === 'function' ? xcssOverrides.rowCell(row.getVisibleCells()[0], table.getState()) : undefined
                                                        ],
                                                        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
                                                            alignItems: "center",
                                                            children: [
                                                                (props.renderChildComponent || props.renderOptions?.groupingRow) && row.getCanExpand() && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                                                    xcss: [
                                                                        $a3a2e4569718778b$var$SubRowButtonWrapperStyle,
                                                                        (0, $ecnYn.xcss)({
                                                                            // @ts-expect-error - needed for nested styles
                                                                            // eslint-disable-next-line @compiled/no-suppress-xcss
                                                                            paddingInlineStart: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                                                                            row.getCanExpand() ? `${(row.depth + 1) * 8}px` : `${32 + (row.depth + 1) * 8}px`
                                                                        })
                                                                    ],
                                                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                                                                        spacing: "compact",
                                                                        testId: "expand-row-button",
                                                                        appearance: "subtle",
                                                                        interactionName: props.interactionName,
                                                                        analyticsContext: {
                                                                            componentName: 'charlieTableExpandRowButton',
                                                                            ...props.analyticsContext
                                                                        },
                                                                        "aria-pressed": row.getIsExpanded(),
                                                                        label: labels.expandRow,
                                                                        icon: (iconProps)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $iQ2sA.ExpandIcon), {
                                                                                isExpanded: row.getIsExpanded() ?? false,
                                                                                ...iconProps
                                                                            }),
                                                                        onClick: (e)=>{
                                                                            e.stopPropagation();
                                                                            row.toggleExpanded();
                                                                        }
                                                                    })
                                                                }),
                                                                row.original.overrideRender && row.original.overrideRender(row.original),
                                                                props.renderOptions?.groupingRow && props.renderOptions.groupingRow(row.original, table.getState())
                                                            ]
                                                        })
                                                    }),
                                                    row.getVisibleCells().length > 1 && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aZrok.TD), {
                                                        colSpan: row.getVisibleCells().length - 1,
                                                        xcss: [
                                                            $a3a2e4569718778b$var$TDExtraStyle,
                                                            typeof xcssOverrides?.rowCell === 'function' ? xcssOverrides.rowCell(row.getVisibleCells()[1], table.getState()) : undefined
                                                        ]
                                                    })
                                                ]
                                            })
                                        }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cYjS3.Row), {
                                            spacing: rowSpacing,
                                            onClick: (e)=>{
                                                // @ts-expect-error Prevent row click if a link was clicked
                                                if (e.target.closest('a')) return;
                                                props.onRowClick?.(row);
                                            },
                                            xcss: props.onRowClick && $a3a2e4569718778b$var$RowCursorPointer,
                                            children: row.getVisibleCells().map((cell, index)=>/*#__PURE__*/ (0, $gwFzn.createElement)((0, $6fw8B.RowCell), {
                                                    tableType: tableType,
                                                    ...enableKeyboardNavigation && {
                                                        tabIndex: 0,
                                                        onKeyDown: tableNavigationControllers
                                                    },
                                                    xcss: [
                                                        $a3a2e4569718778b$var$OverflowHiddenStyle,
                                                        cell.row.getCanExpand() && (props.enableRowSelection && index === 1 || !props.enableRowSelection && index === 0) && $a3a2e4569718778b$var$ExpandableRowCellPadding,
                                                        cell.column.getIsPinned() && (0, $ecnYn.xcss)({
                                                            // @ts-expect-error - this saves us from rerendering all the cells
                                                            // eslint-disable-next-line @compiled/no-suppress-xcss, @atlaskit/ui-styling-standard/no-unsafe-values
                                                            zIndex: `var(--col-${cell.column.id}-zIndex)`,
                                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                                                            left: `var(--col-${cell.column.id}-left)`,
                                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                                                            right: `var(--col-${cell.column.id}-right)`,
                                                            // @ts-expect-error - this saves us from rerendering all the cells
                                                            // eslint-disable-next-line @compiled/no-suppress-xcss, @atlaskit/ui-styling-standard/no-unsafe-values
                                                            position: `var(--col-${cell.column.id}-position)`
                                                        }),
                                                        typeof xcssOverrides?.rowCell === 'function' ? xcssOverrides.rowCell(cell, table.getState()) : undefined
                                                    ],
                                                    key: cell.id
                                                }, index === 0 && props.enableRowSelection ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                                    xcss: $a3a2e4569718778b$var$CheckboxWrapperStyle,
                                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7gpC4.default), {
                                                        analyticsContext: {
                                                            componentName: 'charlieTableExpandRowButton',
                                                            ...props.analyticsContext
                                                        },
                                                        "aria-label": labels.selectRow,
                                                        isDisabled: !row.getCanSelect(),
                                                        isChecked: row.getIsSelected(),
                                                        onClick: (e)=>{
                                                            e.stopPropagation();
                                                            row.toggleSelected();
                                                        }
                                                    })
                                                }) : /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
                                                    alignItems: "center",
                                                    xcss: [
                                                        $a3a2e4569718778b$var$OverflowHiddenStyle,
                                                        (props.enableRowSelection && index === 1 || !props.enableRowSelection && index === 0) && !row.getParentRow()?.getIsGrouped() && (0, $ecnYn.xcss)({
                                                            //@ts-expect-error needed for logic
                                                            // eslint-disable-next-line @compiled/no-suppress-xcss
                                                            paddingInlineStart: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                                                            `${row.depth * 8}px`
                                                        })
                                                    ],
                                                    children: [
                                                        row.getCanExpand() && (props.enableRowSelection && index === 1 || !props.enableRowSelection && index === 0) && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                                            xcss: $a3a2e4569718778b$var$SubRowButtonWrapperStyle,
                                                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                                                                spacing: "compact",
                                                                testId: "expand-row-button",
                                                                interactionName: props.interactionName,
                                                                analyticsContext: {
                                                                    componentName: 'charlieTableExpandRowButton',
                                                                    ...props.analyticsContext
                                                                },
                                                                appearance: "subtle",
                                                                "aria-pressed": row.getIsExpanded(),
                                                                label: labels.expandRow,
                                                                icon: (iconProps)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $iQ2sA.ExpandIcon), {
                                                                        isExpanded: row.getIsExpanded() ?? false,
                                                                        ...iconProps
                                                                    }),
                                                                onClick: (e)=>{
                                                                    e.stopPropagation();
                                                                    row.toggleExpanded();
                                                                }
                                                            })
                                                        }),
                                                        (0, $klCKg.flexRender)(cell.column.columnDef.cell, cell.getContext())
                                                    ]
                                                })))
                                        }, row.id),
                                        row.getIsExpanded() && props.renderChildComponent && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {
                                            children: props?.renderChildComponent({
                                                rowData: row,
                                                tableState: table.getState()
                                            })
                                        }),
                                        props.hasNext && //we pagination with child components is not supported yet
                                        !props.renderChildComponent && index === Math.floor((table.getRowModel().rows?.length ?? 0) * 0.92) && // if user is 92% through the table, load more rows
                                        /*#__PURE__*/ (0, $7UHDa.jsx)("tr", {
                                            ref: infiniteScrollRef
                                        }, 'loadMoreTrigger')
                                    ]
                                }, row.id);
                            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {})
                        }), // eslint-disable-next-line react-hooks/exhaustive-deps
                    [
                        rowSpacing,
                        table.options.state.rowSelection,
                        table.options.state.sorting,
                        table.options.state.expanded,
                        table.options.state.columnOrder,
                        table.options.state.grouping,
                        table.options.state.columnVisibility,
                        table.options.data
                    ])
                ]
            }),
            (props.hasNext != null && props.onLoadNext != null || props.isLoading != null) && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
                xcss: $a3a2e4569718778b$var$FooterStyles,
                children: props.hasNext && props.onLoadNext ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $a3a2e4569718778b$var$LoadMoreWrapperStyle,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                        testId: "prev-page-test-id",
                        isLoading: props.isLoading || tableState === $a3a2e4569718778b$export$3d6dc94c3b008646.loading,
                        onClick: ()=>{
                            props.onLoadNext?.();
                        },
                        spacing: "compact",
                        children: labels.loadMore
                    })
                }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {
                    children: !(isEmptyState || tableState === $a3a2e4569718778b$export$3d6dc94c3b008646.error || props.hidePaginationEndIndicator) && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        as: "hr",
                        testId: "table-footer-divider",
                        xcss: $a3a2e4569718778b$var$FooterDividerStyles,
                        role: "presentation"
                    })
                })
            }),
            (props.isLoading || tableState === $a3a2e4569718778b$export$3d6dc94c3b008646.loading) && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bUlM5.default), {
                xcss: $a3a2e4569718778b$var$LoadingOverlayStyle,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9hlns.default), {
                    size: "large",
                    testId: "common-table-spinner"
                })
            }),
            tableState === $a3a2e4569718778b$export$3d6dc94c3b008646.error && props.errorView,
            isEmptyState && props.emptyTableView
        ]
    }));
};

});
parcelRegister("klCKg", function(module, exports) {
$parcel$export(module.exports, "createColumnHelper", () => (parcelRequire("cBPBN")).createColumnHelper);
$parcel$export(module.exports, "createRow", () => (parcelRequire("cBPBN")).createRow);
$parcel$export(module.exports, "createTable", () => (parcelRequire("cBPBN")).createTable);
$parcel$export(module.exports, "flattenBy", () => (parcelRequire("cBPBN")).flattenBy);
$parcel$export(module.exports, "functionalUpdate", () => (parcelRequire("cBPBN")).functionalUpdate);
$parcel$export(module.exports, "getCoreRowModel", () => (parcelRequire("cBPBN")).getCoreRowModel);
$parcel$export(module.exports, "getExpandedRowModel", () => (parcelRequire("cBPBN")).getExpandedRowModel);
$parcel$export(module.exports, "getGroupedRowModel", () => (parcelRequire("cBPBN")).getGroupedRowModel);
$parcel$export(module.exports, "getMemoOptions", () => (parcelRequire("cBPBN")).getMemoOptions);
$parcel$export(module.exports, "getSortedRowModel", () => (parcelRequire("cBPBN")).getSortedRowModel);
$parcel$export(module.exports, "memo", () => (parcelRequire("cBPBN")).memo);

$parcel$export(module.exports, "flexRender", () => $ed03d2ca7555324e$export$f2385bb6e3ac4b4f);
$parcel$export(module.exports, "useReactTable", () => $ed03d2ca7555324e$export$25eaeb3743e6b31f);
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */ 
var $gwFzn = parcelRequire("gwFzn");

var $cBPBN = parcelRequire("cBPBN");
//
/**
 * If rendering headers, cells, or footers with custom markup, use flexRender instead of `cell.getValue()` or `cell.renderValue()`.
 */ function $ed03d2ca7555324e$export$f2385bb6e3ac4b4f(Comp, props) {
    return !Comp ? null : $ed03d2ca7555324e$var$isReactComponent(Comp) ? /*#__PURE__*/ $gwFzn.createElement(Comp, props) : Comp;
}
function $ed03d2ca7555324e$var$isReactComponent(component) {
    return $ed03d2ca7555324e$var$isClassComponent(component) || typeof component === 'function' || $ed03d2ca7555324e$var$isExoticComponent(component);
}
function $ed03d2ca7555324e$var$isClassComponent(component) {
    return typeof component === 'function' && (()=>{
        const proto = Object.getPrototypeOf(component);
        return proto.prototype && proto.prototype.isReactComponent;
    })();
}
function $ed03d2ca7555324e$var$isExoticComponent(component) {
    return typeof component === 'object' && typeof component.$$typeof === 'symbol' && [
        'react.memo',
        'react.forward_ref'
    ].includes(component.$$typeof.description);
}
function $ed03d2ca7555324e$export$25eaeb3743e6b31f(options) {
    // Compose in the generic options to the user options
    const resolvedOptions = {
        state: {},
        // Dummy state
        onStateChange: ()=>{},
        // noop
        renderFallbackValue: null,
        ...options
    };
    // Create a new table and store it in state
    const [tableRef] = $gwFzn.useState(()=>({
            current: (0, $cBPBN.createTable)(resolvedOptions)
        }));
    // By default, manage table state here using the table's initial state
    const [state, setState] = $gwFzn.useState(()=>tableRef.current.initialState);
    // Compose the default state above with any user state. This will allow the user
    // to only control a subset of the state if desired.
    tableRef.current.setOptions((prev)=>({
            ...prev,
            ...options,
            state: {
                ...state,
                ...options.state
            },
            // Similarly, we'll maintain both our internal state and any user-provided
            // state.
            onStateChange: (updater)=>{
                setState(updater);
                options.onStateChange == null || options.onStateChange(updater);
            }
        }));
    return tableRef.current;
}

});
parcelRegister("cBPBN", function(module, exports) {

$parcel$export(module.exports, "createColumnHelper", () => $92e0f91f0be7afe0$export$4b44a5cb9651fe5e);
$parcel$export(module.exports, "functionalUpdate", () => $92e0f91f0be7afe0$export$7f095f455ad5af3f);
$parcel$export(module.exports, "flattenBy", () => $92e0f91f0be7afe0$export$bf4548421d1b2c8);
$parcel$export(module.exports, "memo", () => $92e0f91f0be7afe0$export$7c73462e0d25e514);
$parcel$export(module.exports, "getMemoOptions", () => $92e0f91f0be7afe0$export$b1f82222dc43996c);
$parcel$export(module.exports, "createRow", () => $92e0f91f0be7afe0$export$3442c5d213434705);
$parcel$export(module.exports, "createTable", () => $92e0f91f0be7afe0$export$33bbb3ec7652e187);
$parcel$export(module.exports, "getCoreRowModel", () => $92e0f91f0be7afe0$export$32d0bc001e828250);
$parcel$export(module.exports, "getExpandedRowModel", () => $92e0f91f0be7afe0$export$53cfec7b1b8d1fcd);
$parcel$export(module.exports, "getGroupedRowModel", () => $92e0f91f0be7afe0$export$2b7f4b57ce71b81);
$parcel$export(module.exports, "getSortedRowModel", () => $92e0f91f0be7afe0$export$4ca93ca80835d8c1);
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */ // type Person = {
//   firstName: string
//   lastName: string
//   age: number
//   visits: number
//   status: string
//   progress: number
//   createdAt: Date
//   nested: {
//     foo: [
//       {
//         bar: 'bar'
//       }
//     ]
//     bar: { subBar: boolean }[]
//     baz: {
//       foo: 'foo'
//       bar: {
//         baz: 'baz'
//       }
//     }
//   }
// }
// const test: DeepKeys<Person> = 'nested.foo.0.bar'
// const test2: DeepKeys<Person> = 'nested.bar'
// const helper = createColumnHelper<Person>()
// helper.accessor('nested.foo', {
//   cell: info => info.getValue(),
// })
// helper.accessor('nested.foo.0.bar', {
//   cell: info => info.getValue(),
// })
// helper.accessor('nested.bar', {
//   cell: info => info.getValue(),
// })
function $92e0f91f0be7afe0$export$4b44a5cb9651fe5e() {
    return {
        accessor: (accessor, column)=>{
            return typeof accessor === 'function' ? {
                ...column,
                accessorFn: accessor
            } : {
                ...column,
                accessorKey: accessor
            };
        },
        display: (column)=>column,
        group: (column)=>column
    };
}
// Is this type a tuple?
// If this type is a tuple, what indices are allowed?
///
function $92e0f91f0be7afe0$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === 'function' ? updater(input) : updater;
}
function $92e0f91f0be7afe0$export$8793edee2d425525() {
//
}
function $92e0f91f0be7afe0$export$2b5605d8069324bd(key, instance) {
    return (updater)=>{
        instance.setState((old)=>{
            return {
                ...old,
                [key]: $92e0f91f0be7afe0$export$7f095f455ad5af3f(updater, old[key])
            };
        });
    };
}
function $92e0f91f0be7afe0$export$f6e2535fb5126e54(d) {
    return d instanceof Function;
}
function $92e0f91f0be7afe0$export$5cd576d1827d40c8(d) {
    return Array.isArray(d) && d.every((val)=>typeof val === 'number');
}
function $92e0f91f0be7afe0$export$bf4548421d1b2c8(arr, getChildren) {
    const flat = [];
    const recurse = (subArr)=>{
        subArr.forEach((item)=>{
            flat.push(item);
            const children = getChildren(item);
            if (children != null && children.length) recurse(children);
        });
    };
    recurse(arr);
    return flat;
}
function $92e0f91f0be7afe0$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = [];
    let result;
    return (depArgs)=>{
        let depTime;
        if (opts.key && opts.debug) depTime = Date.now();
        const newDeps = getDeps(depArgs);
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && opts.debug) resultTime = Date.now();
        result = fn(...newDeps);
        opts == null || opts.onChange == null || opts.onChange(result);
        if (opts.key && opts.debug) {
            if (opts != null && opts.debug()) {
                const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
                const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
                const resultFpsPercentage = resultEndTime / 16;
                const pad = (str, num)=>{
                    str = String(str);
                    while(str.length < num)str = ' ' + str;
                    return str;
                };
                console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
            }
        }
        return result;
    };
}
function $92e0f91f0be7afe0$export$b1f82222dc43996c(tableOptions, debugLevel, key, onChange) {
    return {
        debug: ()=>{
            var _tableOptions$debugAl;
            return (_tableOptions$debugAl = tableOptions == null ? void 0 : tableOptions.debugAll) != null ? _tableOptions$debugAl : tableOptions[debugLevel];
        },
        key: false,
        onChange: onChange
    };
}
function $92e0f91f0be7afe0$export$3cb21b6b1233300e(table, row, column, columnId) {
    const getRenderValue = ()=>{
        var _cell$getValue;
        return (_cell$getValue = cell.getValue()) != null ? _cell$getValue : table.options.renderFallbackValue;
    };
    const cell = {
        id: `${row.id}_${column.id}`,
        row: row,
        column: column,
        getValue: ()=>row.getValue(columnId),
        renderValue: getRenderValue,
        getContext: $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table,
                column,
                row,
                cell
            ], (table, column, row, cell)=>({
                table: table,
                column: column,
                row: row,
                cell: cell,
                getValue: cell.getValue,
                renderValue: cell.renderValue
            }), $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugCells', 'cell.getContext'))
    };
    table._features.forEach((feature)=>{
        feature.createCell == null || feature.createCell(cell, column, row, table);
    }, {});
    return cell;
}
function $92e0f91f0be7afe0$export$1bfa986e9c92c0b5(table, columnDef, depth, parent) {
    var _ref, _resolvedColumnDef$id;
    const defaultColumn = table._getDefaultColumnDef();
    const resolvedColumnDef = {
        ...defaultColumn,
        ...columnDef
    };
    const accessorKey = resolvedColumnDef.accessorKey;
    let id = (_ref = (_resolvedColumnDef$id = resolvedColumnDef.id) != null ? _resolvedColumnDef$id : accessorKey ? typeof String.prototype.replaceAll === 'function' ? accessorKey.replaceAll('.', '_') : accessorKey.replace(/\./g, '_') : undefined) != null ? _ref : typeof resolvedColumnDef.header === 'string' ? resolvedColumnDef.header : undefined;
    let accessorFn;
    if (resolvedColumnDef.accessorFn) accessorFn = resolvedColumnDef.accessorFn;
    else if (accessorKey) {
        // Support deep accessor keys
        if (accessorKey.includes('.')) accessorFn = (originalRow)=>{
            let result = originalRow;
            for (const key of accessorKey.split('.')){
                var _result;
                result = (_result = result) == null ? void 0 : _result[key];
            }
            return result;
        };
        else accessorFn = (originalRow)=>originalRow[resolvedColumnDef.accessorKey];
    }
    if (!id) throw new Error();
    let column = {
        id: `${String(id)}`,
        accessorFn: accessorFn,
        parent: parent,
        depth: depth,
        columnDef: resolvedColumnDef,
        columns: [],
        getFlatColumns: $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                true
            ], ()=>{
            var _column$columns;
            return [
                column,
                ...(_column$columns = column.columns) == null ? void 0 : _column$columns.flatMap((d)=>d.getFlatColumns())
            ];
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugColumns', 'column.getFlatColumns')),
        getLeafColumns: $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table._getOrderColumnsFn()
            ], (orderColumns)=>{
            var _column$columns2;
            if ((_column$columns2 = column.columns) != null && _column$columns2.length) {
                let leafColumns = column.columns.flatMap((column)=>column.getLeafColumns());
                return orderColumns(leafColumns);
            }
            return [
                column
            ];
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugColumns', 'column.getLeafColumns'))
    };
    for (const feature of table._features)feature.createColumn == null || feature.createColumn(column, table);
    // Yes, we have to convert table to unknown, because we know more than the compiler here.
    return column;
}
const $92e0f91f0be7afe0$var$debug = 'debugHeaders';
//
function $92e0f91f0be7afe0$var$createHeader(table, column, options) {
    var _options$id;
    const id = (_options$id = options.id) != null ? _options$id : column.id;
    let header = {
        id: id,
        column: column,
        index: options.index,
        isPlaceholder: !!options.isPlaceholder,
        placeholderId: options.placeholderId,
        depth: options.depth,
        subHeaders: [],
        colSpan: 0,
        rowSpan: 0,
        headerGroup: null,
        getLeafHeaders: ()=>{
            const leafHeaders = [];
            const recurseHeader = (h)=>{
                if (h.subHeaders && h.subHeaders.length) h.subHeaders.map(recurseHeader);
                leafHeaders.push(h);
            };
            recurseHeader(header);
            return leafHeaders;
        },
        getContext: ()=>({
                table: table,
                header: header,
                column: column
            })
    };
    table._features.forEach((feature)=>{
        feature.createHeader == null || feature.createHeader(header, table);
    });
    return header;
}
const $92e0f91f0be7afe0$export$79b704688b15c0f4 = {
    createTable: (table)=>{
        // Header Groups
        table.getHeaderGroups = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, left, right)=>{
            var _left$map$filter, _right$map$filter;
            const leftColumns = (_left$map$filter = left == null ? void 0 : left.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _left$map$filter : [];
            const rightColumns = (_right$map$filter = right == null ? void 0 : right.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _right$map$filter : [];
            const centerColumns = leafColumns.filter((column)=>!(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
            const headerGroups = $92e0f91f0be7afe0$export$d8c3a8af36458fc3(allColumns, [
                ...leftColumns,
                ...centerColumns,
                ...rightColumns
            ], table);
            return headerGroups;
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, $92e0f91f0be7afe0$var$debug, 'getHeaderGroups'));
        table.getCenterHeaderGroups = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, left, right)=>{
            leafColumns = leafColumns.filter((column)=>!(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
            return $92e0f91f0be7afe0$export$d8c3a8af36458fc3(allColumns, leafColumns, table, 'center');
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, $92e0f91f0be7afe0$var$debug, 'getCenterHeaderGroups'));
        table.getLeftHeaderGroups = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left
            ], (allColumns, leafColumns, left)=>{
            var _left$map$filter2;
            const orderedLeafColumns = (_left$map$filter2 = left == null ? void 0 : left.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _left$map$filter2 : [];
            return $92e0f91f0be7afe0$export$d8c3a8af36458fc3(allColumns, orderedLeafColumns, table, 'left');
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, $92e0f91f0be7afe0$var$debug, 'getLeftHeaderGroups'));
        table.getRightHeaderGroups = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, right)=>{
            var _right$map$filter2;
            const orderedLeafColumns = (_right$map$filter2 = right == null ? void 0 : right.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _right$map$filter2 : [];
            return $92e0f91f0be7afe0$export$d8c3a8af36458fc3(allColumns, orderedLeafColumns, table, 'right');
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, $92e0f91f0be7afe0$var$debug, 'getRightHeaderGroups'));
        // Footer Groups
        table.getFooterGroups = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, $92e0f91f0be7afe0$var$debug, 'getFooterGroups'));
        table.getLeftFooterGroups = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getLeftHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, $92e0f91f0be7afe0$var$debug, 'getLeftFooterGroups'));
        table.getCenterFooterGroups = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getCenterHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, $92e0f91f0be7afe0$var$debug, 'getCenterFooterGroups'));
        table.getRightFooterGroups = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getRightHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, $92e0f91f0be7afe0$var$debug, 'getRightFooterGroups'));
        // Flat Headers
        table.getFlatHeaders = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getHeaderGroups()
            ], (headerGroups)=>{
            return headerGroups.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, $92e0f91f0be7afe0$var$debug, 'getFlatHeaders'));
        table.getLeftFlatHeaders = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getLeftHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, $92e0f91f0be7afe0$var$debug, 'getLeftFlatHeaders'));
        table.getCenterFlatHeaders = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getCenterHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, $92e0f91f0be7afe0$var$debug, 'getCenterFlatHeaders'));
        table.getRightFlatHeaders = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getRightHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, $92e0f91f0be7afe0$var$debug, 'getRightFlatHeaders'));
        // Leaf Headers
        table.getCenterLeafHeaders = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getCenterFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders;
                return !((_header$subHeaders = header.subHeaders) != null && _header$subHeaders.length);
            });
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, $92e0f91f0be7afe0$var$debug, 'getCenterLeafHeaders'));
        table.getLeftLeafHeaders = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getLeftFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders2;
                return !((_header$subHeaders2 = header.subHeaders) != null && _header$subHeaders2.length);
            });
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, $92e0f91f0be7afe0$var$debug, 'getLeftLeafHeaders'));
        table.getRightLeafHeaders = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getRightFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders3;
                return !((_header$subHeaders3 = header.subHeaders) != null && _header$subHeaders3.length);
            });
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, $92e0f91f0be7afe0$var$debug, 'getRightLeafHeaders'));
        table.getLeafHeaders = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getLeftHeaderGroups(),
                table.getCenterHeaderGroups(),
                table.getRightHeaderGroups()
            ], (left, center, right)=>{
            var _left$0$headers, _left$, _center$0$headers, _center$, _right$0$headers, _right$;
            return [
                ...(_left$0$headers = (_left$ = left[0]) == null ? void 0 : _left$.headers) != null ? _left$0$headers : [],
                ...(_center$0$headers = (_center$ = center[0]) == null ? void 0 : _center$.headers) != null ? _center$0$headers : [],
                ...(_right$0$headers = (_right$ = right[0]) == null ? void 0 : _right$.headers) != null ? _right$0$headers : []
            ].map((header)=>{
                return header.getLeafHeaders();
            }).flat();
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, $92e0f91f0be7afe0$var$debug, 'getLeafHeaders'));
    }
};
function $92e0f91f0be7afe0$export$d8c3a8af36458fc3(allColumns, columnsToGroup, table, headerFamily) {
    var _headerGroups$0$heade, _headerGroups$;
    // Find the max depth of the columns:
    // build the leaf column row
    // build each buffer row going up
    //    placeholder for non-existent level
    //    real column for existing level
    let maxDepth = 0;
    const findMaxDepth = function(columns, depth) {
        if (depth === void 0) depth = 1;
        maxDepth = Math.max(maxDepth, depth);
        columns.filter((column)=>column.getIsVisible()).forEach((column)=>{
            var _column$columns;
            if ((_column$columns = column.columns) != null && _column$columns.length) findMaxDepth(column.columns, depth + 1);
        }, 0);
    };
    findMaxDepth(allColumns);
    let headerGroups = [];
    const createHeaderGroup = (headersToGroup, depth)=>{
        // The header group we are creating
        const headerGroup = {
            depth: depth,
            id: [
                headerFamily,
                `${depth}`
            ].filter(Boolean).join('_'),
            headers: []
        };
        // The parent columns we're going to scan next
        const pendingParentHeaders = [];
        // Scan each column for parents
        headersToGroup.forEach((headerToGroup)=>{
            // What is the latest (last) parent column?
            const latestPendingParentHeader = [
                ...pendingParentHeaders
            ].reverse()[0];
            const isLeafHeader = headerToGroup.column.depth === headerGroup.depth;
            let column;
            let isPlaceholder = false;
            if (isLeafHeader && headerToGroup.column.parent) // The parent header is new
            column = headerToGroup.column.parent;
            else {
                // The parent header is repeated
                column = headerToGroup.column;
                isPlaceholder = true;
            }
            if (latestPendingParentHeader && (latestPendingParentHeader == null ? void 0 : latestPendingParentHeader.column) === column) // This column is repeated. Add it as a sub header to the next batch
            latestPendingParentHeader.subHeaders.push(headerToGroup);
            else {
                // This is a new header. Let's create it
                const header = $92e0f91f0be7afe0$var$createHeader(table, column, {
                    id: [
                        headerFamily,
                        depth,
                        column.id,
                        headerToGroup == null ? void 0 : headerToGroup.id
                    ].filter(Boolean).join('_'),
                    isPlaceholder: isPlaceholder,
                    placeholderId: isPlaceholder ? `${pendingParentHeaders.filter((d)=>d.column === column).length}` : undefined,
                    depth: depth,
                    index: pendingParentHeaders.length
                });
                // Add the headerToGroup as a subHeader of the new header
                header.subHeaders.push(headerToGroup);
                // Add the new header to the pendingParentHeaders to get grouped
                // in the next batch
                pendingParentHeaders.push(header);
            }
            headerGroup.headers.push(headerToGroup);
            headerToGroup.headerGroup = headerGroup;
        });
        headerGroups.push(headerGroup);
        if (depth > 0) createHeaderGroup(pendingParentHeaders, depth - 1);
    };
    const bottomHeaders = columnsToGroup.map((column, index)=>$92e0f91f0be7afe0$var$createHeader(table, column, {
            depth: maxDepth,
            index: index
        }));
    createHeaderGroup(bottomHeaders, maxDepth - 1);
    headerGroups.reverse();
    // headerGroups = headerGroups.filter(headerGroup => {
    //   return !headerGroup.headers.every(header => header.isPlaceholder)
    // })
    const recurseHeadersForSpans = (headers)=>{
        const filteredHeaders = headers.filter((header)=>header.column.getIsVisible());
        return filteredHeaders.map((header)=>{
            let colSpan = 0;
            let rowSpan = 0;
            let childRowSpans = [
                0
            ];
            if (header.subHeaders && header.subHeaders.length) {
                childRowSpans = [];
                recurseHeadersForSpans(header.subHeaders).forEach((_ref)=>{
                    let { colSpan: childColSpan, rowSpan: childRowSpan } = _ref;
                    colSpan += childColSpan;
                    childRowSpans.push(childRowSpan);
                });
            } else colSpan = 1;
            const minChildRowSpan = Math.min(...childRowSpans);
            rowSpan = rowSpan + minChildRowSpan;
            header.colSpan = colSpan;
            header.rowSpan = rowSpan;
            return {
                colSpan: colSpan,
                rowSpan: rowSpan
            };
        });
    };
    recurseHeadersForSpans((_headerGroups$0$heade = (_headerGroups$ = headerGroups[0]) == null ? void 0 : _headerGroups$.headers) != null ? _headerGroups$0$heade : []);
    return headerGroups;
}
const $92e0f91f0be7afe0$export$3442c5d213434705 = (table, id, original, rowIndex, depth, subRows, parentId)=>{
    let row = {
        id: id,
        index: rowIndex,
        original: original,
        depth: depth,
        parentId: parentId,
        _valuesCache: {},
        _uniqueValuesCache: {},
        getValue: (columnId)=>{
            if (row._valuesCache.hasOwnProperty(columnId)) return row._valuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.accessorFn)) return undefined;
            row._valuesCache[columnId] = column.accessorFn(row.original, rowIndex);
            return row._valuesCache[columnId];
        },
        getUniqueValues: (columnId)=>{
            if (row._uniqueValuesCache.hasOwnProperty(columnId)) return row._uniqueValuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.accessorFn)) return undefined;
            if (!column.columnDef.getUniqueValues) {
                row._uniqueValuesCache[columnId] = [
                    row.getValue(columnId)
                ];
                return row._uniqueValuesCache[columnId];
            }
            row._uniqueValuesCache[columnId] = column.columnDef.getUniqueValues(row.original, rowIndex);
            return row._uniqueValuesCache[columnId];
        },
        renderValue: (columnId)=>{
            var _row$getValue;
            return (_row$getValue = row.getValue(columnId)) != null ? _row$getValue : table.options.renderFallbackValue;
        },
        subRows: subRows != null ? subRows : [],
        getLeafRows: ()=>$92e0f91f0be7afe0$export$bf4548421d1b2c8(row.subRows, (d)=>d.subRows),
        getParentRow: ()=>row.parentId ? table.getRow(row.parentId, true) : undefined,
        getParentRows: ()=>{
            let parentRows = [];
            let currentRow = row;
            while(true){
                const parentRow = currentRow.getParentRow();
                if (!parentRow) break;
                parentRows.push(parentRow);
                currentRow = parentRow;
            }
            return parentRows.reverse();
        },
        getAllCells: $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns()
            ], (leafColumns)=>{
            return leafColumns.map((column)=>{
                return $92e0f91f0be7afe0$export$3cb21b6b1233300e(table, row, column, column.id);
            });
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugRows', 'getAllCells')),
        _getAllCellsByColumnId: $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                row.getAllCells()
            ], (allCells)=>{
            return allCells.reduce((acc, cell)=>{
                acc[cell.column.id] = cell;
                return acc;
            }, {});
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugRows', 'getAllCellsByColumnId'))
    };
    for(let i = 0; i < table._features.length; i++){
        const feature = table._features[i];
        feature == null || feature.createRow == null || feature.createRow(row, table);
    }
    return row;
};
//
const $92e0f91f0be7afe0$export$1f746e6a9cd841b1 = {
    createColumn: (column, table)=>{
        column._getFacetedRowModel = table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, column.id);
        column.getFacetedRowModel = ()=>{
            if (!column._getFacetedRowModel) return table.getPreFilteredRowModel();
            return column._getFacetedRowModel();
        };
        column._getFacetedUniqueValues = table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, column.id);
        column.getFacetedUniqueValues = ()=>{
            if (!column._getFacetedUniqueValues) return new Map();
            return column._getFacetedUniqueValues();
        };
        column._getFacetedMinMaxValues = table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, column.id);
        column.getFacetedMinMaxValues = ()=>{
            if (!column._getFacetedMinMaxValues) return undefined;
            return column._getFacetedMinMaxValues();
        };
    }
};
const $92e0f91f0be7afe0$var$includesString = (row, columnId, filterValue)=>{
    var _filterValue$toString, _row$getValue;
    const search = filterValue == null || (_filterValue$toString = filterValue.toString()) == null ? void 0 : _filterValue$toString.toLowerCase();
    return Boolean((_row$getValue = row.getValue(columnId)) == null || (_row$getValue = _row$getValue.toString()) == null || (_row$getValue = _row$getValue.toLowerCase()) == null ? void 0 : _row$getValue.includes(search));
};
$92e0f91f0be7afe0$var$includesString.autoRemove = (val)=>$92e0f91f0be7afe0$var$testFalsey(val);
const $92e0f91f0be7afe0$var$includesStringSensitive = (row, columnId, filterValue)=>{
    var _row$getValue2;
    return Boolean((_row$getValue2 = row.getValue(columnId)) == null || (_row$getValue2 = _row$getValue2.toString()) == null ? void 0 : _row$getValue2.includes(filterValue));
};
$92e0f91f0be7afe0$var$includesStringSensitive.autoRemove = (val)=>$92e0f91f0be7afe0$var$testFalsey(val);
const $92e0f91f0be7afe0$var$equalsString = (row, columnId, filterValue)=>{
    var _row$getValue3;
    return ((_row$getValue3 = row.getValue(columnId)) == null || (_row$getValue3 = _row$getValue3.toString()) == null ? void 0 : _row$getValue3.toLowerCase()) === (filterValue == null ? void 0 : filterValue.toLowerCase());
};
$92e0f91f0be7afe0$var$equalsString.autoRemove = (val)=>$92e0f91f0be7afe0$var$testFalsey(val);
const $92e0f91f0be7afe0$var$arrIncludes = (row, columnId, filterValue)=>{
    var _row$getValue4;
    return (_row$getValue4 = row.getValue(columnId)) == null ? void 0 : _row$getValue4.includes(filterValue);
};
$92e0f91f0be7afe0$var$arrIncludes.autoRemove = (val)=>$92e0f91f0be7afe0$var$testFalsey(val);
const $92e0f91f0be7afe0$var$arrIncludesAll = (row, columnId, filterValue)=>{
    return !filterValue.some((val)=>{
        var _row$getValue5;
        return !((_row$getValue5 = row.getValue(columnId)) != null && _row$getValue5.includes(val));
    });
};
$92e0f91f0be7afe0$var$arrIncludesAll.autoRemove = (val)=>$92e0f91f0be7afe0$var$testFalsey(val) || !(val != null && val.length);
const $92e0f91f0be7afe0$var$arrIncludesSome = (row, columnId, filterValue)=>{
    return filterValue.some((val)=>{
        var _row$getValue6;
        return (_row$getValue6 = row.getValue(columnId)) == null ? void 0 : _row$getValue6.includes(val);
    });
};
$92e0f91f0be7afe0$var$arrIncludesSome.autoRemove = (val)=>$92e0f91f0be7afe0$var$testFalsey(val) || !(val != null && val.length);
const $92e0f91f0be7afe0$var$equals = (row, columnId, filterValue)=>{
    return row.getValue(columnId) === filterValue;
};
$92e0f91f0be7afe0$var$equals.autoRemove = (val)=>$92e0f91f0be7afe0$var$testFalsey(val);
const $92e0f91f0be7afe0$var$weakEquals = (row, columnId, filterValue)=>{
    return row.getValue(columnId) == filterValue;
};
$92e0f91f0be7afe0$var$weakEquals.autoRemove = (val)=>$92e0f91f0be7afe0$var$testFalsey(val);
const $92e0f91f0be7afe0$var$inNumberRange = (row, columnId, filterValue)=>{
    let [min, max] = filterValue;
    const rowValue = row.getValue(columnId);
    return rowValue >= min && rowValue <= max;
};
$92e0f91f0be7afe0$var$inNumberRange.resolveFilterValue = (val)=>{
    let [unsafeMin, unsafeMax] = val;
    let parsedMin = typeof unsafeMin !== 'number' ? parseFloat(unsafeMin) : unsafeMin;
    let parsedMax = typeof unsafeMax !== 'number' ? parseFloat(unsafeMax) : unsafeMax;
    let min = unsafeMin === null || Number.isNaN(parsedMin) ? -Infinity : parsedMin;
    let max = unsafeMax === null || Number.isNaN(parsedMax) ? Infinity : parsedMax;
    if (min > max) {
        const temp = min;
        min = max;
        max = temp;
    }
    return [
        min,
        max
    ];
};
$92e0f91f0be7afe0$var$inNumberRange.autoRemove = (val)=>$92e0f91f0be7afe0$var$testFalsey(val) || $92e0f91f0be7afe0$var$testFalsey(val[0]) && $92e0f91f0be7afe0$var$testFalsey(val[1]);
// Export
const $92e0f91f0be7afe0$export$6ad8312e296ec316 = {
    includesString: $92e0f91f0be7afe0$var$includesString,
    includesStringSensitive: $92e0f91f0be7afe0$var$includesStringSensitive,
    equalsString: $92e0f91f0be7afe0$var$equalsString,
    arrIncludes: $92e0f91f0be7afe0$var$arrIncludes,
    arrIncludesAll: $92e0f91f0be7afe0$var$arrIncludesAll,
    arrIncludesSome: $92e0f91f0be7afe0$var$arrIncludesSome,
    equals: $92e0f91f0be7afe0$var$equals,
    weakEquals: $92e0f91f0be7afe0$var$weakEquals,
    inNumberRange: $92e0f91f0be7afe0$var$inNumberRange
};
// Utils
function $92e0f91f0be7afe0$var$testFalsey(val) {
    return val === undefined || val === null || val === '';
}
//
const $92e0f91f0be7afe0$export$f1d67534a0c5e9d3 = {
    getDefaultColumnDef: ()=>{
        return {
            filterFn: 'auto'
        };
    },
    getInitialState: (state)=>{
        return {
            columnFilters: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnFiltersChange: $92e0f91f0be7afe0$export$2b5605d8069324bd('columnFilters', table),
            filterFromLeafRows: false,
            maxLeafRowFilterDepth: 100
        };
    },
    createColumn: (column, table)=>{
        column.getAutoFilterFn = ()=>{
            const firstRow = table.getCoreRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === 'string') return $92e0f91f0be7afe0$export$6ad8312e296ec316.includesString;
            if (typeof value === 'number') return $92e0f91f0be7afe0$export$6ad8312e296ec316.inNumberRange;
            if (typeof value === 'boolean') return $92e0f91f0be7afe0$export$6ad8312e296ec316.equals;
            if (value !== null && typeof value === 'object') return $92e0f91f0be7afe0$export$6ad8312e296ec316.equals;
            if (Array.isArray(value)) return $92e0f91f0be7afe0$export$6ad8312e296ec316.arrIncludes;
            return $92e0f91f0be7afe0$export$6ad8312e296ec316.weakEquals;
        };
        column.getFilterFn = ()=>{
            var _table$options$filter, _table$options$filter2;
            return $92e0f91f0be7afe0$export$f6e2535fb5126e54(column.columnDef.filterFn) ? column.columnDef.filterFn : column.columnDef.filterFn === 'auto' ? column.getAutoFilterFn() : (_table$options$filter = (_table$options$filter2 = table.options.filterFns) == null ? void 0 : _table$options$filter2[column.columnDef.filterFn]) != null ? _table$options$filter : $92e0f91f0be7afe0$export$6ad8312e296ec316[column.columnDef.filterFn];
        };
        column.getCanFilter = ()=>{
            var _column$columnDef$ena, _table$options$enable, _table$options$enable2;
            return ((_column$columnDef$ena = column.columnDef.enableColumnFilter) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnFilters) != null ? _table$options$enable : true) && ((_table$options$enable2 = table.options.enableFilters) != null ? _table$options$enable2 : true) && !!column.accessorFn;
        };
        column.getIsFiltered = ()=>column.getFilterIndex() > -1;
        column.getFilterValue = ()=>{
            var _table$getState$colum;
            return (_table$getState$colum = table.getState().columnFilters) == null || (_table$getState$colum = _table$getState$colum.find((d)=>d.id === column.id)) == null ? void 0 : _table$getState$colum.value;
        };
        column.getFilterIndex = ()=>{
            var _table$getState$colum2, _table$getState$colum3;
            return (_table$getState$colum2 = (_table$getState$colum3 = table.getState().columnFilters) == null ? void 0 : _table$getState$colum3.findIndex((d)=>d.id === column.id)) != null ? _table$getState$colum2 : -1;
        };
        column.setFilterValue = (value)=>{
            table.setColumnFilters((old)=>{
                const filterFn = column.getFilterFn();
                const previousFilter = old == null ? void 0 : old.find((d)=>d.id === column.id);
                const newFilter = $92e0f91f0be7afe0$export$7f095f455ad5af3f(value, previousFilter ? previousFilter.value : undefined);
                //
                if ($92e0f91f0be7afe0$export$5b01eb94d7ce58a8(filterFn, newFilter, column)) {
                    var _old$filter;
                    return (_old$filter = old == null ? void 0 : old.filter((d)=>d.id !== column.id)) != null ? _old$filter : [];
                }
                const newFilterObj = {
                    id: column.id,
                    value: newFilter
                };
                if (previousFilter) {
                    var _old$map;
                    return (_old$map = old == null ? void 0 : old.map((d)=>{
                        if (d.id === column.id) return newFilterObj;
                        return d;
                    })) != null ? _old$map : [];
                }
                if (old != null && old.length) return [
                    ...old,
                    newFilterObj
                ];
                return [
                    newFilterObj
                ];
            });
        };
    },
    createRow: (row, _table)=>{
        row.columnFilters = {};
        row.columnFiltersMeta = {};
    },
    createTable: (table)=>{
        table.setColumnFilters = (updater)=>{
            const leafColumns = table.getAllLeafColumns();
            const updateFn = (old)=>{
                var _functionalUpdate;
                return (_functionalUpdate = $92e0f91f0be7afe0$export$7f095f455ad5af3f(updater, old)) == null ? void 0 : _functionalUpdate.filter((filter)=>{
                    const column = leafColumns.find((d)=>d.id === filter.id);
                    if (column) {
                        const filterFn = column.getFilterFn();
                        if ($92e0f91f0be7afe0$export$5b01eb94d7ce58a8(filterFn, filter.value, column)) return false;
                    }
                    return true;
                });
            };
            table.options.onColumnFiltersChange == null || table.options.onColumnFiltersChange(updateFn);
        };
        table.resetColumnFilters = (defaultState)=>{
            var _table$initialState$c, _table$initialState;
            table.setColumnFilters(defaultState ? [] : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnFilters) != null ? _table$initialState$c : []);
        };
        table.getPreFilteredRowModel = ()=>table.getCoreRowModel();
        table.getFilteredRowModel = ()=>{
            if (!table._getFilteredRowModel && table.options.getFilteredRowModel) table._getFilteredRowModel = table.options.getFilteredRowModel(table);
            if (table.options.manualFiltering || !table._getFilteredRowModel) return table.getPreFilteredRowModel();
            return table._getFilteredRowModel();
        };
    }
};
function $92e0f91f0be7afe0$export$5b01eb94d7ce58a8(filterFn, value, column) {
    return (filterFn && filterFn.autoRemove ? filterFn.autoRemove(value, column) : false) || typeof value === 'undefined' || typeof value === 'string' && !value;
}
const $92e0f91f0be7afe0$var$sum = (columnId, _leafRows, childRows)=>{
    // It's faster to just add the aggregations together instead of
    // process leaf nodes individually
    return childRows.reduce((sum, next)=>{
        const nextValue = next.getValue(columnId);
        return sum + (typeof nextValue === 'number' ? nextValue : 0);
    }, 0);
};
const $92e0f91f0be7afe0$var$min = (columnId, _leafRows, childRows)=>{
    let min;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null && (min > value || min === undefined && value >= value)) min = value;
    });
    return min;
};
const $92e0f91f0be7afe0$var$max = (columnId, _leafRows, childRows)=>{
    let max;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null && (max < value || max === undefined && value >= value)) max = value;
    });
    return max;
};
const $92e0f91f0be7afe0$var$extent = (columnId, _leafRows, childRows)=>{
    let min;
    let max;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    });
    return [
        min,
        max
    ];
};
const $92e0f91f0be7afe0$var$mean = (columnId, leafRows)=>{
    let count = 0;
    let sum = 0;
    leafRows.forEach((row)=>{
        let value = row.getValue(columnId);
        if (value != null && (value = +value) >= value) ++count, sum += value;
    });
    if (count) return sum / count;
    return;
};
const $92e0f91f0be7afe0$var$median = (columnId, leafRows)=>{
    if (!leafRows.length) return;
    const values = leafRows.map((row)=>row.getValue(columnId));
    if (!$92e0f91f0be7afe0$export$5cd576d1827d40c8(values)) return;
    if (values.length === 1) return values[0];
    const mid = Math.floor(values.length / 2);
    const nums = values.sort((a, b)=>a - b);
    return values.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
};
const $92e0f91f0be7afe0$var$unique = (columnId, leafRows)=>{
    return Array.from(new Set(leafRows.map((d)=>d.getValue(columnId))).values());
};
const $92e0f91f0be7afe0$var$uniqueCount = (columnId, leafRows)=>{
    return new Set(leafRows.map((d)=>d.getValue(columnId))).size;
};
const $92e0f91f0be7afe0$var$count = (_columnId, leafRows)=>{
    return leafRows.length;
};
const $92e0f91f0be7afe0$export$3aa4339120b8b25b = {
    sum: $92e0f91f0be7afe0$var$sum,
    min: $92e0f91f0be7afe0$var$min,
    max: $92e0f91f0be7afe0$var$max,
    extent: $92e0f91f0be7afe0$var$extent,
    mean: $92e0f91f0be7afe0$var$mean,
    median: $92e0f91f0be7afe0$var$median,
    unique: $92e0f91f0be7afe0$var$unique,
    uniqueCount: $92e0f91f0be7afe0$var$uniqueCount,
    count: $92e0f91f0be7afe0$var$count
};
//
const $92e0f91f0be7afe0$export$9c9247c655f92e74 = {
    getDefaultColumnDef: ()=>{
        return {
            aggregatedCell: (props)=>{
                var _toString, _props$getValue;
                return (_toString = (_props$getValue = props.getValue()) == null || _props$getValue.toString == null ? void 0 : _props$getValue.toString()) != null ? _toString : null;
            },
            aggregationFn: 'auto'
        };
    },
    getInitialState: (state)=>{
        return {
            grouping: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onGroupingChange: $92e0f91f0be7afe0$export$2b5605d8069324bd('grouping', table),
            groupedColumnMode: 'reorder'
        };
    },
    createColumn: (column, table)=>{
        column.toggleGrouping = ()=>{
            table.setGrouping((old)=>{
                // Find any existing grouping for this column
                if (old != null && old.includes(column.id)) return old.filter((d)=>d !== column.id);
                return [
                    ...old != null ? old : [],
                    column.id
                ];
            });
        };
        column.getCanGroup = ()=>{
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableGrouping) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableGrouping) != null ? _table$options$enable : true) && (!!column.accessorFn || !!column.columnDef.getGroupingValue);
        };
        column.getIsGrouped = ()=>{
            var _table$getState$group;
            return (_table$getState$group = table.getState().grouping) == null ? void 0 : _table$getState$group.includes(column.id);
        };
        column.getGroupedIndex = ()=>{
            var _table$getState$group2;
            return (_table$getState$group2 = table.getState().grouping) == null ? void 0 : _table$getState$group2.indexOf(column.id);
        };
        column.getToggleGroupingHandler = ()=>{
            const canGroup = column.getCanGroup();
            return ()=>{
                if (!canGroup) return;
                column.toggleGrouping();
            };
        };
        column.getAutoAggregationFn = ()=>{
            const firstRow = table.getCoreRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === 'number') return $92e0f91f0be7afe0$export$3aa4339120b8b25b.sum;
            if (Object.prototype.toString.call(value) === '[object Date]') return $92e0f91f0be7afe0$export$3aa4339120b8b25b.extent;
        };
        column.getAggregationFn = ()=>{
            var _table$options$aggreg, _table$options$aggreg2;
            if (!column) throw new Error();
            return $92e0f91f0be7afe0$export$f6e2535fb5126e54(column.columnDef.aggregationFn) ? column.columnDef.aggregationFn : column.columnDef.aggregationFn === 'auto' ? column.getAutoAggregationFn() : (_table$options$aggreg = (_table$options$aggreg2 = table.options.aggregationFns) == null ? void 0 : _table$options$aggreg2[column.columnDef.aggregationFn]) != null ? _table$options$aggreg : $92e0f91f0be7afe0$export$3aa4339120b8b25b[column.columnDef.aggregationFn];
        };
    },
    createTable: (table)=>{
        table.setGrouping = (updater)=>table.options.onGroupingChange == null ? void 0 : table.options.onGroupingChange(updater);
        table.resetGrouping = (defaultState)=>{
            var _table$initialState$g, _table$initialState;
            table.setGrouping(defaultState ? [] : (_table$initialState$g = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.grouping) != null ? _table$initialState$g : []);
        };
        table.getPreGroupedRowModel = ()=>table.getFilteredRowModel();
        table.getGroupedRowModel = ()=>{
            if (!table._getGroupedRowModel && table.options.getGroupedRowModel) table._getGroupedRowModel = table.options.getGroupedRowModel(table);
            if (table.options.manualGrouping || !table._getGroupedRowModel) return table.getPreGroupedRowModel();
            return table._getGroupedRowModel();
        };
    },
    createRow: (row, table)=>{
        row.getIsGrouped = ()=>!!row.groupingColumnId;
        row.getGroupingValue = (columnId)=>{
            if (row._groupingValuesCache.hasOwnProperty(columnId)) return row._groupingValuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.columnDef.getGroupingValue)) return row.getValue(columnId);
            row._groupingValuesCache[columnId] = column.columnDef.getGroupingValue(row.original);
            return row._groupingValuesCache[columnId];
        };
        row._groupingValuesCache = {};
    },
    createCell: (cell, column, row, table)=>{
        cell.getIsGrouped = ()=>column.getIsGrouped() && column.id === row.groupingColumnId;
        cell.getIsPlaceholder = ()=>!cell.getIsGrouped() && column.getIsGrouped();
        cell.getIsAggregated = ()=>{
            var _row$subRows;
            return !cell.getIsGrouped() && !cell.getIsPlaceholder() && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
        };
    }
};
function $92e0f91f0be7afe0$export$ac763d2b0470e663(leafColumns, grouping, groupedColumnMode) {
    if (!(grouping != null && grouping.length) || !groupedColumnMode) return leafColumns;
    const nonGroupingColumns = leafColumns.filter((col)=>!grouping.includes(col.id));
    if (groupedColumnMode === 'remove') return nonGroupingColumns;
    const groupingColumns = grouping.map((g)=>leafColumns.find((col)=>col.id === g)).filter(Boolean);
    return [
        ...groupingColumns,
        ...nonGroupingColumns
    ];
}
//
const $92e0f91f0be7afe0$export$fec9c66cd0275c2c = {
    getInitialState: (state)=>{
        return {
            columnOrder: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnOrderChange: $92e0f91f0be7afe0$export$2b5605d8069324bd('columnOrder', table)
        };
    },
    createColumn: (column, table)=>{
        column.getIndex = $92e0f91f0be7afe0$export$7c73462e0d25e514((position)=>[
                $92e0f91f0be7afe0$export$1d7c103713892a11(table, position)
            ], (columns)=>columns.findIndex((d)=>d.id === column.id), $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugColumns', 'getIndex'));
        column.getIsFirstColumn = (position)=>{
            var _columns$;
            const columns = $92e0f91f0be7afe0$export$1d7c103713892a11(table, position);
            return ((_columns$ = columns[0]) == null ? void 0 : _columns$.id) === column.id;
        };
        column.getIsLastColumn = (position)=>{
            var _columns;
            const columns = $92e0f91f0be7afe0$export$1d7c103713892a11(table, position);
            return ((_columns = columns[columns.length - 1]) == null ? void 0 : _columns.id) === column.id;
        };
    },
    createTable: (table)=>{
        table.setColumnOrder = (updater)=>table.options.onColumnOrderChange == null ? void 0 : table.options.onColumnOrderChange(updater);
        table.resetColumnOrder = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnOrder(defaultState ? [] : (_table$initialState$c = table.initialState.columnOrder) != null ? _table$initialState$c : []);
        };
        table._getOrderColumnsFn = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getState().columnOrder,
                table.getState().grouping,
                table.options.groupedColumnMode
            ], (columnOrder, grouping, groupedColumnMode)=>(columns)=>{
                // Sort grouped columns to the start of the column list
                // before the headers are built
                let orderedColumns = [];
                // If there is no order, return the normal columns
                if (!(columnOrder != null && columnOrder.length)) orderedColumns = columns;
                else {
                    const columnOrderCopy = [
                        ...columnOrder
                    ];
                    // If there is an order, make a copy of the columns
                    const columnsCopy = [
                        ...columns
                    ];
                    // And make a new ordered array of the columns
                    // Loop over the columns and place them in order into the new array
                    while(columnsCopy.length && columnOrderCopy.length){
                        const targetColumnId = columnOrderCopy.shift();
                        const foundIndex = columnsCopy.findIndex((d)=>d.id === targetColumnId);
                        if (foundIndex > -1) orderedColumns.push(columnsCopy.splice(foundIndex, 1)[0]);
                    }
                    // If there are any columns left, add them to the end
                    orderedColumns = [
                        ...orderedColumns,
                        ...columnsCopy
                    ];
                }
                return $92e0f91f0be7afe0$export$ac763d2b0470e663(orderedColumns, grouping, groupedColumnMode);
            }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugTable', '_getOrderColumnsFn'));
    }
};
//
const $92e0f91f0be7afe0$var$getDefaultColumnPinningState = ()=>({
        left: [],
        right: []
    });
const $92e0f91f0be7afe0$export$3563275ce70c4813 = {
    getInitialState: (state)=>{
        return {
            columnPinning: $92e0f91f0be7afe0$var$getDefaultColumnPinningState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnPinningChange: $92e0f91f0be7afe0$export$2b5605d8069324bd('columnPinning', table)
        };
    },
    createColumn: (column, table)=>{
        column.pin = (position)=>{
            const columnIds = column.getLeafColumns().map((d)=>d.id).filter(Boolean);
            table.setColumnPinning((old)=>{
                var _old$left3, _old$right3;
                if (position === 'right') {
                    var _old$left, _old$right;
                    return {
                        left: ((_old$left = old == null ? void 0 : old.left) != null ? _old$left : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                        right: [
                            ...((_old$right = old == null ? void 0 : old.right) != null ? _old$right : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                            ...columnIds
                        ]
                    };
                }
                if (position === 'left') {
                    var _old$left2, _old$right2;
                    return {
                        left: [
                            ...((_old$left2 = old == null ? void 0 : old.left) != null ? _old$left2 : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                            ...columnIds
                        ],
                        right: ((_old$right2 = old == null ? void 0 : old.right) != null ? _old$right2 : []).filter((d)=>!(columnIds != null && columnIds.includes(d)))
                    };
                }
                return {
                    left: ((_old$left3 = old == null ? void 0 : old.left) != null ? _old$left3 : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                    right: ((_old$right3 = old == null ? void 0 : old.right) != null ? _old$right3 : []).filter((d)=>!(columnIds != null && columnIds.includes(d)))
                };
            });
        };
        column.getCanPin = ()=>{
            const leafColumns = column.getLeafColumns();
            return leafColumns.some((d)=>{
                var _d$columnDef$enablePi, _ref, _table$options$enable;
                return ((_d$columnDef$enablePi = d.columnDef.enablePinning) != null ? _d$columnDef$enablePi : true) && ((_ref = (_table$options$enable = table.options.enableColumnPinning) != null ? _table$options$enable : table.options.enablePinning) != null ? _ref : true);
            });
        };
        column.getIsPinned = ()=>{
            const leafColumnIds = column.getLeafColumns().map((d)=>d.id);
            const { left: left, right: right } = table.getState().columnPinning;
            const isLeft = leafColumnIds.some((d)=>left == null ? void 0 : left.includes(d));
            const isRight = leafColumnIds.some((d)=>right == null ? void 0 : right.includes(d));
            return isLeft ? 'left' : isRight ? 'right' : false;
        };
        column.getPinnedIndex = ()=>{
            var _table$getState$colum, _table$getState$colum2;
            const position = column.getIsPinned();
            return position ? (_table$getState$colum = (_table$getState$colum2 = table.getState().columnPinning) == null || (_table$getState$colum2 = _table$getState$colum2[position]) == null ? void 0 : _table$getState$colum2.indexOf(column.id)) != null ? _table$getState$colum : -1 : 0;
        };
    },
    createRow: (row, table)=>{
        row.getCenterVisibleCells = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allCells, left, right)=>{
            const leftAndRight = [
                ...left != null ? left : [],
                ...right != null ? right : []
            ];
            return allCells.filter((d)=>!leftAndRight.includes(d.column.id));
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugRows', 'getCenterVisibleCells'));
        row.getLeftVisibleCells = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.left
            ], (allCells, left)=>{
            const cells = (left != null ? left : []).map((columnId)=>allCells.find((cell)=>cell.column.id === columnId)).filter(Boolean).map((d)=>({
                    ...d,
                    position: 'left'
                }));
            return cells;
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugRows', 'getLeftVisibleCells'));
        row.getRightVisibleCells = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.right
            ], (allCells, right)=>{
            const cells = (right != null ? right : []).map((columnId)=>allCells.find((cell)=>cell.column.id === columnId)).filter(Boolean).map((d)=>({
                    ...d,
                    position: 'right'
                }));
            return cells;
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugRows', 'getRightVisibleCells'));
    },
    createTable: (table)=>{
        table.setColumnPinning = (updater)=>table.options.onColumnPinningChange == null ? void 0 : table.options.onColumnPinningChange(updater);
        table.resetColumnPinning = (defaultState)=>{
            var _table$initialState$c, _table$initialState;
            return table.setColumnPinning(defaultState ? $92e0f91f0be7afe0$var$getDefaultColumnPinningState() : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnPinning) != null ? _table$initialState$c : $92e0f91f0be7afe0$var$getDefaultColumnPinningState());
        };
        table.getIsSomeColumnsPinned = (position)=>{
            var _pinningState$positio;
            const pinningState = table.getState().columnPinning;
            if (!position) {
                var _pinningState$left, _pinningState$right;
                return Boolean(((_pinningState$left = pinningState.left) == null ? void 0 : _pinningState$left.length) || ((_pinningState$right = pinningState.right) == null ? void 0 : _pinningState$right.length));
            }
            return Boolean((_pinningState$positio = pinningState[position]) == null ? void 0 : _pinningState$positio.length);
        };
        table.getLeftLeafColumns = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.left
            ], (allColumns, left)=>{
            return (left != null ? left : []).map((columnId)=>allColumns.find((column)=>column.id === columnId)).filter(Boolean);
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugColumns', 'getLeftLeafColumns'));
        table.getRightLeafColumns = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.right
            ], (allColumns, right)=>{
            return (right != null ? right : []).map((columnId)=>allColumns.find((column)=>column.id === columnId)).filter(Boolean);
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugColumns', 'getRightLeafColumns'));
        table.getCenterLeafColumns = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, left, right)=>{
            const leftAndRight = [
                ...left != null ? left : [],
                ...right != null ? right : []
            ];
            return allColumns.filter((d)=>!leftAndRight.includes(d.id));
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugColumns', 'getCenterLeafColumns'));
    }
};
//
//
const $92e0f91f0be7afe0$export$2f660993f4eb1f29 = {
    size: 150,
    minSize: 20,
    maxSize: Number.MAX_SAFE_INTEGER
};
const $92e0f91f0be7afe0$var$getDefaultColumnSizingInfoState = ()=>({
        startOffset: null,
        startSize: null,
        deltaOffset: null,
        deltaPercentage: null,
        isResizingColumn: false,
        columnSizingStart: []
    });
const $92e0f91f0be7afe0$export$9916c85814812d4a = {
    getDefaultColumnDef: ()=>{
        return $92e0f91f0be7afe0$export$2f660993f4eb1f29;
    },
    getInitialState: (state)=>{
        return {
            columnSizing: {},
            columnSizingInfo: $92e0f91f0be7afe0$var$getDefaultColumnSizingInfoState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            columnResizeMode: 'onEnd',
            columnResizeDirection: 'ltr',
            onColumnSizingChange: $92e0f91f0be7afe0$export$2b5605d8069324bd('columnSizing', table),
            onColumnSizingInfoChange: $92e0f91f0be7afe0$export$2b5605d8069324bd('columnSizingInfo', table)
        };
    },
    createColumn: (column, table)=>{
        column.getSize = ()=>{
            var _column$columnDef$min, _ref, _column$columnDef$max;
            const columnSize = table.getState().columnSizing[column.id];
            return Math.min(Math.max((_column$columnDef$min = column.columnDef.minSize) != null ? _column$columnDef$min : $92e0f91f0be7afe0$export$2f660993f4eb1f29.minSize, (_ref = columnSize != null ? columnSize : column.columnDef.size) != null ? _ref : $92e0f91f0be7afe0$export$2f660993f4eb1f29.size), (_column$columnDef$max = column.columnDef.maxSize) != null ? _column$columnDef$max : $92e0f91f0be7afe0$export$2f660993f4eb1f29.maxSize);
        };
        column.getStart = $92e0f91f0be7afe0$export$7c73462e0d25e514((position)=>[
                position,
                $92e0f91f0be7afe0$export$1d7c103713892a11(table, position),
                table.getState().columnSizing
            ], (position, columns)=>columns.slice(0, column.getIndex(position)).reduce((sum, column)=>sum + column.getSize(), 0), $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugColumns', 'getStart'));
        column.getAfter = $92e0f91f0be7afe0$export$7c73462e0d25e514((position)=>[
                position,
                $92e0f91f0be7afe0$export$1d7c103713892a11(table, position),
                table.getState().columnSizing
            ], (position, columns)=>columns.slice(column.getIndex(position) + 1).reduce((sum, column)=>sum + column.getSize(), 0), $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugColumns', 'getAfter'));
        column.resetSize = ()=>{
            table.setColumnSizing((_ref2)=>{
                let { [column.id]: _, ...rest } = _ref2;
                return rest;
            });
        };
        column.getCanResize = ()=>{
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableResizing) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnResizing) != null ? _table$options$enable : true);
        };
        column.getIsResizing = ()=>{
            return table.getState().columnSizingInfo.isResizingColumn === column.id;
        };
    },
    createHeader: (header, table)=>{
        header.getSize = ()=>{
            let sum = 0;
            const recurse = (header)=>{
                if (header.subHeaders.length) header.subHeaders.forEach(recurse);
                else {
                    var _header$column$getSiz;
                    sum += (_header$column$getSiz = header.column.getSize()) != null ? _header$column$getSiz : 0;
                }
            };
            recurse(header);
            return sum;
        };
        header.getStart = ()=>{
            if (header.index > 0) {
                const prevSiblingHeader = header.headerGroup.headers[header.index - 1];
                return prevSiblingHeader.getStart() + prevSiblingHeader.getSize();
            }
            return 0;
        };
        header.getResizeHandler = (_contextDocument)=>{
            const column = table.getColumn(header.column.id);
            const canResize = column == null ? void 0 : column.getCanResize();
            return (e)=>{
                if (!column || !canResize) return;
                e.persist == null || e.persist();
                if ($92e0f91f0be7afe0$var$isTouchStartEvent(e)) {
                    // lets not respond to multiple touches (e.g. 2 or 3 fingers)
                    if (e.touches && e.touches.length > 1) return;
                }
                const startSize = header.getSize();
                const columnSizingStart = header ? header.getLeafHeaders().map((d)=>[
                        d.column.id,
                        d.column.getSize()
                    ]) : [
                    [
                        column.id,
                        column.getSize()
                    ]
                ];
                const clientX = $92e0f91f0be7afe0$var$isTouchStartEvent(e) ? Math.round(e.touches[0].clientX) : e.clientX;
                const newColumnSizing = {};
                const updateOffset = (eventType, clientXPos)=>{
                    if (typeof clientXPos !== 'number') return;
                    table.setColumnSizingInfo((old)=>{
                        var _old$startOffset, _old$startSize;
                        const deltaDirection = table.options.columnResizeDirection === 'rtl' ? -1 : 1;
                        const deltaOffset = (clientXPos - ((_old$startOffset = old == null ? void 0 : old.startOffset) != null ? _old$startOffset : 0)) * deltaDirection;
                        const deltaPercentage = Math.max(deltaOffset / ((_old$startSize = old == null ? void 0 : old.startSize) != null ? _old$startSize : 0), -0.999999);
                        old.columnSizingStart.forEach((_ref3)=>{
                            let [columnId, headerSize] = _ref3;
                            newColumnSizing[columnId] = Math.round(Math.max(headerSize + headerSize * deltaPercentage, 0) * 100) / 100;
                        });
                        return {
                            ...old,
                            deltaOffset: deltaOffset,
                            deltaPercentage: deltaPercentage
                        };
                    });
                    if (table.options.columnResizeMode === 'onChange' || eventType === 'end') table.setColumnSizing((old)=>({
                            ...old,
                            ...newColumnSizing
                        }));
                };
                const onMove = (clientXPos)=>updateOffset('move', clientXPos);
                const onEnd = (clientXPos)=>{
                    updateOffset('end', clientXPos);
                    table.setColumnSizingInfo((old)=>({
                            ...old,
                            isResizingColumn: false,
                            startOffset: null,
                            startSize: null,
                            deltaOffset: null,
                            deltaPercentage: null,
                            columnSizingStart: []
                        }));
                };
                const contextDocument = _contextDocument || typeof document !== 'undefined' ? document : null;
                const mouseEvents = {
                    moveHandler: (e)=>onMove(e.clientX),
                    upHandler: (e)=>{
                        contextDocument == null || contextDocument.removeEventListener('mousemove', mouseEvents.moveHandler);
                        contextDocument == null || contextDocument.removeEventListener('mouseup', mouseEvents.upHandler);
                        onEnd(e.clientX);
                    }
                };
                const touchEvents = {
                    moveHandler: (e)=>{
                        if (e.cancelable) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        onMove(e.touches[0].clientX);
                        return false;
                    },
                    upHandler: (e)=>{
                        var _e$touches$;
                        contextDocument == null || contextDocument.removeEventListener('touchmove', touchEvents.moveHandler);
                        contextDocument == null || contextDocument.removeEventListener('touchend', touchEvents.upHandler);
                        if (e.cancelable) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        onEnd((_e$touches$ = e.touches[0]) == null ? void 0 : _e$touches$.clientX);
                    }
                };
                const passiveIfSupported = $92e0f91f0be7afe0$export$4927b5943c7c0b4() ? {
                    passive: false
                } : false;
                if ($92e0f91f0be7afe0$var$isTouchStartEvent(e)) {
                    contextDocument == null || contextDocument.addEventListener('touchmove', touchEvents.moveHandler, passiveIfSupported);
                    contextDocument == null || contextDocument.addEventListener('touchend', touchEvents.upHandler, passiveIfSupported);
                } else {
                    contextDocument == null || contextDocument.addEventListener('mousemove', mouseEvents.moveHandler, passiveIfSupported);
                    contextDocument == null || contextDocument.addEventListener('mouseup', mouseEvents.upHandler, passiveIfSupported);
                }
                table.setColumnSizingInfo((old)=>({
                        ...old,
                        startOffset: clientX,
                        startSize: startSize,
                        deltaOffset: 0,
                        deltaPercentage: 0,
                        columnSizingStart: columnSizingStart,
                        isResizingColumn: column.id
                    }));
            };
        };
    },
    createTable: (table)=>{
        table.setColumnSizing = (updater)=>table.options.onColumnSizingChange == null ? void 0 : table.options.onColumnSizingChange(updater);
        table.setColumnSizingInfo = (updater)=>table.options.onColumnSizingInfoChange == null ? void 0 : table.options.onColumnSizingInfoChange(updater);
        table.resetColumnSizing = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnSizing(defaultState ? {} : (_table$initialState$c = table.initialState.columnSizing) != null ? _table$initialState$c : {});
        };
        table.resetHeaderSizeInfo = (defaultState)=>{
            var _table$initialState$c2;
            table.setColumnSizingInfo(defaultState ? $92e0f91f0be7afe0$var$getDefaultColumnSizingInfoState() : (_table$initialState$c2 = table.initialState.columnSizingInfo) != null ? _table$initialState$c2 : $92e0f91f0be7afe0$var$getDefaultColumnSizingInfoState());
        };
        table.getTotalSize = ()=>{
            var _table$getHeaderGroup, _table$getHeaderGroup2;
            return (_table$getHeaderGroup = (_table$getHeaderGroup2 = table.getHeaderGroups()[0]) == null ? void 0 : _table$getHeaderGroup2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getHeaderGroup : 0;
        };
        table.getLeftTotalSize = ()=>{
            var _table$getLeftHeaderG, _table$getLeftHeaderG2;
            return (_table$getLeftHeaderG = (_table$getLeftHeaderG2 = table.getLeftHeaderGroups()[0]) == null ? void 0 : _table$getLeftHeaderG2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getLeftHeaderG : 0;
        };
        table.getCenterTotalSize = ()=>{
            var _table$getCenterHeade, _table$getCenterHeade2;
            return (_table$getCenterHeade = (_table$getCenterHeade2 = table.getCenterHeaderGroups()[0]) == null ? void 0 : _table$getCenterHeade2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getCenterHeade : 0;
        };
        table.getRightTotalSize = ()=>{
            var _table$getRightHeader, _table$getRightHeader2;
            return (_table$getRightHeader = (_table$getRightHeader2 = table.getRightHeaderGroups()[0]) == null ? void 0 : _table$getRightHeader2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getRightHeader : 0;
        };
    }
};
let $92e0f91f0be7afe0$var$passiveSupported = null;
function $92e0f91f0be7afe0$export$4927b5943c7c0b4() {
    if (typeof $92e0f91f0be7afe0$var$passiveSupported === 'boolean') return $92e0f91f0be7afe0$var$passiveSupported;
    let supported = false;
    try {
        const options = {
            get passive () {
                supported = true;
                return false;
            }
        };
        const noop = ()=>{};
        window.addEventListener('test', noop, options);
        window.removeEventListener('test', noop);
    } catch (err) {
        supported = false;
    }
    $92e0f91f0be7afe0$var$passiveSupported = supported;
    return $92e0f91f0be7afe0$var$passiveSupported;
}
function $92e0f91f0be7afe0$var$isTouchStartEvent(e) {
    return e.type === 'touchstart';
}
//
const $92e0f91f0be7afe0$export$be5545a32e20d889 = {
    getInitialState: (state)=>{
        return {
            columnVisibility: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnVisibilityChange: $92e0f91f0be7afe0$export$2b5605d8069324bd('columnVisibility', table)
        };
    },
    createColumn: (column, table)=>{
        column.toggleVisibility = (value)=>{
            if (column.getCanHide()) table.setColumnVisibility((old)=>({
                    ...old,
                    [column.id]: value != null ? value : !column.getIsVisible()
                }));
        };
        column.getIsVisible = ()=>{
            var _ref, _table$getState$colum;
            const childColumns = column.columns;
            return (_ref = childColumns.length ? childColumns.some((c)=>c.getIsVisible()) : (_table$getState$colum = table.getState().columnVisibility) == null ? void 0 : _table$getState$colum[column.id]) != null ? _ref : true;
        };
        column.getCanHide = ()=>{
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableHiding) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableHiding) != null ? _table$options$enable : true);
        };
        column.getToggleVisibilityHandler = ()=>{
            return (e)=>{
                column.toggleVisibility == null || column.toggleVisibility(e.target.checked);
            };
        };
    },
    createRow: (row, table)=>{
        row._getAllVisibleCells = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                row.getAllCells(),
                table.getState().columnVisibility
            ], (cells)=>{
            return cells.filter((cell)=>cell.column.getIsVisible());
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugRows', '_getAllVisibleCells'));
        row.getVisibleCells = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                row.getLeftVisibleCells(),
                row.getCenterVisibleCells(),
                row.getRightVisibleCells()
            ], (left, center, right)=>[
                ...left,
                ...center,
                ...right
            ], $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugRows', 'getVisibleCells'));
    },
    createTable: (table)=>{
        const makeVisibleColumnsMethod = (key, getColumns)=>{
            return $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                    getColumns(),
                    getColumns().filter((d)=>d.getIsVisible()).map((d)=>d.id).join('_')
                ], (columns)=>{
                return columns.filter((d)=>d.getIsVisible == null ? void 0 : d.getIsVisible());
            }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugColumns', key));
        };
        table.getVisibleFlatColumns = makeVisibleColumnsMethod('getVisibleFlatColumns', ()=>table.getAllFlatColumns());
        table.getVisibleLeafColumns = makeVisibleColumnsMethod('getVisibleLeafColumns', ()=>table.getAllLeafColumns());
        table.getLeftVisibleLeafColumns = makeVisibleColumnsMethod('getLeftVisibleLeafColumns', ()=>table.getLeftLeafColumns());
        table.getRightVisibleLeafColumns = makeVisibleColumnsMethod('getRightVisibleLeafColumns', ()=>table.getRightLeafColumns());
        table.getCenterVisibleLeafColumns = makeVisibleColumnsMethod('getCenterVisibleLeafColumns', ()=>table.getCenterLeafColumns());
        table.setColumnVisibility = (updater)=>table.options.onColumnVisibilityChange == null ? void 0 : table.options.onColumnVisibilityChange(updater);
        table.resetColumnVisibility = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnVisibility(defaultState ? {} : (_table$initialState$c = table.initialState.columnVisibility) != null ? _table$initialState$c : {});
        };
        table.toggleAllColumnsVisible = (value)=>{
            var _value;
            value = (_value = value) != null ? _value : !table.getIsAllColumnsVisible();
            table.setColumnVisibility(table.getAllLeafColumns().reduce((obj, column)=>({
                    ...obj,
                    [column.id]: !value ? !(column.getCanHide != null && column.getCanHide()) : value
                }), {}));
        };
        table.getIsAllColumnsVisible = ()=>!table.getAllLeafColumns().some((column)=>!(column.getIsVisible != null && column.getIsVisible()));
        table.getIsSomeColumnsVisible = ()=>table.getAllLeafColumns().some((column)=>column.getIsVisible == null ? void 0 : column.getIsVisible());
        table.getToggleAllColumnsVisibilityHandler = ()=>{
            return (e)=>{
                var _target;
                table.toggleAllColumnsVisible((_target = e.target) == null ? void 0 : _target.checked);
            };
        };
    }
};
function $92e0f91f0be7afe0$export$1d7c103713892a11(table, position) {
    return !position ? table.getVisibleLeafColumns() : position === 'center' ? table.getCenterVisibleLeafColumns() : position === 'left' ? table.getLeftVisibleLeafColumns() : table.getRightVisibleLeafColumns();
}
//
const $92e0f91f0be7afe0$export$4b37edcdc7ad2fe1 = {
    createTable: (table)=>{
        table._getGlobalFacetedRowModel = table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, '__global__');
        table.getGlobalFacetedRowModel = ()=>{
            if (table.options.manualFiltering || !table._getGlobalFacetedRowModel) return table.getPreFilteredRowModel();
            return table._getGlobalFacetedRowModel();
        };
        table._getGlobalFacetedUniqueValues = table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, '__global__');
        table.getGlobalFacetedUniqueValues = ()=>{
            if (!table._getGlobalFacetedUniqueValues) return new Map();
            return table._getGlobalFacetedUniqueValues();
        };
        table._getGlobalFacetedMinMaxValues = table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, '__global__');
        table.getGlobalFacetedMinMaxValues = ()=>{
            if (!table._getGlobalFacetedMinMaxValues) return;
            return table._getGlobalFacetedMinMaxValues();
        };
    }
};
//
const $92e0f91f0be7afe0$export$61e9e0661ff79b1c = {
    getInitialState: (state)=>{
        return {
            globalFilter: undefined,
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onGlobalFilterChange: $92e0f91f0be7afe0$export$2b5605d8069324bd('globalFilter', table),
            globalFilterFn: 'auto',
            getColumnCanGlobalFilter: (column)=>{
                var _table$getCoreRowMode;
                const value = (_table$getCoreRowMode = table.getCoreRowModel().flatRows[0]) == null || (_table$getCoreRowMode = _table$getCoreRowMode._getAllCellsByColumnId()[column.id]) == null ? void 0 : _table$getCoreRowMode.getValue();
                return typeof value === 'string' || typeof value === 'number';
            }
        };
    },
    createColumn: (column, table)=>{
        column.getCanGlobalFilter = ()=>{
            var _column$columnDef$ena, _table$options$enable, _table$options$enable2, _table$options$getCol;
            return ((_column$columnDef$ena = column.columnDef.enableGlobalFilter) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableGlobalFilter) != null ? _table$options$enable : true) && ((_table$options$enable2 = table.options.enableFilters) != null ? _table$options$enable2 : true) && ((_table$options$getCol = table.options.getColumnCanGlobalFilter == null ? void 0 : table.options.getColumnCanGlobalFilter(column)) != null ? _table$options$getCol : true) && !!column.accessorFn;
        };
    },
    createTable: (table)=>{
        table.getGlobalAutoFilterFn = ()=>{
            return $92e0f91f0be7afe0$export$6ad8312e296ec316.includesString;
        };
        table.getGlobalFilterFn = ()=>{
            var _table$options$filter, _table$options$filter2;
            const { globalFilterFn: globalFilterFn } = table.options;
            return $92e0f91f0be7afe0$export$f6e2535fb5126e54(globalFilterFn) ? globalFilterFn : globalFilterFn === 'auto' ? table.getGlobalAutoFilterFn() : (_table$options$filter = (_table$options$filter2 = table.options.filterFns) == null ? void 0 : _table$options$filter2[globalFilterFn]) != null ? _table$options$filter : $92e0f91f0be7afe0$export$6ad8312e296ec316[globalFilterFn];
        };
        table.setGlobalFilter = (updater)=>{
            table.options.onGlobalFilterChange == null || table.options.onGlobalFilterChange(updater);
        };
        table.resetGlobalFilter = (defaultState)=>{
            table.setGlobalFilter(defaultState ? undefined : table.initialState.globalFilter);
        };
    }
};
//
const $92e0f91f0be7afe0$export$fed54e0d64c17fb2 = {
    getInitialState: (state)=>{
        return {
            expanded: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onExpandedChange: $92e0f91f0be7afe0$export$2b5605d8069324bd('expanded', table),
            paginateExpandedRows: true
        };
    },
    createTable: (table)=>{
        let registered = false;
        let queued = false;
        table._autoResetExpanded = ()=>{
            var _ref, _table$options$autoRe;
            if (!registered) {
                table._queue(()=>{
                    registered = true;
                });
                return;
            }
            if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetExpanded) != null ? _ref : !table.options.manualExpanding) {
                if (queued) return;
                queued = true;
                table._queue(()=>{
                    table.resetExpanded();
                    queued = false;
                });
            }
        };
        table.setExpanded = (updater)=>table.options.onExpandedChange == null ? void 0 : table.options.onExpandedChange(updater);
        table.toggleAllRowsExpanded = (expanded)=>{
            if (expanded != null ? expanded : !table.getIsAllRowsExpanded()) table.setExpanded(true);
            else table.setExpanded({});
        };
        table.resetExpanded = (defaultState)=>{
            var _table$initialState$e, _table$initialState;
            table.setExpanded(defaultState ? {} : (_table$initialState$e = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.expanded) != null ? _table$initialState$e : {});
        };
        table.getCanSomeRowsExpand = ()=>{
            return table.getPrePaginationRowModel().flatRows.some((row)=>row.getCanExpand());
        };
        table.getToggleAllRowsExpandedHandler = ()=>{
            return (e)=>{
                e.persist == null || e.persist();
                table.toggleAllRowsExpanded();
            };
        };
        table.getIsSomeRowsExpanded = ()=>{
            const expanded = table.getState().expanded;
            return expanded === true || Object.values(expanded).some(Boolean);
        };
        table.getIsAllRowsExpanded = ()=>{
            const expanded = table.getState().expanded;
            // If expanded is true, save some cycles and return true
            if (typeof expanded === 'boolean') return expanded === true;
            if (!Object.keys(expanded).length) return false;
            // If any row is not expanded, return false
            if (table.getRowModel().flatRows.some((row)=>!row.getIsExpanded())) return false;
            // They must all be expanded :shrug:
            return true;
        };
        table.getExpandedDepth = ()=>{
            let maxDepth = 0;
            const rowIds = table.getState().expanded === true ? Object.keys(table.getRowModel().rowsById) : Object.keys(table.getState().expanded);
            rowIds.forEach((id)=>{
                const splitId = id.split('.');
                maxDepth = Math.max(maxDepth, splitId.length);
            });
            return maxDepth;
        };
        table.getPreExpandedRowModel = ()=>table.getSortedRowModel();
        table.getExpandedRowModel = ()=>{
            if (!table._getExpandedRowModel && table.options.getExpandedRowModel) table._getExpandedRowModel = table.options.getExpandedRowModel(table);
            if (table.options.manualExpanding || !table._getExpandedRowModel) return table.getPreExpandedRowModel();
            return table._getExpandedRowModel();
        };
    },
    createRow: (row, table)=>{
        row.toggleExpanded = (expanded)=>{
            table.setExpanded((old)=>{
                var _expanded;
                const exists = old === true ? true : !!(old != null && old[row.id]);
                let oldExpanded = {};
                if (old === true) Object.keys(table.getRowModel().rowsById).forEach((rowId)=>{
                    oldExpanded[rowId] = true;
                });
                else oldExpanded = old;
                expanded = (_expanded = expanded) != null ? _expanded : !exists;
                if (!exists && expanded) return {
                    ...oldExpanded,
                    [row.id]: true
                };
                if (exists && !expanded) {
                    const { [row.id]: _, ...rest } = oldExpanded;
                    return rest;
                }
                return old;
            });
        };
        row.getIsExpanded = ()=>{
            var _table$options$getIsR;
            const expanded = table.getState().expanded;
            return !!((_table$options$getIsR = table.options.getIsRowExpanded == null ? void 0 : table.options.getIsRowExpanded(row)) != null ? _table$options$getIsR : expanded === true || (expanded == null ? void 0 : expanded[row.id]));
        };
        row.getCanExpand = ()=>{
            var _table$options$getRow, _table$options$enable, _row$subRows;
            return (_table$options$getRow = table.options.getRowCanExpand == null ? void 0 : table.options.getRowCanExpand(row)) != null ? _table$options$getRow : ((_table$options$enable = table.options.enableExpanding) != null ? _table$options$enable : true) && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
        };
        row.getIsAllParentsExpanded = ()=>{
            let isFullyExpanded = true;
            let currentRow = row;
            while(isFullyExpanded && currentRow.parentId){
                currentRow = table.getRow(currentRow.parentId, true);
                isFullyExpanded = currentRow.getIsExpanded();
            }
            return isFullyExpanded;
        };
        row.getToggleExpandedHandler = ()=>{
            const canExpand = row.getCanExpand();
            return ()=>{
                if (!canExpand) return;
                row.toggleExpanded();
            };
        };
    }
};
//
const $92e0f91f0be7afe0$var$defaultPageIndex = 0;
const $92e0f91f0be7afe0$var$defaultPageSize = 10;
const $92e0f91f0be7afe0$var$getDefaultPaginationState = ()=>({
        pageIndex: $92e0f91f0be7afe0$var$defaultPageIndex,
        pageSize: $92e0f91f0be7afe0$var$defaultPageSize
    });
const $92e0f91f0be7afe0$export$bce540641752d22b = {
    getInitialState: (state)=>{
        return {
            ...state,
            pagination: {
                ...$92e0f91f0be7afe0$var$getDefaultPaginationState(),
                ...state == null ? void 0 : state.pagination
            }
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onPaginationChange: $92e0f91f0be7afe0$export$2b5605d8069324bd('pagination', table)
        };
    },
    createTable: (table)=>{
        let registered = false;
        let queued = false;
        table._autoResetPageIndex = ()=>{
            var _ref, _table$options$autoRe;
            if (!registered) {
                table._queue(()=>{
                    registered = true;
                });
                return;
            }
            if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetPageIndex) != null ? _ref : !table.options.manualPagination) {
                if (queued) return;
                queued = true;
                table._queue(()=>{
                    table.resetPageIndex();
                    queued = false;
                });
            }
        };
        table.setPagination = (updater)=>{
            const safeUpdater = (old)=>{
                let newState = $92e0f91f0be7afe0$export$7f095f455ad5af3f(updater, old);
                return newState;
            };
            return table.options.onPaginationChange == null ? void 0 : table.options.onPaginationChange(safeUpdater);
        };
        table.resetPagination = (defaultState)=>{
            var _table$initialState$p;
            table.setPagination(defaultState ? $92e0f91f0be7afe0$var$getDefaultPaginationState() : (_table$initialState$p = table.initialState.pagination) != null ? _table$initialState$p : $92e0f91f0be7afe0$var$getDefaultPaginationState());
        };
        table.setPageIndex = (updater)=>{
            table.setPagination((old)=>{
                let pageIndex = $92e0f91f0be7afe0$export$7f095f455ad5af3f(updater, old.pageIndex);
                const maxPageIndex = typeof table.options.pageCount === 'undefined' || table.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : table.options.pageCount - 1;
                pageIndex = Math.max(0, Math.min(pageIndex, maxPageIndex));
                return {
                    ...old,
                    pageIndex: pageIndex
                };
            });
        };
        table.resetPageIndex = (defaultState)=>{
            var _table$initialState$p2, _table$initialState;
            table.setPageIndex(defaultState ? $92e0f91f0be7afe0$var$defaultPageIndex : (_table$initialState$p2 = (_table$initialState = table.initialState) == null || (_table$initialState = _table$initialState.pagination) == null ? void 0 : _table$initialState.pageIndex) != null ? _table$initialState$p2 : $92e0f91f0be7afe0$var$defaultPageIndex);
        };
        table.resetPageSize = (defaultState)=>{
            var _table$initialState$p3, _table$initialState2;
            table.setPageSize(defaultState ? $92e0f91f0be7afe0$var$defaultPageSize : (_table$initialState$p3 = (_table$initialState2 = table.initialState) == null || (_table$initialState2 = _table$initialState2.pagination) == null ? void 0 : _table$initialState2.pageSize) != null ? _table$initialState$p3 : $92e0f91f0be7afe0$var$defaultPageSize);
        };
        table.setPageSize = (updater)=>{
            table.setPagination((old)=>{
                const pageSize = Math.max(1, $92e0f91f0be7afe0$export$7f095f455ad5af3f(updater, old.pageSize));
                const topRowIndex = old.pageSize * old.pageIndex;
                const pageIndex = Math.floor(topRowIndex / pageSize);
                return {
                    ...old,
                    pageIndex: pageIndex,
                    pageSize: pageSize
                };
            });
        };
        //deprecated
        table.setPageCount = (updater)=>table.setPagination((old)=>{
                var _table$options$pageCo;
                let newPageCount = $92e0f91f0be7afe0$export$7f095f455ad5af3f(updater, (_table$options$pageCo = table.options.pageCount) != null ? _table$options$pageCo : -1);
                if (typeof newPageCount === 'number') newPageCount = Math.max(-1, newPageCount);
                return {
                    ...old,
                    pageCount: newPageCount
                };
            });
        table.getPageOptions = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getPageCount()
            ], (pageCount)=>{
            let pageOptions = [];
            if (pageCount && pageCount > 0) pageOptions = [
                ...new Array(pageCount)
            ].fill(null).map((_, i)=>i);
            return pageOptions;
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugTable', 'getPageOptions'));
        table.getCanPreviousPage = ()=>table.getState().pagination.pageIndex > 0;
        table.getCanNextPage = ()=>{
            const { pageIndex: pageIndex } = table.getState().pagination;
            const pageCount = table.getPageCount();
            if (pageCount === -1) return true;
            if (pageCount === 0) return false;
            return pageIndex < pageCount - 1;
        };
        table.previousPage = ()=>{
            return table.setPageIndex((old)=>old - 1);
        };
        table.nextPage = ()=>{
            return table.setPageIndex((old)=>{
                return old + 1;
            });
        };
        table.firstPage = ()=>{
            return table.setPageIndex(0);
        };
        table.lastPage = ()=>{
            return table.setPageIndex(table.getPageCount() - 1);
        };
        table.getPrePaginationRowModel = ()=>table.getExpandedRowModel();
        table.getPaginationRowModel = ()=>{
            if (!table._getPaginationRowModel && table.options.getPaginationRowModel) table._getPaginationRowModel = table.options.getPaginationRowModel(table);
            if (table.options.manualPagination || !table._getPaginationRowModel) return table.getPrePaginationRowModel();
            return table._getPaginationRowModel();
        };
        table.getPageCount = ()=>{
            var _table$options$pageCo2;
            return (_table$options$pageCo2 = table.options.pageCount) != null ? _table$options$pageCo2 : Math.ceil(table.getRowCount() / table.getState().pagination.pageSize);
        };
        table.getRowCount = ()=>{
            var _table$options$rowCou;
            return (_table$options$rowCou = table.options.rowCount) != null ? _table$options$rowCou : table.getPrePaginationRowModel().rows.length;
        };
    }
};
//
const $92e0f91f0be7afe0$var$getDefaultRowPinningState = ()=>({
        top: [],
        bottom: []
    });
const $92e0f91f0be7afe0$export$213d72cb2ac7d440 = {
    getInitialState: (state)=>{
        return {
            rowPinning: $92e0f91f0be7afe0$var$getDefaultRowPinningState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onRowPinningChange: $92e0f91f0be7afe0$export$2b5605d8069324bd('rowPinning', table)
        };
    },
    createRow: (row, table)=>{
        row.pin = (position, includeLeafRows, includeParentRows)=>{
            const leafRowIds = includeLeafRows ? row.getLeafRows().map((_ref)=>{
                let { id: id } = _ref;
                return id;
            }) : [];
            const parentRowIds = includeParentRows ? row.getParentRows().map((_ref2)=>{
                let { id: id } = _ref2;
                return id;
            }) : [];
            const rowIds = new Set([
                ...parentRowIds,
                row.id,
                ...leafRowIds
            ]);
            table.setRowPinning((old)=>{
                var _old$top3, _old$bottom3;
                if (position === 'bottom') {
                    var _old$top, _old$bottom;
                    return {
                        top: ((_old$top = old == null ? void 0 : old.top) != null ? _old$top : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                        bottom: [
                            ...((_old$bottom = old == null ? void 0 : old.bottom) != null ? _old$bottom : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                            ...Array.from(rowIds)
                        ]
                    };
                }
                if (position === 'top') {
                    var _old$top2, _old$bottom2;
                    return {
                        top: [
                            ...((_old$top2 = old == null ? void 0 : old.top) != null ? _old$top2 : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                            ...Array.from(rowIds)
                        ],
                        bottom: ((_old$bottom2 = old == null ? void 0 : old.bottom) != null ? _old$bottom2 : []).filter((d)=>!(rowIds != null && rowIds.has(d)))
                    };
                }
                return {
                    top: ((_old$top3 = old == null ? void 0 : old.top) != null ? _old$top3 : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                    bottom: ((_old$bottom3 = old == null ? void 0 : old.bottom) != null ? _old$bottom3 : []).filter((d)=>!(rowIds != null && rowIds.has(d)))
                };
            });
        };
        row.getCanPin = ()=>{
            var _ref3;
            const { enableRowPinning: enableRowPinning, enablePinning: enablePinning } = table.options;
            if (typeof enableRowPinning === 'function') return enableRowPinning(row);
            return (_ref3 = enableRowPinning != null ? enableRowPinning : enablePinning) != null ? _ref3 : true;
        };
        row.getIsPinned = ()=>{
            const rowIds = [
                row.id
            ];
            const { top: top, bottom: bottom } = table.getState().rowPinning;
            const isTop = rowIds.some((d)=>top == null ? void 0 : top.includes(d));
            const isBottom = rowIds.some((d)=>bottom == null ? void 0 : bottom.includes(d));
            return isTop ? 'top' : isBottom ? 'bottom' : false;
        };
        row.getPinnedIndex = ()=>{
            var _ref4, _visiblePinnedRowIds$;
            const position = row.getIsPinned();
            if (!position) return -1;
            const visiblePinnedRowIds = (_ref4 = position === 'top' ? table.getTopRows() : table.getBottomRows()) == null ? void 0 : _ref4.map((_ref5)=>{
                let { id: id } = _ref5;
                return id;
            });
            return (_visiblePinnedRowIds$ = visiblePinnedRowIds == null ? void 0 : visiblePinnedRowIds.indexOf(row.id)) != null ? _visiblePinnedRowIds$ : -1;
        };
    },
    createTable: (table)=>{
        table.setRowPinning = (updater)=>table.options.onRowPinningChange == null ? void 0 : table.options.onRowPinningChange(updater);
        table.resetRowPinning = (defaultState)=>{
            var _table$initialState$r, _table$initialState;
            return table.setRowPinning(defaultState ? $92e0f91f0be7afe0$var$getDefaultRowPinningState() : (_table$initialState$r = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.rowPinning) != null ? _table$initialState$r : $92e0f91f0be7afe0$var$getDefaultRowPinningState());
        };
        table.getIsSomeRowsPinned = (position)=>{
            var _pinningState$positio;
            const pinningState = table.getState().rowPinning;
            if (!position) {
                var _pinningState$top, _pinningState$bottom;
                return Boolean(((_pinningState$top = pinningState.top) == null ? void 0 : _pinningState$top.length) || ((_pinningState$bottom = pinningState.bottom) == null ? void 0 : _pinningState$bottom.length));
            }
            return Boolean((_pinningState$positio = pinningState[position]) == null ? void 0 : _pinningState$positio.length);
        };
        table._getPinnedRows = (visibleRows, pinnedRowIds, position)=>{
            var _table$options$keepPi;
            const rows = ((_table$options$keepPi = table.options.keepPinnedRows) != null ? _table$options$keepPi : true) ? //get all rows that are pinned even if they would not be otherwise visible
            //account for expanded parent rows, but not pagination or filtering
            (pinnedRowIds != null ? pinnedRowIds : []).map((rowId)=>{
                const row = table.getRow(rowId, true);
                return row.getIsAllParentsExpanded() ? row : null;
            }) : //else get only visible rows that are pinned
            (pinnedRowIds != null ? pinnedRowIds : []).map((rowId)=>visibleRows.find((row)=>row.id === rowId));
            return rows.filter(Boolean).map((d)=>({
                    ...d,
                    position: position
                }));
        };
        table.getTopRows = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getRowModel().rows,
                table.getState().rowPinning.top
            ], (allRows, topPinnedRowIds)=>table._getPinnedRows(allRows, topPinnedRowIds, 'top'), $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugRows', 'getTopRows'));
        table.getBottomRows = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getRowModel().rows,
                table.getState().rowPinning.bottom
            ], (allRows, bottomPinnedRowIds)=>table._getPinnedRows(allRows, bottomPinnedRowIds, 'bottom'), $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugRows', 'getBottomRows'));
        table.getCenterRows = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getRowModel().rows,
                table.getState().rowPinning.top,
                table.getState().rowPinning.bottom
            ], (allRows, top, bottom)=>{
            const topAndBottom = new Set([
                ...top != null ? top : [],
                ...bottom != null ? bottom : []
            ]);
            return allRows.filter((d)=>!topAndBottom.has(d.id));
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugRows', 'getCenterRows'));
    }
};
//
const $92e0f91f0be7afe0$export$e8905133e7bf3121 = {
    getInitialState: (state)=>{
        return {
            rowSelection: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onRowSelectionChange: $92e0f91f0be7afe0$export$2b5605d8069324bd('rowSelection', table),
            enableRowSelection: true,
            enableMultiRowSelection: true,
            enableSubRowSelection: true
        };
    },
    createTable: (table)=>{
        table.setRowSelection = (updater)=>table.options.onRowSelectionChange == null ? void 0 : table.options.onRowSelectionChange(updater);
        table.resetRowSelection = (defaultState)=>{
            var _table$initialState$r;
            return table.setRowSelection(defaultState ? {} : (_table$initialState$r = table.initialState.rowSelection) != null ? _table$initialState$r : {});
        };
        table.toggleAllRowsSelected = (value)=>{
            table.setRowSelection((old)=>{
                value = typeof value !== 'undefined' ? value : !table.getIsAllRowsSelected();
                const rowSelection = {
                    ...old
                };
                const preGroupedFlatRows = table.getPreGroupedRowModel().flatRows;
                // We don't use `mutateRowIsSelected` here for performance reasons.
                // All of the rows are flat already, so it wouldn't be worth it
                if (value) preGroupedFlatRows.forEach((row)=>{
                    if (!row.getCanSelect()) return;
                    rowSelection[row.id] = true;
                });
                else preGroupedFlatRows.forEach((row)=>{
                    delete rowSelection[row.id];
                });
                return rowSelection;
            });
        };
        table.toggleAllPageRowsSelected = (value)=>table.setRowSelection((old)=>{
                const resolvedValue = typeof value !== 'undefined' ? value : !table.getIsAllPageRowsSelected();
                const rowSelection = {
                    ...old
                };
                table.getRowModel().rows.forEach((row)=>{
                    $92e0f91f0be7afe0$var$mutateRowIsSelected(rowSelection, row.id, resolvedValue, true, table);
                });
                return rowSelection;
            });
        // addRowSelectionRange: rowId => {
        //   const {
        //     rows,
        //     rowsById,
        //     options: { selectGroupingRows, selectSubRows },
        //   } = table
        //   const findSelectedRow = (rows: Row[]) => {
        //     let found
        //     rows.find(d => {
        //       if (d.getIsSelected()) {
        //         found = d
        //         return true
        //       }
        //       const subFound = findSelectedRow(d.subRows || [])
        //       if (subFound) {
        //         found = subFound
        //         return true
        //       }
        //       return false
        //     })
        //     return found
        //   }
        //   const firstRow = findSelectedRow(rows) || rows[0]
        //   const lastRow = rowsById[rowId]
        //   let include = false
        //   const selectedRowIds = {}
        //   const addRow = (row: Row) => {
        //     mutateRowIsSelected(selectedRowIds, row.id, true, {
        //       rowsById,
        //       selectGroupingRows: selectGroupingRows!,
        //       selectSubRows: selectSubRows!,
        //     })
        //   }
        //   table.rows.forEach(row => {
        //     const isFirstRow = row.id === firstRow.id
        //     const isLastRow = row.id === lastRow.id
        //     if (isFirstRow || isLastRow) {
        //       if (!include) {
        //         include = true
        //       } else if (include) {
        //         addRow(row)
        //         include = false
        //       }
        //     }
        //     if (include) {
        //       addRow(row)
        //     }
        //   })
        //   table.setRowSelection(selectedRowIds)
        // },
        table.getPreSelectedRowModel = ()=>table.getCoreRowModel();
        table.getSelectedRowModel = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getState().rowSelection,
                table.getCoreRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return $92e0f91f0be7afe0$export$f150e72530556b0b(table, rowModel);
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugTable', 'getSelectedRowModel'));
        table.getFilteredSelectedRowModel = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getState().rowSelection,
                table.getFilteredRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return $92e0f91f0be7afe0$export$f150e72530556b0b(table, rowModel);
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugTable', 'getFilteredSelectedRowModel'));
        table.getGroupedSelectedRowModel = $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getState().rowSelection,
                table.getSortedRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return $92e0f91f0be7afe0$export$f150e72530556b0b(table, rowModel);
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugTable', 'getGroupedSelectedRowModel'));
        ///
        // getGroupingRowCanSelect: rowId => {
        //   const row = table.getRow(rowId)
        //   if (!row) {
        //     throw new Error()
        //   }
        //   if (typeof table.options.enableGroupingRowSelection === 'function') {
        //     return table.options.enableGroupingRowSelection(row)
        //   }
        //   return table.options.enableGroupingRowSelection ?? false
        // },
        table.getIsAllRowsSelected = ()=>{
            const preGroupedFlatRows = table.getFilteredRowModel().flatRows;
            const { rowSelection: rowSelection } = table.getState();
            let isAllRowsSelected = Boolean(preGroupedFlatRows.length && Object.keys(rowSelection).length);
            if (isAllRowsSelected) {
                if (preGroupedFlatRows.some((row)=>row.getCanSelect() && !rowSelection[row.id])) isAllRowsSelected = false;
            }
            return isAllRowsSelected;
        };
        table.getIsAllPageRowsSelected = ()=>{
            const paginationFlatRows = table.getPaginationRowModel().flatRows.filter((row)=>row.getCanSelect());
            const { rowSelection: rowSelection } = table.getState();
            let isAllPageRowsSelected = !!paginationFlatRows.length;
            if (isAllPageRowsSelected && paginationFlatRows.some((row)=>!rowSelection[row.id])) isAllPageRowsSelected = false;
            return isAllPageRowsSelected;
        };
        table.getIsSomeRowsSelected = ()=>{
            var _table$getState$rowSe;
            const totalSelected = Object.keys((_table$getState$rowSe = table.getState().rowSelection) != null ? _table$getState$rowSe : {}).length;
            return totalSelected > 0 && totalSelected < table.getFilteredRowModel().flatRows.length;
        };
        table.getIsSomePageRowsSelected = ()=>{
            const paginationFlatRows = table.getPaginationRowModel().flatRows;
            return table.getIsAllPageRowsSelected() ? false : paginationFlatRows.filter((row)=>row.getCanSelect()).some((d)=>d.getIsSelected() || d.getIsSomeSelected());
        };
        table.getToggleAllRowsSelectedHandler = ()=>{
            return (e)=>{
                table.toggleAllRowsSelected(e.target.checked);
            };
        };
        table.getToggleAllPageRowsSelectedHandler = ()=>{
            return (e)=>{
                table.toggleAllPageRowsSelected(e.target.checked);
            };
        };
    },
    createRow: (row, table)=>{
        row.toggleSelected = (value, opts)=>{
            const isSelected = row.getIsSelected();
            table.setRowSelection((old)=>{
                var _opts$selectChildren;
                value = typeof value !== 'undefined' ? value : !isSelected;
                if (row.getCanSelect() && isSelected === value) return old;
                const selectedRowIds = {
                    ...old
                };
                $92e0f91f0be7afe0$var$mutateRowIsSelected(selectedRowIds, row.id, value, (_opts$selectChildren = opts == null ? void 0 : opts.selectChildren) != null ? _opts$selectChildren : true, table);
                return selectedRowIds;
            });
        };
        row.getIsSelected = ()=>{
            const { rowSelection: rowSelection } = table.getState();
            return $92e0f91f0be7afe0$export$710e11cf672b86c(row, rowSelection);
        };
        row.getIsSomeSelected = ()=>{
            const { rowSelection: rowSelection } = table.getState();
            return $92e0f91f0be7afe0$export$8f4c46e5d7907334(row, rowSelection) === 'some';
        };
        row.getIsAllSubRowsSelected = ()=>{
            const { rowSelection: rowSelection } = table.getState();
            return $92e0f91f0be7afe0$export$8f4c46e5d7907334(row, rowSelection) === 'all';
        };
        row.getCanSelect = ()=>{
            var _table$options$enable;
            if (typeof table.options.enableRowSelection === 'function') return table.options.enableRowSelection(row);
            return (_table$options$enable = table.options.enableRowSelection) != null ? _table$options$enable : true;
        };
        row.getCanSelectSubRows = ()=>{
            var _table$options$enable2;
            if (typeof table.options.enableSubRowSelection === 'function') return table.options.enableSubRowSelection(row);
            return (_table$options$enable2 = table.options.enableSubRowSelection) != null ? _table$options$enable2 : true;
        };
        row.getCanMultiSelect = ()=>{
            var _table$options$enable3;
            if (typeof table.options.enableMultiRowSelection === 'function') return table.options.enableMultiRowSelection(row);
            return (_table$options$enable3 = table.options.enableMultiRowSelection) != null ? _table$options$enable3 : true;
        };
        row.getToggleSelectedHandler = ()=>{
            const canSelect = row.getCanSelect();
            return (e)=>{
                var _target;
                if (!canSelect) return;
                row.toggleSelected((_target = e.target) == null ? void 0 : _target.checked);
            };
        };
    }
};
const $92e0f91f0be7afe0$var$mutateRowIsSelected = (selectedRowIds, id, value, includeChildren, table)=>{
    var _row$subRows;
    const row = table.getRow(id, true);
    // const isGrouped = row.getIsGrouped()
    // if ( // TODO: enforce grouping row selection rules
    //   !isGrouped ||
    //   (isGrouped && table.options.enableGroupingRowSelection)
    // ) {
    if (value) {
        if (!row.getCanMultiSelect()) Object.keys(selectedRowIds).forEach((key)=>delete selectedRowIds[key]);
        if (row.getCanSelect()) selectedRowIds[id] = true;
    } else delete selectedRowIds[id];
    // }
    if (includeChildren && (_row$subRows = row.subRows) != null && _row$subRows.length && row.getCanSelectSubRows()) row.subRows.forEach((row)=>$92e0f91f0be7afe0$var$mutateRowIsSelected(selectedRowIds, row.id, value, includeChildren, table));
};
function $92e0f91f0be7afe0$export$f150e72530556b0b(table, rowModel) {
    const rowSelection = table.getState().rowSelection;
    const newSelectedFlatRows = [];
    const newSelectedRowsById = {};
    // Filters top level and nested rows
    const recurseRows = function(rows, depth) {
        return rows.map((row)=>{
            var _row$subRows2;
            const isSelected = $92e0f91f0be7afe0$export$710e11cf672b86c(row, rowSelection);
            if (isSelected) {
                newSelectedFlatRows.push(row);
                newSelectedRowsById[row.id] = row;
            }
            if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length) row = {
                ...row,
                subRows: recurseRows(row.subRows)
            };
            if (isSelected) return row;
        }).filter(Boolean);
    };
    return {
        rows: recurseRows(rowModel.rows),
        flatRows: newSelectedFlatRows,
        rowsById: newSelectedRowsById
    };
}
function $92e0f91f0be7afe0$export$710e11cf672b86c(row, selection) {
    var _selection$row$id;
    return (_selection$row$id = selection[row.id]) != null ? _selection$row$id : false;
}
function $92e0f91f0be7afe0$export$8f4c46e5d7907334(row, selection, table) {
    var _row$subRows3;
    if (!((_row$subRows3 = row.subRows) != null && _row$subRows3.length)) return false;
    let allChildrenSelected = true;
    let someSelected = false;
    row.subRows.forEach((subRow)=>{
        // Bail out early if we know both of these
        if (someSelected && !allChildrenSelected) return;
        if (subRow.getCanSelect()) {
            if ($92e0f91f0be7afe0$export$710e11cf672b86c(subRow, selection)) someSelected = true;
            else allChildrenSelected = false;
        }
        // Check row selection of nested subrows
        if (subRow.subRows && subRow.subRows.length) {
            const subRowChildrenSelected = $92e0f91f0be7afe0$export$8f4c46e5d7907334(subRow, selection);
            if (subRowChildrenSelected === 'all') someSelected = true;
            else if (subRowChildrenSelected === 'some') {
                someSelected = true;
                allChildrenSelected = false;
            } else allChildrenSelected = false;
        }
    });
    return allChildrenSelected ? 'all' : someSelected ? 'some' : false;
}
const $92e0f91f0be7afe0$export$8758689f50bddb9f = /([0-9]+)/gm;
const $92e0f91f0be7afe0$var$alphanumeric = (rowA, rowB, columnId)=>{
    return $92e0f91f0be7afe0$var$compareAlphanumeric($92e0f91f0be7afe0$var$toString(rowA.getValue(columnId)).toLowerCase(), $92e0f91f0be7afe0$var$toString(rowB.getValue(columnId)).toLowerCase());
};
const $92e0f91f0be7afe0$var$alphanumericCaseSensitive = (rowA, rowB, columnId)=>{
    return $92e0f91f0be7afe0$var$compareAlphanumeric($92e0f91f0be7afe0$var$toString(rowA.getValue(columnId)), $92e0f91f0be7afe0$var$toString(rowB.getValue(columnId)));
};
// The text filter is more basic (less numeric support)
// but is much faster
const $92e0f91f0be7afe0$var$text = (rowA, rowB, columnId)=>{
    return $92e0f91f0be7afe0$var$compareBasic($92e0f91f0be7afe0$var$toString(rowA.getValue(columnId)).toLowerCase(), $92e0f91f0be7afe0$var$toString(rowB.getValue(columnId)).toLowerCase());
};
// The text filter is more basic (less numeric support)
// but is much faster
const $92e0f91f0be7afe0$var$textCaseSensitive = (rowA, rowB, columnId)=>{
    return $92e0f91f0be7afe0$var$compareBasic($92e0f91f0be7afe0$var$toString(rowA.getValue(columnId)), $92e0f91f0be7afe0$var$toString(rowB.getValue(columnId)));
};
const $92e0f91f0be7afe0$var$datetime = (rowA, rowB, columnId)=>{
    const a = rowA.getValue(columnId);
    const b = rowB.getValue(columnId);
    // Can handle nullish values
    // Use > and < because == (and ===) doesn't work with
    // Date objects (would require calling getTime()).
    return a > b ? 1 : a < b ? -1 : 0;
};
const $92e0f91f0be7afe0$var$basic = (rowA, rowB, columnId)=>{
    return $92e0f91f0be7afe0$var$compareBasic(rowA.getValue(columnId), rowB.getValue(columnId));
};
// Utils
function $92e0f91f0be7afe0$var$compareBasic(a, b) {
    return a === b ? 0 : a > b ? 1 : -1;
}
function $92e0f91f0be7afe0$var$toString(a) {
    if (typeof a === 'number') {
        if (isNaN(a) || a === Infinity || a === -Infinity) return '';
        return String(a);
    }
    if (typeof a === 'string') return a;
    return '';
}
// Mixed sorting is slow, but very inclusive of many edge cases.
// It handles numbers, mixed alphanumeric combinations, and even
// null, undefined, and Infinity
function $92e0f91f0be7afe0$var$compareAlphanumeric(aStr, bStr) {
    // Split on number groups, but keep the delimiter
    // Then remove falsey split values
    const a = aStr.split($92e0f91f0be7afe0$export$8758689f50bddb9f).filter(Boolean);
    const b = bStr.split($92e0f91f0be7afe0$export$8758689f50bddb9f).filter(Boolean);
    // While
    while(a.length && b.length){
        const aa = a.shift();
        const bb = b.shift();
        const an = parseInt(aa, 10);
        const bn = parseInt(bb, 10);
        const combo = [
            an,
            bn
        ].sort();
        // Both are string
        if (isNaN(combo[0])) {
            if (aa > bb) return 1;
            if (bb > aa) return -1;
            continue;
        }
        // One is a string, one is a number
        if (isNaN(combo[1])) return isNaN(an) ? -1 : 1;
        // Both are numbers
        if (an > bn) return 1;
        if (bn > an) return -1;
    }
    return a.length - b.length;
}
// Exports
const $92e0f91f0be7afe0$export$47423a4cd813a815 = {
    alphanumeric: $92e0f91f0be7afe0$var$alphanumeric,
    alphanumericCaseSensitive: $92e0f91f0be7afe0$var$alphanumericCaseSensitive,
    text: $92e0f91f0be7afe0$var$text,
    textCaseSensitive: $92e0f91f0be7afe0$var$textCaseSensitive,
    datetime: $92e0f91f0be7afe0$var$datetime,
    basic: $92e0f91f0be7afe0$var$basic
};
//
const $92e0f91f0be7afe0$export$c7de5ec16c5efba8 = {
    getInitialState: (state)=>{
        return {
            sorting: [],
            ...state
        };
    },
    getDefaultColumnDef: ()=>{
        return {
            sortingFn: 'auto',
            sortUndefined: 1
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onSortingChange: $92e0f91f0be7afe0$export$2b5605d8069324bd('sorting', table),
            isMultiSortEvent: (e)=>{
                return e.shiftKey;
            }
        };
    },
    createColumn: (column, table)=>{
        column.getAutoSortingFn = ()=>{
            const firstRows = table.getFilteredRowModel().flatRows.slice(10);
            let isString = false;
            for (const row of firstRows){
                const value = row == null ? void 0 : row.getValue(column.id);
                if (Object.prototype.toString.call(value) === '[object Date]') return $92e0f91f0be7afe0$export$47423a4cd813a815.datetime;
                if (typeof value === 'string') {
                    isString = true;
                    if (value.split($92e0f91f0be7afe0$export$8758689f50bddb9f).length > 1) return $92e0f91f0be7afe0$export$47423a4cd813a815.alphanumeric;
                }
            }
            if (isString) return $92e0f91f0be7afe0$export$47423a4cd813a815.text;
            return $92e0f91f0be7afe0$export$47423a4cd813a815.basic;
        };
        column.getAutoSortDir = ()=>{
            const firstRow = table.getFilteredRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === 'string') return 'asc';
            return 'desc';
        };
        column.getSortingFn = ()=>{
            var _table$options$sortin, _table$options$sortin2;
            if (!column) throw new Error();
            return $92e0f91f0be7afe0$export$f6e2535fb5126e54(column.columnDef.sortingFn) ? column.columnDef.sortingFn : column.columnDef.sortingFn === 'auto' ? column.getAutoSortingFn() : (_table$options$sortin = (_table$options$sortin2 = table.options.sortingFns) == null ? void 0 : _table$options$sortin2[column.columnDef.sortingFn]) != null ? _table$options$sortin : $92e0f91f0be7afe0$export$47423a4cd813a815[column.columnDef.sortingFn];
        };
        column.toggleSorting = (desc, multi)=>{
            // if (column.columns.length) {
            //   column.columns.forEach((c, i) => {
            //     if (c.id) {
            //       table.toggleColumnSorting(c.id, undefined, multi || !!i)
            //     }
            //   })
            //   return
            // }
            // this needs to be outside of table.setSorting to be in sync with rerender
            const nextSortingOrder = column.getNextSortingOrder();
            const hasManualValue = typeof desc !== 'undefined' && desc !== null;
            table.setSorting((old)=>{
                // Find any existing sorting for this column
                const existingSorting = old == null ? void 0 : old.find((d)=>d.id === column.id);
                const existingIndex = old == null ? void 0 : old.findIndex((d)=>d.id === column.id);
                let newSorting = [];
                // What should we do with this sort action?
                let sortAction;
                let nextDesc = hasManualValue ? desc : nextSortingOrder === 'desc';
                // Multi-mode
                if (old != null && old.length && column.getCanMultiSort() && multi) {
                    if (existingSorting) sortAction = 'toggle';
                    else sortAction = 'add';
                } else {
                    // Normal mode
                    if (old != null && old.length && existingIndex !== old.length - 1) sortAction = 'replace';
                    else if (existingSorting) sortAction = 'toggle';
                    else sortAction = 'replace';
                }
                // Handle toggle states that will remove the sorting
                if (sortAction === 'toggle') {
                    // If we are "actually" toggling (not a manual set value), should we remove the sorting?
                    if (!hasManualValue) // Is our intention to remove?
                    {
                        if (!nextSortingOrder) sortAction = 'remove';
                    }
                }
                if (sortAction === 'add') {
                    var _table$options$maxMul;
                    newSorting = [
                        ...old,
                        {
                            id: column.id,
                            desc: nextDesc
                        }
                    ];
                    // Take latest n columns
                    newSorting.splice(0, newSorting.length - ((_table$options$maxMul = table.options.maxMultiSortColCount) != null ? _table$options$maxMul : Number.MAX_SAFE_INTEGER));
                } else if (sortAction === 'toggle') // This flips (or sets) the
                newSorting = old.map((d)=>{
                    if (d.id === column.id) return {
                        ...d,
                        desc: nextDesc
                    };
                    return d;
                });
                else if (sortAction === 'remove') newSorting = old.filter((d)=>d.id !== column.id);
                else newSorting = [
                    {
                        id: column.id,
                        desc: nextDesc
                    }
                ];
                return newSorting;
            });
        };
        column.getFirstSortDir = ()=>{
            var _ref, _column$columnDef$sor;
            const sortDescFirst = (_ref = (_column$columnDef$sor = column.columnDef.sortDescFirst) != null ? _column$columnDef$sor : table.options.sortDescFirst) != null ? _ref : column.getAutoSortDir() === 'desc';
            return sortDescFirst ? 'desc' : 'asc';
        };
        column.getNextSortingOrder = (multi)=>{
            var _table$options$enable, _table$options$enable2;
            const firstSortDirection = column.getFirstSortDir();
            const isSorted = column.getIsSorted();
            if (!isSorted) return firstSortDirection;
            if (isSorted !== firstSortDirection && ((_table$options$enable = table.options.enableSortingRemoval) != null ? _table$options$enable : true) && // If enableSortRemove, enable in general
            (multi ? (_table$options$enable2 = table.options.enableMultiRemove) != null ? _table$options$enable2 : true : true // If multi, don't allow if enableMultiRemove))
            )) return false;
            return isSorted === 'desc' ? 'asc' : 'desc';
        };
        column.getCanSort = ()=>{
            var _column$columnDef$ena, _table$options$enable3;
            return ((_column$columnDef$ena = column.columnDef.enableSorting) != null ? _column$columnDef$ena : true) && ((_table$options$enable3 = table.options.enableSorting) != null ? _table$options$enable3 : true) && !!column.accessorFn;
        };
        column.getCanMultiSort = ()=>{
            var _ref2, _column$columnDef$ena2;
            return (_ref2 = (_column$columnDef$ena2 = column.columnDef.enableMultiSort) != null ? _column$columnDef$ena2 : table.options.enableMultiSort) != null ? _ref2 : !!column.accessorFn;
        };
        column.getIsSorted = ()=>{
            var _table$getState$sorti;
            const columnSort = (_table$getState$sorti = table.getState().sorting) == null ? void 0 : _table$getState$sorti.find((d)=>d.id === column.id);
            return !columnSort ? false : columnSort.desc ? 'desc' : 'asc';
        };
        column.getSortIndex = ()=>{
            var _table$getState$sorti2, _table$getState$sorti3;
            return (_table$getState$sorti2 = (_table$getState$sorti3 = table.getState().sorting) == null ? void 0 : _table$getState$sorti3.findIndex((d)=>d.id === column.id)) != null ? _table$getState$sorti2 : -1;
        };
        column.clearSorting = ()=>{
            //clear sorting for just 1 column
            table.setSorting((old)=>old != null && old.length ? old.filter((d)=>d.id !== column.id) : []);
        };
        column.getToggleSortingHandler = ()=>{
            const canSort = column.getCanSort();
            return (e)=>{
                if (!canSort) return;
                e.persist == null || e.persist();
                column.toggleSorting == null || column.toggleSorting(undefined, column.getCanMultiSort() ? table.options.isMultiSortEvent == null ? void 0 : table.options.isMultiSortEvent(e) : false);
            };
        };
    },
    createTable: (table)=>{
        table.setSorting = (updater)=>table.options.onSortingChange == null ? void 0 : table.options.onSortingChange(updater);
        table.resetSorting = (defaultState)=>{
            var _table$initialState$s, _table$initialState;
            table.setSorting(defaultState ? [] : (_table$initialState$s = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.sorting) != null ? _table$initialState$s : []);
        };
        table.getPreSortedRowModel = ()=>table.getGroupedRowModel();
        table.getSortedRowModel = ()=>{
            if (!table._getSortedRowModel && table.options.getSortedRowModel) table._getSortedRowModel = table.options.getSortedRowModel(table);
            if (table.options.manualSorting || !table._getSortedRowModel) return table.getPreSortedRowModel();
            return table._getSortedRowModel();
        };
    }
};
const $92e0f91f0be7afe0$var$builtInFeatures = [
    $92e0f91f0be7afe0$export$79b704688b15c0f4,
    $92e0f91f0be7afe0$export$be5545a32e20d889,
    $92e0f91f0be7afe0$export$fec9c66cd0275c2c,
    $92e0f91f0be7afe0$export$3563275ce70c4813,
    $92e0f91f0be7afe0$export$1f746e6a9cd841b1,
    $92e0f91f0be7afe0$export$f1d67534a0c5e9d3,
    $92e0f91f0be7afe0$export$4b37edcdc7ad2fe1,
    //depends on ColumnFaceting
    $92e0f91f0be7afe0$export$61e9e0661ff79b1c,
    //depends on ColumnFiltering
    $92e0f91f0be7afe0$export$c7de5ec16c5efba8,
    $92e0f91f0be7afe0$export$9c9247c655f92e74,
    //depends on RowSorting
    $92e0f91f0be7afe0$export$fed54e0d64c17fb2,
    $92e0f91f0be7afe0$export$bce540641752d22b,
    $92e0f91f0be7afe0$export$213d72cb2ac7d440,
    $92e0f91f0be7afe0$export$e8905133e7bf3121,
    $92e0f91f0be7afe0$export$9916c85814812d4a
];
//
function $92e0f91f0be7afe0$export$33bbb3ec7652e187(options) {
    var _options$_features, _options$initialState;
    const _features = [
        ...$92e0f91f0be7afe0$var$builtInFeatures,
        ...(_options$_features = options._features) != null ? _options$_features : []
    ];
    let table = {
        _features: _features
    };
    const defaultOptions = table._features.reduce((obj, feature)=>{
        return Object.assign(obj, feature.getDefaultOptions == null ? void 0 : feature.getDefaultOptions(table));
    }, {});
    const mergeOptions = (options)=>{
        if (table.options.mergeOptions) return table.options.mergeOptions(defaultOptions, options);
        return {
            ...defaultOptions,
            ...options
        };
    };
    const coreInitialState = {};
    let initialState = {
        ...coreInitialState,
        ...(_options$initialState = options.initialState) != null ? _options$initialState : {}
    };
    table._features.forEach((feature)=>{
        var _feature$getInitialSt;
        initialState = (_feature$getInitialSt = feature.getInitialState == null ? void 0 : feature.getInitialState(initialState)) != null ? _feature$getInitialSt : initialState;
    });
    const queued = [];
    let queuedTimeout = false;
    const coreInstance = {
        _features: _features,
        options: {
            ...defaultOptions,
            ...options
        },
        initialState: initialState,
        _queue: (cb)=>{
            queued.push(cb);
            if (!queuedTimeout) {
                queuedTimeout = true;
                // Schedule a microtask to run the queued callbacks after
                // the current call stack (render, etc) has finished.
                Promise.resolve().then(()=>{
                    while(queued.length)queued.shift()();
                    queuedTimeout = false;
                }).catch((error)=>setTimeout(()=>{
                        throw error;
                    }));
            }
        },
        reset: ()=>{
            table.setState(table.initialState);
        },
        setOptions: (updater)=>{
            const newOptions = $92e0f91f0be7afe0$export$7f095f455ad5af3f(updater, table.options);
            table.options = mergeOptions(newOptions);
        },
        getState: ()=>{
            return table.options.state;
        },
        setState: (updater)=>{
            table.options.onStateChange == null || table.options.onStateChange(updater);
        },
        _getRowId: (row, index, parent)=>{
            var _table$options$getRow;
            return (_table$options$getRow = table.options.getRowId == null ? void 0 : table.options.getRowId(row, index, parent)) != null ? _table$options$getRow : `${parent ? [
                parent.id,
                index
            ].join('.') : index}`;
        },
        getCoreRowModel: ()=>{
            if (!table._getCoreRowModel) table._getCoreRowModel = table.options.getCoreRowModel(table);
            return table._getCoreRowModel();
        },
        // The final calls start at the bottom of the model,
        // expanded rows, which then work their way up
        getRowModel: ()=>{
            return table.getPaginationRowModel();
        },
        //in next version, we should just pass in the row model as the optional 2nd arg
        getRow: (id, searchAll)=>{
            let row = (searchAll ? table.getPrePaginationRowModel() : table.getRowModel()).rowsById[id];
            if (!row) {
                row = table.getCoreRowModel().rowsById[id];
                if (!row) throw new Error();
            }
            return row;
        },
        _getDefaultColumnDef: $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.options.defaultColumn
            ], (defaultColumn)=>{
            var _defaultColumn;
            defaultColumn = (_defaultColumn = defaultColumn) != null ? _defaultColumn : {};
            return {
                header: (props)=>{
                    const resolvedColumnDef = props.header.column.columnDef;
                    if (resolvedColumnDef.accessorKey) return resolvedColumnDef.accessorKey;
                    if (resolvedColumnDef.accessorFn) return resolvedColumnDef.id;
                    return null;
                },
                // footer: props => props.header.column.id,
                cell: (props)=>{
                    var _props$renderValue$to, _props$renderValue;
                    return (_props$renderValue$to = (_props$renderValue = props.renderValue()) == null || _props$renderValue.toString == null ? void 0 : _props$renderValue.toString()) != null ? _props$renderValue$to : null;
                },
                ...table._features.reduce((obj, feature)=>{
                    return Object.assign(obj, feature.getDefaultColumnDef == null ? void 0 : feature.getDefaultColumnDef());
                }, {}),
                ...defaultColumn
            };
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(options, 'debugColumns', '_getDefaultColumnDef')),
        _getColumnDefs: ()=>table.options.columns,
        getAllColumns: $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table._getColumnDefs()
            ], (columnDefs)=>{
            const recurseColumns = function(columnDefs, parent, depth) {
                if (depth === void 0) depth = 0;
                return columnDefs.map((columnDef)=>{
                    const column = $92e0f91f0be7afe0$export$1bfa986e9c92c0b5(table, columnDef, depth, parent);
                    const groupingColumnDef = columnDef;
                    column.columns = groupingColumnDef.columns ? recurseColumns(groupingColumnDef.columns, column, depth + 1) : [];
                    return column;
                });
            };
            return recurseColumns(columnDefs);
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(options, 'debugColumns', 'getAllColumns')),
        getAllFlatColumns: $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getAllColumns()
            ], (allColumns)=>{
            return allColumns.flatMap((column)=>{
                return column.getFlatColumns();
            });
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(options, 'debugColumns', 'getAllFlatColumns')),
        _getAllFlatColumnsById: $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getAllFlatColumns()
            ], (flatColumns)=>{
            return flatColumns.reduce((acc, column)=>{
                acc[column.id] = column;
                return acc;
            }, {});
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(options, 'debugColumns', 'getAllFlatColumnsById')),
        getAllLeafColumns: $92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table._getOrderColumnsFn()
            ], (allColumns, orderColumns)=>{
            let leafColumns = allColumns.flatMap((column)=>column.getLeafColumns());
            return orderColumns(leafColumns);
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(options, 'debugColumns', 'getAllLeafColumns')),
        getColumn: (columnId)=>{
            const column = table._getAllFlatColumnsById()[columnId];
            return column;
        }
    };
    Object.assign(table, coreInstance);
    for(let index = 0; index < table._features.length; index++){
        const feature = table._features[index];
        feature == null || feature.createTable == null || feature.createTable(table);
    }
    return table;
}
function $92e0f91f0be7afe0$export$32d0bc001e828250() {
    return (table)=>$92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.options.data
            ], (data)=>{
            const rowModel = {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            const accessRows = function(originalRows, depth, parentRow) {
                if (depth === void 0) depth = 0;
                const rows = [];
                for(let i = 0; i < originalRows.length; i++){
                    // This could be an expensive check at scale, so we should move it somewhere else, but where?
                    // if (!id) {
                    //   if (process.env.NODE_ENV !== 'production') {
                    //     throw new Error(`getRowId expected an ID, but got ${id}`)
                    //   }
                    // }
                    // Make the row
                    const row = $92e0f91f0be7afe0$export$3442c5d213434705(table, table._getRowId(originalRows[i], i, parentRow), originalRows[i], i, depth, undefined, parentRow == null ? void 0 : parentRow.id);
                    // Keep track of every row in a flat array
                    rowModel.flatRows.push(row);
                    // Also keep track of every row by its ID
                    rowModel.rowsById[row.id] = row;
                    // Push table row into parent
                    rows.push(row);
                    // Get the original subrows
                    if (table.options.getSubRows) {
                        var _row$originalSubRows;
                        row.originalSubRows = table.options.getSubRows(originalRows[i], i);
                        // Then recursively access them
                        if ((_row$originalSubRows = row.originalSubRows) != null && _row$originalSubRows.length) row.subRows = accessRows(row.originalSubRows, depth + 1, row);
                    }
                }
                return rows;
            };
            rowModel.rows = accessRows(data);
            return rowModel;
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugTable', 'getRowModel', ()=>table._autoResetPageIndex()));
}
function $92e0f91f0be7afe0$export$53cfec7b1b8d1fcd() {
    return (table)=>$92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getState().expanded,
                table.getPreExpandedRowModel(),
                table.options.paginateExpandedRows
            ], (expanded, rowModel, paginateExpandedRows)=>{
            if (!rowModel.rows.length || expanded !== true && !Object.keys(expanded != null ? expanded : {}).length) return rowModel;
            if (!paginateExpandedRows) // Only expand rows at this point if they are being paginated
            return rowModel;
            return $92e0f91f0be7afe0$export$1293f966cdb38633(rowModel);
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugTable', 'getExpandedRowModel'));
}
function $92e0f91f0be7afe0$export$1293f966cdb38633(rowModel) {
    const expandedRows = [];
    const handleRow = (row)=>{
        var _row$subRows;
        expandedRows.push(row);
        if ((_row$subRows = row.subRows) != null && _row$subRows.length && row.getIsExpanded()) row.subRows.forEach(handleRow);
    };
    rowModel.rows.forEach(handleRow);
    return {
        rows: expandedRows,
        flatRows: rowModel.flatRows,
        rowsById: rowModel.rowsById
    };
}
function $92e0f91f0be7afe0$export$d17dd32c9eab9fc7() {
    return (table, columnId)=>$92e0f91f0be7afe0$export$7c73462e0d25e514(()=>{
            var _table$getColumn;
            return [
                (_table$getColumn = table.getColumn(columnId)) == null ? void 0 : _table$getColumn.getFacetedRowModel()
            ];
        }, (facetedRowModel)=>{
            if (!facetedRowModel) return undefined;
            const uniqueValues = facetedRowModel.flatRows.flatMap((flatRow)=>{
                var _flatRow$getUniqueVal;
                return (_flatRow$getUniqueVal = flatRow.getUniqueValues(columnId)) != null ? _flatRow$getUniqueVal : [];
            }).map(Number).filter((value)=>!Number.isNaN(value));
            if (!uniqueValues.length) return;
            let facetedMinValue = uniqueValues[0];
            let facetedMaxValue = uniqueValues[uniqueValues.length - 1];
            for (const value of uniqueValues){
                if (value < facetedMinValue) facetedMinValue = value;
                else if (value > facetedMaxValue) facetedMaxValue = value;
            }
            return [
                facetedMinValue,
                facetedMaxValue
            ];
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugTable', 'getFacetedMinMaxValues'));
}
function $92e0f91f0be7afe0$var$filterRows(rows, filterRowImpl, table) {
    if (table.options.filterFromLeafRows) return $92e0f91f0be7afe0$var$filterRowModelFromLeafs(rows, filterRowImpl, table);
    return $92e0f91f0be7afe0$var$filterRowModelFromRoot(rows, filterRowImpl, table);
}
function $92e0f91f0be7afe0$var$filterRowModelFromLeafs(rowsToFilter, filterRow, table) {
    var _table$options$maxLea;
    const newFilteredFlatRows = [];
    const newFilteredRowsById = {};
    const maxDepth = (_table$options$maxLea = table.options.maxLeafRowFilterDepth) != null ? _table$options$maxLea : 100;
    const recurseFilterRows = function(rowsToFilter, depth) {
        if (depth === void 0) depth = 0;
        const rows = [];
        // Filter from children up first
        for(let i = 0; i < rowsToFilter.length; i++){
            var _row$subRows;
            let row = rowsToFilter[i];
            const newRow = $92e0f91f0be7afe0$export$3442c5d213434705(table, row.id, row.original, row.index, row.depth, undefined, row.parentId);
            newRow.columnFilters = row.columnFilters;
            if ((_row$subRows = row.subRows) != null && _row$subRows.length && depth < maxDepth) {
                newRow.subRows = recurseFilterRows(row.subRows, depth + 1);
                row = newRow;
                if (filterRow(row) && !newRow.subRows.length) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                    continue;
                }
                if (filterRow(row) || newRow.subRows.length) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                    continue;
                }
            } else {
                row = newRow;
                if (filterRow(row)) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                }
            }
        }
        return rows;
    };
    return {
        rows: recurseFilterRows(rowsToFilter),
        flatRows: newFilteredFlatRows,
        rowsById: newFilteredRowsById
    };
}
function $92e0f91f0be7afe0$var$filterRowModelFromRoot(rowsToFilter, filterRow, table) {
    var _table$options$maxLea2;
    const newFilteredFlatRows = [];
    const newFilteredRowsById = {};
    const maxDepth = (_table$options$maxLea2 = table.options.maxLeafRowFilterDepth) != null ? _table$options$maxLea2 : 100;
    // Filters top level and nested rows
    const recurseFilterRows = function(rowsToFilter, depth) {
        if (depth === void 0) depth = 0;
        // Filter from parents downward first
        const rows = [];
        // Apply the filter to any subRows
        for(let i = 0; i < rowsToFilter.length; i++){
            let row = rowsToFilter[i];
            const pass = filterRow(row);
            if (pass) {
                var _row$subRows2;
                if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length && depth < maxDepth) {
                    const newRow = $92e0f91f0be7afe0$export$3442c5d213434705(table, row.id, row.original, row.index, row.depth, undefined, row.parentId);
                    newRow.subRows = recurseFilterRows(row.subRows, depth + 1);
                    row = newRow;
                }
                rows.push(row);
                newFilteredFlatRows.push(row);
                newFilteredRowsById[row.id] = row;
            }
        }
        return rows;
    };
    return {
        rows: recurseFilterRows(rowsToFilter),
        flatRows: newFilteredFlatRows,
        rowsById: newFilteredRowsById
    };
}
function $92e0f91f0be7afe0$export$3519aa0e35dc33b4() {
    return (table, columnId)=>$92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getPreFilteredRowModel(),
                table.getState().columnFilters,
                table.getState().globalFilter,
                table.getFilteredRowModel()
            ], (preRowModel, columnFilters, globalFilter)=>{
            if (!preRowModel.rows.length || !(columnFilters != null && columnFilters.length) && !globalFilter) return preRowModel;
            const filterableIds = [
                ...columnFilters.map((d)=>d.id).filter((d)=>d !== columnId),
                globalFilter ? '__global__' : undefined
            ].filter(Boolean);
            const filterRowsImpl = (row)=>{
                // Horizontally filter rows through each column
                for(let i = 0; i < filterableIds.length; i++){
                    if (row.columnFilters[filterableIds[i]] === false) return false;
                }
                return true;
            };
            return $92e0f91f0be7afe0$var$filterRows(preRowModel.rows, filterRowsImpl, table);
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugTable', 'getFacetedRowModel'));
}
function $92e0f91f0be7afe0$export$1fb5d0c1edc37de2() {
    return (table, columnId)=>$92e0f91f0be7afe0$export$7c73462e0d25e514(()=>{
            var _table$getColumn;
            return [
                (_table$getColumn = table.getColumn(columnId)) == null ? void 0 : _table$getColumn.getFacetedRowModel()
            ];
        }, (facetedRowModel)=>{
            if (!facetedRowModel) return new Map();
            let facetedUniqueValues = new Map();
            for(let i = 0; i < facetedRowModel.flatRows.length; i++){
                const values = facetedRowModel.flatRows[i].getUniqueValues(columnId);
                for(let j = 0; j < values.length; j++){
                    const value = values[j];
                    if (facetedUniqueValues.has(value)) {
                        var _facetedUniqueValues$;
                        facetedUniqueValues.set(value, ((_facetedUniqueValues$ = facetedUniqueValues.get(value)) != null ? _facetedUniqueValues$ : 0) + 1);
                    } else facetedUniqueValues.set(value, 1);
                }
            }
            return facetedUniqueValues;
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugTable', `getFacetedUniqueValues_${columnId}`));
}
function $92e0f91f0be7afe0$export$26f255a2756e1638() {
    return (table)=>$92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getPreFilteredRowModel(),
                table.getState().columnFilters,
                table.getState().globalFilter
            ], (rowModel, columnFilters, globalFilter)=>{
            if (!rowModel.rows.length || !(columnFilters != null && columnFilters.length) && !globalFilter) {
                for(let i = 0; i < rowModel.flatRows.length; i++){
                    rowModel.flatRows[i].columnFilters = {};
                    rowModel.flatRows[i].columnFiltersMeta = {};
                }
                return rowModel;
            }
            const resolvedColumnFilters = [];
            const resolvedGlobalFilters = [];
            (columnFilters != null ? columnFilters : []).forEach((d)=>{
                var _filterFn$resolveFilt;
                const column = table.getColumn(d.id);
                if (!column) return;
                const filterFn = column.getFilterFn();
                if (!filterFn) return;
                resolvedColumnFilters.push({
                    id: d.id,
                    filterFn: filterFn,
                    resolvedValue: (_filterFn$resolveFilt = filterFn.resolveFilterValue == null ? void 0 : filterFn.resolveFilterValue(d.value)) != null ? _filterFn$resolveFilt : d.value
                });
            });
            const filterableIds = (columnFilters != null ? columnFilters : []).map((d)=>d.id);
            const globalFilterFn = table.getGlobalFilterFn();
            const globallyFilterableColumns = table.getAllLeafColumns().filter((column)=>column.getCanGlobalFilter());
            if (globalFilter && globalFilterFn && globallyFilterableColumns.length) {
                filterableIds.push('__global__');
                globallyFilterableColumns.forEach((column)=>{
                    var _globalFilterFn$resol;
                    resolvedGlobalFilters.push({
                        id: column.id,
                        filterFn: globalFilterFn,
                        resolvedValue: (_globalFilterFn$resol = globalFilterFn.resolveFilterValue == null ? void 0 : globalFilterFn.resolveFilterValue(globalFilter)) != null ? _globalFilterFn$resol : globalFilter
                    });
                });
            }
            let currentColumnFilter;
            let currentGlobalFilter;
            // Flag the prefiltered row model with each filter state
            for(let j = 0; j < rowModel.flatRows.length; j++){
                const row = rowModel.flatRows[j];
                row.columnFilters = {};
                if (resolvedColumnFilters.length) for(let i = 0; i < resolvedColumnFilters.length; i++){
                    currentColumnFilter = resolvedColumnFilters[i];
                    const id = currentColumnFilter.id;
                    // Tag the row with the column filter state
                    row.columnFilters[id] = currentColumnFilter.filterFn(row, id, currentColumnFilter.resolvedValue, (filterMeta)=>{
                        row.columnFiltersMeta[id] = filterMeta;
                    });
                }
                if (resolvedGlobalFilters.length) {
                    for(let i = 0; i < resolvedGlobalFilters.length; i++){
                        currentGlobalFilter = resolvedGlobalFilters[i];
                        const id = currentGlobalFilter.id;
                        // Tag the row with the first truthy global filter state
                        if (currentGlobalFilter.filterFn(row, id, currentGlobalFilter.resolvedValue, (filterMeta)=>{
                            row.columnFiltersMeta[id] = filterMeta;
                        })) {
                            row.columnFilters.__global__ = true;
                            break;
                        }
                    }
                    if (row.columnFilters.__global__ !== true) row.columnFilters.__global__ = false;
                }
            }
            const filterRowsImpl = (row)=>{
                // Horizontally filter rows through each column
                for(let i = 0; i < filterableIds.length; i++){
                    if (row.columnFilters[filterableIds[i]] === false) return false;
                }
                return true;
            };
            // Filter final rows using all of the active filters
            return $92e0f91f0be7afe0$var$filterRows(rowModel.rows, filterRowsImpl, table);
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugTable', 'getFilteredRowModel', ()=>table._autoResetPageIndex()));
}
function $92e0f91f0be7afe0$export$2b7f4b57ce71b81() {
    return (table)=>$92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getState().grouping,
                table.getPreGroupedRowModel()
            ], (grouping, rowModel)=>{
            if (!rowModel.rows.length || !grouping.length) {
                rowModel.rows.forEach((row)=>{
                    row.depth = 0;
                    row.parentId = undefined;
                });
                return rowModel;
            }
            // Filter the grouping list down to columns that exist
            const existingGrouping = grouping.filter((columnId)=>table.getColumn(columnId));
            const groupedFlatRows = [];
            const groupedRowsById = {};
            // const onlyGroupedFlatRows: Row[] = [];
            // const onlyGroupedRowsById: Record<RowId, Row> = {};
            // const nonGroupedFlatRows: Row[] = [];
            // const nonGroupedRowsById: Record<RowId, Row> = {};
            // Recursively group the data
            const groupUpRecursively = function(rows, depth, parentId) {
                if (depth === void 0) depth = 0;
                // Grouping depth has been been met
                // Stop grouping and simply rewrite thd depth and row relationships
                if (depth >= existingGrouping.length) return rows.map((row)=>{
                    row.depth = depth;
                    groupedFlatRows.push(row);
                    groupedRowsById[row.id] = row;
                    if (row.subRows) row.subRows = groupUpRecursively(row.subRows, depth + 1, row.id);
                    return row;
                });
                const columnId = existingGrouping[depth];
                // Group the rows together for this level
                const rowGroupsMap = $92e0f91f0be7afe0$var$groupBy(rows, columnId);
                // Perform aggregations for each group
                const aggregatedGroupedRows = Array.from(rowGroupsMap.entries()).map((_ref, index)=>{
                    let [groupingValue, groupedRows] = _ref;
                    let id = `${columnId}:${groupingValue}`;
                    id = parentId ? `${parentId}>${id}` : id;
                    // First, Recurse to group sub rows before aggregation
                    const subRows = groupUpRecursively(groupedRows, depth + 1, id);
                    subRows.forEach((subRow)=>{
                        subRow.parentId = id;
                    });
                    // Flatten the leaf rows of the rows in this group
                    const leafRows = depth ? $92e0f91f0be7afe0$export$bf4548421d1b2c8(groupedRows, (row)=>row.subRows) : groupedRows;
                    const row = $92e0f91f0be7afe0$export$3442c5d213434705(table, id, leafRows[0].original, index, depth, undefined, parentId);
                    Object.assign(row, {
                        groupingColumnId: columnId,
                        groupingValue: groupingValue,
                        subRows: subRows,
                        leafRows: leafRows,
                        getValue: (columnId)=>{
                            // Don't aggregate columns that are in the grouping
                            if (existingGrouping.includes(columnId)) {
                                if (row._valuesCache.hasOwnProperty(columnId)) return row._valuesCache[columnId];
                                if (groupedRows[0]) {
                                    var _groupedRows$0$getVal;
                                    row._valuesCache[columnId] = (_groupedRows$0$getVal = groupedRows[0].getValue(columnId)) != null ? _groupedRows$0$getVal : undefined;
                                }
                                return row._valuesCache[columnId];
                            }
                            if (row._groupingValuesCache.hasOwnProperty(columnId)) return row._groupingValuesCache[columnId];
                            // Aggregate the values
                            const column = table.getColumn(columnId);
                            const aggregateFn = column == null ? void 0 : column.getAggregationFn();
                            if (aggregateFn) {
                                row._groupingValuesCache[columnId] = aggregateFn(columnId, leafRows, groupedRows);
                                return row._groupingValuesCache[columnId];
                            }
                        }
                    });
                    subRows.forEach((subRow)=>{
                        groupedFlatRows.push(subRow);
                        groupedRowsById[subRow.id] = subRow;
                    // if (subRow.getIsGrouped?.()) {
                    //   onlyGroupedFlatRows.push(subRow);
                    //   onlyGroupedRowsById[subRow.id] = subRow;
                    // } else {
                    //   nonGroupedFlatRows.push(subRow);
                    //   nonGroupedRowsById[subRow.id] = subRow;
                    // }
                    });
                    return row;
                });
                return aggregatedGroupedRows;
            };
            const groupedRows = groupUpRecursively(rowModel.rows, 0);
            groupedRows.forEach((subRow)=>{
                groupedFlatRows.push(subRow);
                groupedRowsById[subRow.id] = subRow;
            // if (subRow.getIsGrouped?.()) {
            //   onlyGroupedFlatRows.push(subRow);
            //   onlyGroupedRowsById[subRow.id] = subRow;
            // } else {
            //   nonGroupedFlatRows.push(subRow);
            //   nonGroupedRowsById[subRow.id] = subRow;
            // }
            });
            return {
                rows: groupedRows,
                flatRows: groupedFlatRows,
                rowsById: groupedRowsById
            };
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugTable', 'getGroupedRowModel', ()=>{
            table._queue(()=>{
                table._autoResetExpanded();
                table._autoResetPageIndex();
            });
        }));
}
function $92e0f91f0be7afe0$var$groupBy(rows, columnId) {
    const groupMap = new Map();
    return rows.reduce((map, row)=>{
        const resKey = `${row.getGroupingValue(columnId)}`;
        const previous = map.get(resKey);
        if (!previous) map.set(resKey, [
            row
        ]);
        else previous.push(row);
        return map;
    }, groupMap);
}
function $92e0f91f0be7afe0$export$ddfd3662e196c265(opts) {
    return (table)=>$92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getState().pagination,
                table.getPrePaginationRowModel(),
                table.options.paginateExpandedRows ? undefined : table.getState().expanded
            ], (pagination, rowModel)=>{
            if (!rowModel.rows.length) return rowModel;
            const { pageSize: pageSize, pageIndex: pageIndex } = pagination;
            let { rows: rows, flatRows: flatRows, rowsById: rowsById } = rowModel;
            const pageStart = pageSize * pageIndex;
            const pageEnd = pageStart + pageSize;
            rows = rows.slice(pageStart, pageEnd);
            let paginatedRowModel;
            if (!table.options.paginateExpandedRows) paginatedRowModel = $92e0f91f0be7afe0$export$1293f966cdb38633({
                rows: rows,
                flatRows: flatRows,
                rowsById: rowsById
            });
            else paginatedRowModel = {
                rows: rows,
                flatRows: flatRows,
                rowsById: rowsById
            };
            paginatedRowModel.flatRows = [];
            const handleRow = (row)=>{
                paginatedRowModel.flatRows.push(row);
                if (row.subRows.length) row.subRows.forEach(handleRow);
            };
            paginatedRowModel.rows.forEach(handleRow);
            return paginatedRowModel;
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugTable', 'getPaginationRowModel'));
}
function $92e0f91f0be7afe0$export$4ca93ca80835d8c1() {
    return (table)=>$92e0f91f0be7afe0$export$7c73462e0d25e514(()=>[
                table.getState().sorting,
                table.getPreSortedRowModel()
            ], (sorting, rowModel)=>{
            if (!rowModel.rows.length || !(sorting != null && sorting.length)) return rowModel;
            const sortingState = table.getState().sorting;
            const sortedFlatRows = [];
            // Filter out sortings that correspond to non existing columns
            const availableSorting = sortingState.filter((sort)=>{
                var _table$getColumn;
                return (_table$getColumn = table.getColumn(sort.id)) == null ? void 0 : _table$getColumn.getCanSort();
            });
            const columnInfoById = {};
            availableSorting.forEach((sortEntry)=>{
                const column = table.getColumn(sortEntry.id);
                if (!column) return;
                columnInfoById[sortEntry.id] = {
                    sortUndefined: column.columnDef.sortUndefined,
                    invertSorting: column.columnDef.invertSorting,
                    sortingFn: column.getSortingFn()
                };
            });
            const sortData = (rows)=>{
                // This will also perform a stable sorting using the row index
                // if needed.
                const sortedData = rows.map((row)=>({
                        ...row
                    }));
                sortedData.sort((rowA, rowB)=>{
                    for(let i = 0; i < availableSorting.length; i += 1){
                        var _sortEntry$desc;
                        const sortEntry = availableSorting[i];
                        const columnInfo = columnInfoById[sortEntry.id];
                        const sortUndefined = columnInfo.sortUndefined;
                        const isDesc = (_sortEntry$desc = sortEntry == null ? void 0 : sortEntry.desc) != null ? _sortEntry$desc : false;
                        let sortInt = 0;
                        // All sorting ints should always return in ascending order
                        if (sortUndefined) {
                            const aValue = rowA.getValue(sortEntry.id);
                            const bValue = rowB.getValue(sortEntry.id);
                            const aUndefined = aValue === undefined;
                            const bUndefined = bValue === undefined;
                            if (aUndefined || bUndefined) {
                                if (sortUndefined === 'first') return aUndefined ? -1 : 1;
                                if (sortUndefined === 'last') return aUndefined ? 1 : -1;
                                sortInt = aUndefined && bUndefined ? 0 : aUndefined ? sortUndefined : -sortUndefined;
                            }
                        }
                        if (sortInt === 0) sortInt = columnInfo.sortingFn(rowA, rowB, sortEntry.id);
                        // If sorting is non-zero, take care of desc and inversion
                        if (sortInt !== 0) {
                            if (isDesc) sortInt *= -1;
                            if (columnInfo.invertSorting) sortInt *= -1;
                            return sortInt;
                        }
                    }
                    return rowA.index - rowB.index;
                });
                // If there are sub-rows, sort them
                sortedData.forEach((row)=>{
                    var _row$subRows;
                    sortedFlatRows.push(row);
                    if ((_row$subRows = row.subRows) != null && _row$subRows.length) row.subRows = sortData(row.subRows);
                });
                return sortedData;
            };
            return {
                rows: sortData(rowModel.rows),
                flatRows: sortedFlatRows,
                rowsById: rowModel.rowsById
            };
        }, $92e0f91f0be7afe0$export$b1f82222dc43996c(table.options, 'debugTable', 'getSortedRowModel', ()=>table._autoResetPageIndex()));
}

});


parcelRegister("2T0BN", function(module, exports) {

$parcel$export(module.exports, "useInfiniteScroll", () => $f86225181e5b528c$export$a973cef5093a8d22);

var $gwFzn = parcelRequire("gwFzn");
function $f86225181e5b528c$export$a973cef5093a8d22({ onScrollTo: onScrollTo }) {
    const loadMoreRef = (0, $gwFzn.useRef)(null);
    // This function is called by the IntersectionObserver API when "loaderTarget" UI element
    // changes visibility.  If it has become visible (typically by user scrolling), call our
    // scroll handler and the parent will attempt to load more data
    const fetchMoreCallback = (0, $gwFzn.useCallback)((loadMoreEntry)=>{
        // Sometimes based on an unknown render race condition, the previous IntersectionObserver is not
        // properly cleared before the next one is observed, which causes the 0th indexed IntersectionObserver
        // to never be intersecting, which causes the onScrollTo callback to not be called when it should be.
        // To fix this just get rid of the old observer if it is not properly cleaned up.
        if (loadMoreEntry.length > 1) loadMoreEntry.shift();
        if (loadMoreEntry?.[0].isIntersecting) onScrollTo();
    }, [
        onScrollTo
    ]);
    (0, $gwFzn.useEffect)(()=>{
        const intersectionObserver = new IntersectionObserver(fetchMoreCallback);
        const loadMoreRefCurrent = loadMoreRef.current;
        if (loadMoreRef.current) intersectionObserver.observe(loadMoreRef.current);
        return ()=>{
            if (loadMoreRefCurrent) intersectionObserver.unobserve(loadMoreRefCurrent);
            intersectionObserver.disconnect();
        };
    }, [
        loadMoreRef,
        fetchMoreCallback
    ]);
    return loadMoreRef;
}

});

parcelRegister("fmn3m", function(module, exports) {

$parcel$export(module.exports, "useKeyboardNavigation", () => $7f6e9595258d18bd$export$4da28cf324280418);
/**
 * Allows for tables to use keyboard arrow
 * keys (up, down, left, right) to navigate the table.
 *
 * The hook also includes meta + c to copy the content. Since the
 * table is not ADF, this only copies text content and not the
 * full experience like images / status lozenge.
 */ const $7f6e9595258d18bd$export$4da28cf324280418 = ()=>{
    const tableNavigationControllers = (event)=>{
        const key = event.key;
        const target = event.currentTarget;
        if (key === 'ArrowDown' || key === 'ArrowUp' || key === 'ArrowLeft' || key === 'ArrowRight' || key === 'c' && event.metaKey) event.preventDefault();
        else return;
        const getFocusableElement = (element)=>{
            const focusableSelector = 'input, select, textarea, button, [tabindex]:not([tabindex="-1"])';
            return element.querySelector(focusableSelector);
        };
        let nextElement;
        switch(key){
            case 'ArrowDown':
                nextElement = target.parentElement?.nextElementSibling?.children[target.cellIndex];
                break;
            case 'ArrowUp':
                nextElement = target.parentElement?.previousElementSibling?.children[target.cellIndex];
                break;
            case 'ArrowLeft':
                nextElement = target.previousElementSibling;
                break;
            case 'ArrowRight':
                nextElement = target.nextElementSibling;
                break;
            case 'c':
                if (event.metaKey) target.textContent && navigator.clipboard.writeText(target.textContent);
                break;
        }
        if (nextElement instanceof HTMLElement) {
            nextElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
            const focusableElement = getFocusableElement(nextElement);
            if (focusableElement) focusableElement.focus();
            else nextElement.focus();
        }
    };
    return {
        tableNavigationControllers: tableNavigationControllers
    };
};

});

parcelRegister("9RXAh", function(module, exports) {

$parcel$export(module.exports, "Col", () => $de1f4d14e757a752$export$963a4b2511a4b70c);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
const $de1f4d14e757a752$export$963a4b2511a4b70c = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ children: children, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        as: "col",
        ref: ref,
        ...props,
        children: children
    });
});

});

parcelRegister("cjz3t", function(module, exports) {

$parcel$export(module.exports, "Colgroup", () => $19e93a49858b3430$export$89efc2d0ceeaa030);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $gdv5Z = parcelRequire("gdv5Z");
const $19e93a49858b3430$export$89efc2d0ceeaa030 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ children: children, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        as: "colgroup",
        ref: ref,
        ...props,
        children: children
    });
});

});

parcelRegister("iQ2sA", function(module, exports) {

$parcel$export(module.exports, "ExpandIcon", () => $840a83cc4a8669fd$export$fcdb0af0473ee9e4);
// TODO: Using HipChat icons as the standard icon set is missing large
// versions of `chevron-up` and `chevron-down`, despite already including
// `chevron-left-large` and `chevron-right-large`...

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $hDEQG = parcelRequire("hDEQG");

var $f1W4o = parcelRequire("f1W4o");
const $840a83cc4a8669fd$export$fcdb0af0473ee9e4 = /*#__PURE__*/ (0, $gwFzn.memo)(({ isExpanded: isExpanded })=>{
    switch(isExpanded){
        case false:
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f1W4o))), {
                spacing: "compact",
                LEGACY_size: "small",
                label: "",
                color: "currentColor"
            });
        case true:
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hDEQG))), {
                spacing: "compact",
                LEGACY_size: "small",
                label: "",
                color: "currentColor"
            });
    }
});

});

parcelRegister("aZrok", function(module, exports) {

$parcel$export(module.exports, "TD", () => $d1beedfacd8168fe$export$9cf5b401f969f5e3);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $v1ofh = parcelRequire("v1ofh");
const $d1beedfacd8168fe$export$9cf5b401f969f5e3 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ testId: testId, ...props }, ref)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $v1ofh.BaseCell), {
        as: "td",
        testId: testId,
        ...props,
        ref: ref
    }));

});
parcelRegister("v1ofh", function(module, exports) {

$parcel$export(module.exports, "BaseCell", () => $957288c67e7999c7$export$41ad0bbfa4755cac);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $957288c67e7999c7$var$alignLeftStyles = (0, $ecnYn.xcss)({
    textAlign: 'left'
});
const $957288c67e7999c7$var$alignCenterStyles = (0, $ecnYn.xcss)({
    textAlign: 'center'
});
const $957288c67e7999c7$var$alignRightStyles = (0, $ecnYn.xcss)({
    textAlign: 'right'
});
const $957288c67e7999c7$var$focusOutline = (0, $ecnYn.xcss)({
    ':focus-visible': {
        //@ts-expect-error This is a hack to get better focus styles
        boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #388BFF)"} inset`,
        outline: 'none'
    },
    ':focus': {
        //@ts-expect-error This is a hack to get better focus styles
        boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #388BFF)"} inset`
    }
});
const $957288c67e7999c7$var$alignMap = {
    text: $957288c67e7999c7$var$alignLeftStyles,
    number: $957288c67e7999c7$var$alignRightStyles,
    icon: $957288c67e7999c7$var$alignCenterStyles
};
const $957288c67e7999c7$export$41ad0bbfa4755cac = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ testId: testId, as: as, xcss: customXcss, children: children, align: align = 'text', display: display, paddingBlock: paddingBlock = 'space.100', paddingInline: paddingInline = 'space.100', backgroundColor: backgroundColor, scope: scope, width: width, sortDirection: sortDirection, colSpan: colSpan, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, tabIndex: tabIndex, onKeyDown: onKeyDown }, ref)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        ref: ref,
        scope: scope,
        xcss: [
            $957288c67e7999c7$var$alignMap[align],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $ecnYn.xcss)({
                width: width
            }),
            tabIndex === 0 && $957288c67e7999c7$var$focusOutline,
            customXcss
        ],
        backgroundColor: backgroundColor,
        paddingBlock: paddingBlock,
        paddingInline: paddingInline,
        as: as,
        //@ts-expect-error This is a hack to get around Box's typing not allowing 'unset' or 'table-cell'
        display: display ?? 'unset',
        testId: testId,
        "aria-sort": sortDirection,
        colSpan: colSpan,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        tabIndex: tabIndex,
        onKeyDown: onKeyDown,
        children: children
    });
});

});


parcelRegister("guDfp", function(module, exports) {

$parcel$export(module.exports, "TR", () => $7ca316fbba001a50$export$5582bd7183a5e873);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
const $7ca316fbba001a50$export$5582bd7183a5e873 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ isSelected: isSelected, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        as: "tr",
        tabIndex: -1,
        "aria-selected": isSelected,
        ref: ref,
        ...props
    });
});

});

parcelRegister("7jsiw", function(module, exports) {

$parcel$export(module.exports, "CharlieTableHeader", () => $8cc145d3cb458f69$export$dfa60aeb2051f459);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $klCKg = parcelRequire("klCKg");

var $eEA8O = parcelRequire("eEA8O");

var $7gpC4 = parcelRequire("7gpC4");

var $hW3Sn = parcelRequire("hW3Sn");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $3gadb = parcelRequire("3gadb");
var $afneb = parcelRequire("afneb");

var $3R4xL = parcelRequire("3R4xL");

var $k5ODG = parcelRequire("k5ODG");
const $8cc145d3cb458f69$var$HeaderDescriptionStyles = (0, $ecnYn.xcss)({
    background: "var(--ds-surface-overlay, #FFFFFF)",
    boxSizing: 'content-box',
    maxHeight: '500px',
    maxWidth: '300px',
    //TODO: move this to the children of the tooltip, not as styling for the tooltip
    //@ts-expect-error styling is applying but property does not exist for SafeCSSObject
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles
    ul: {
        paddingLeft: "var(--ds-space-250, 20px)"
    },
    boxShadow: 'elevation.shadow.overlay',
    color: 'color.text',
    padding: 'space.300',
    borderRadius: 'border.radius.050',
    margin: 'space.050'
});
const $8cc145d3cb458f69$var$checkboxWrapperStyle = (0, $ecnYn.xcss)({
    paddingInlineStart: 'space.100'
});
const $8cc145d3cb458f69$var$NotReorderingPaddingStyle = (0, $ecnYn.xcss)({
    paddingInlineStart: 'space.100',
    alignItems: 'center'
});
const $8cc145d3cb458f69$var$overflowInlineStyle = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    alignItems: 'center'
});
const $8cc145d3cb458f69$var$ButtonFontStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    flex: 1,
    textOverflow: 'ellipsis',
    color: 'color.text.subtlest',
    textAlign: 'left',
    fontWeight: 'font.weight.bold'
});
const $8cc145d3cb458f69$var$ButtonFontCurrentSortStyles = (0, $ecnYn.xcss)({
    color: 'color.text.brand'
});
const $8cc145d3cb458f69$var$SortButtonStyle = (0, $3jLHL.css)({
    width: 'fit-content',
    paddingInline: "var(--ds-space-050, 4px)",
    height: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    fill: `${"var(--ds-text-subtlest, #626F86)"} !important`
});
const $8cc145d3cb458f69$var$SortButtonCurrentSortStyle = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    fill: `${"var(--ds-text-brand, #0C66E4)"} !important`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles
    '.sortable-icon': {
        opacity: 1,
        transitionDelay: '150ms'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles
    'svg, path, g': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        fill: `${"var(--ds-text-brand, #0C66E4)"} !important`
    }
});
const $8cc145d3cb458f69$var$DragHandlerIconContainerStyle = (0, $ecnYn.xcss)({
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: 'size.100'
});

const $8cc145d3cb458f69$export$dfa60aeb2051f459 = ({ labels: labels, tableType: tableType, charlieTableColumn: charlieTableColumn, charlieTableState: charlieTableState, index: index, enableResizing: enableResizing = false, enableColumnReorder: enableColumnReorder, enableRowSelection: enableRowSelection, hasWidths: hasWidths, xcss: customXcss, analyticsContext: analyticsContext, interactionName: interactionName })=>{
    const [showIcons, setShowIcons] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState(false);
    const PragmaticHeadCellLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("jurwU")).then((module)=>({
                default: module.PragmaticHeadCell
            })));
    const Header = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useMemo(()=>{
        if (enableResizing || enableColumnReorder) return (props)=>/*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Suspense, {
                fallback: /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3R4xL.HeadCell), props)
            }, /*#__PURE__*/ (0, $3jLHL.jsx)(PragmaticHeadCellLazy, props));
        else return 0, $3R4xL.HeadCell;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enableResizing,
        enableColumnReorder
    ]);
    if (enableRowSelection && index === 0) return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3R4xL.HeadCell), {
        tableType: tableType,
        xcss: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $ecnYn.xcss)({
                // @ts-expect-error-next-line - none of the zIndex ADS tokens equate to 1
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                zIndex: charlieTableColumn.column.getIsPinned() ? 3 : undefined,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                left: `var(--col-${charlieTableColumn.id}-left)`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                right: `var(--col-${charlieTableColumn.id}-right)`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                position: charlieTableColumn.column.getIsPinned() ? 'sticky' : 'relative',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                paddingInlineStart: 'space.100'
            }),
            customXcss
        ],
        width: hasWidths ? `${charlieTableColumn.getSize()}px` : undefined,
        key: charlieTableColumn.id
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
        xcss: $8cc145d3cb458f69$var$checkboxWrapperStyle
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $7gpC4.default), {
        analyticsContext: {
            componentName: 'charlieTableSortColumnButton',
            ...analyticsContext
        },
        "aria-label": labels?.selectAllRows,
        isIndeterminate: charlieTableState.getIsSomeRowsSelected(),
        isChecked: charlieTableState.getIsAllRowsSelected(),
        onClick: ()=>charlieTableState.toggleAllRowsSelected()
    })));
    const sortDirection = charlieTableColumn.column.getIsSorted();
    return /*#__PURE__*/ (0, $3jLHL.jsx)(Header, {
        tableType: tableType,
        xcss: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $ecnYn.xcss)({
                // @ts-expect-error-next-line - none of the zIndex ADS tokens equate to 1
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                zIndex: charlieTableColumn.column.getIsPinned() ? 3 : undefined,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                left: `var(--col-${charlieTableColumn.id}-left)`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                right: `var(--col-${charlieTableColumn.id}-right)`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                position: charlieTableColumn.column.getIsPinned() ? 'sticky' : 'relative',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                ...enableColumnReorder ? {
                    paddingInlineStart: 'space.0',
                    cursor: 'grab'
                } : {
                    //overriding dom default of space.0 for first-of-type
                    ':first-of-type': {
                        paddingInlineStart: 'space.100'
                    }
                }
            }),
            customXcss
        ],
        onWidthChange: (width)=>{
            charlieTableState.setColumnSizing((old)=>({
                    ...old,
                    [charlieTableColumn.id]: width
                }));
        },
        ...sortDirection && {
            sortDirection: sortDirection === 'asc' ? 'ascending' : 'descending'
        },
        enableColumnReorder: enableColumnReorder,
        enableResizing: enableResizing,
        width: hasWidths ? `${charlieTableColumn.getSize()}px` : undefined,
        key: charlieTableColumn.id,
        id: charlieTableColumn.id,
        onMouseEnter: ()=>setShowIcons(true),
        onMouseLeave: ()=>setShowIcons(false)
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3gadb.default), {
        // TODO: remove temporary fix while we figure out why this is erroring out
        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef((props, ref)=>{
            const { children: children, ...rest } = props;
            if (ref == null) return null;
            return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $afneb.default), {
                ...rest,
                ref: ref
            }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
                xcss: $8cc145d3cb458f69$var$HeaderDescriptionStyles
            }, children));
        // NOTE: We use an assertion for React 18 compatibility, it may be solvable in better ways
        }),
        content: charlieTableColumn.column.columnDef.meta?.description && /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), null, /*#__PURE__*/ (0, $3jLHL.jsx)("b", null, (0, $klCKg.flexRender)(charlieTableColumn.column.columnDef.header, charlieTableColumn.getContext())), charlieTableColumn.column.columnDef.meta?.description),
        position: "bottom"
    }, (tooltipProps)=>{
        return charlieTableColumn.column.getCanSort() ? /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), tooltipProps, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $dcJ7R.default), {
            xcss: enableColumnReorder ? $8cc145d3cb458f69$var$overflowInlineStyle : $8cc145d3cb458f69$var$NotReorderingPaddingStyle,
            spread: "space-between",
            ...tooltipProps
        }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $dcJ7R.default), {
            xcss: $8cc145d3cb458f69$var$overflowInlineStyle
        }, enableColumnReorder && /*#__PURE__*/ (0, $3jLHL.jsx)((0, $bUlM5.default), {
            xcss: $8cc145d3cb458f69$var$DragHandlerIconContainerStyle
        }, showIcons && /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hW3Sn))), {
            label: "Drag list item",
            color: "var(--ds-icon, #44546F)",
            LEGACY_size: "small"
        })), /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
            xcss: [
                $8cc145d3cb458f69$var$ButtonFontStyles,
                sortDirection && $8cc145d3cb458f69$var$ButtonFontCurrentSortStyles
            ]
        }, (0, $klCKg.flexRender)(charlieTableColumn.column.columnDef.header, charlieTableColumn.getContext()))), /*#__PURE__*/ (0, $3jLHL.jsx)((0, $eEA8O.default), {
            testId: `${charlieTableColumn.id}-sort-button`,
            spacing: "none",
            appearance: "subtle",
            ...tooltipProps,
            onClick: ()=>charlieTableColumn.column.toggleSorting(),
            "aria-label": `${charlieTableColumn.id} column sort button`,
            interactionName: interactionName,
            analyticsContext: {
                componentName: 'charlieTableSortColumnButton',
                ...analyticsContext
            },
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
            css: [
                $8cc145d3cb458f69$var$SortButtonStyle,
                sortDirection && $8cc145d3cb458f69$var$SortButtonCurrentSortStyle
            ]
        }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $bUlM5.default), {
            xcss: $8cc145d3cb458f69$var$DragHandlerIconContainerStyle
        }, charlieTableColumn.column.columnDef.meta?.sortDescription ? /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3gadb.default), {
            testId: "sort-tooltip",
            content: `${sortDirection === 'asc' ? charlieTableColumn.column.columnDef.meta?.sortDescription.asc : charlieTableColumn.column.columnDef.meta?.sortDescription.desc}`
        }, (showIcons || sortDirection) && /*#__PURE__*/ (0, $3jLHL.jsx)((0, $k5ODG.SortIcon), {
            sortDirection: sortDirection ?? 'asc',
            isCurrentSort: sortDirection ? true : false
        })) : /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, (showIcons || sortDirection) && /*#__PURE__*/ (0, $3jLHL.jsx)((0, $k5ODG.SortIcon), {
            sortDirection: sortDirection ?? 'asc',
            isCurrentSort: sortDirection ? true : false
        })))))) : /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), tooltipProps, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $dcJ7R.default), {
            xcss: enableColumnReorder ? $8cc145d3cb458f69$var$overflowInlineStyle : $8cc145d3cb458f69$var$NotReorderingPaddingStyle
        }, enableColumnReorder && /*#__PURE__*/ (0, $3jLHL.jsx)((0, $bUlM5.default), {
            xcss: $8cc145d3cb458f69$var$DragHandlerIconContainerStyle
        }, showIcons && /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hW3Sn))), {
            label: "Drag list item",
            color: "var(--ds-icon, #44546F)",
            LEGACY_size: "small"
        })), /*#__PURE__*/ (0, $3jLHL.jsx)((0, $6f0Oj.default), {
            xcss: $8cc145d3cb458f69$var$ButtonFontStyles
        }, (0, $klCKg.flexRender)(charlieTableColumn.column.columnDef.header, charlieTableColumn.getContext()))));
    }));
};

});
parcelRegister("3R4xL", function(module, exports) {

$parcel$export(module.exports, "HeadCell", () => $c3b04bb9f1405694$export$4e8024263ace498b);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $ecnYn = parcelRequire("ecnYn");

var $iBkJn = parcelRequire("iBkJn");

var $iOD6S = parcelRequire("iOD6S");
const $c3b04bb9f1405694$var$InputHeadStyle = (0, $ecnYn.xcss)({
    borderBlock: '1px solid',
    borderInlineEnd: '1px solid',
    borderColor: 'color.border',
    backgroundColor: 'elevation.surface.sunken'
});
const $c3b04bb9f1405694$var$InventoryHeadStyle = (0, $ecnYn.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-of-type': {
        borderInlineEnd: '1px solid',
        borderColor: 'color.border'
    },
    backgroundColor: 'elevation.surface',
    height: '48px',
    borderBlockStart: '1px solid',
    borderBlockEnd: '2px solid',
    borderColor: 'color.border'
});
const $c3b04bb9f1405694$var$HeadCellStyle = (0, $ecnYn.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':first-of-type': {
        borderInlineStart: '1px solid',
        borderColor: 'color.border',
        borderTopLeftRadius: '7px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-of-type': {
        paddingInline: 'space.100',
        borderColor: 'color.border',
        borderTopRightRadius: '7px'
    },
    position: 'sticky',
    borderColor: 'color.border',
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
    color: 'color.text.subtlest',
    textAlign: 'left',
    top: 'space.0',
    // @ts-expect-error-next-line - none of the zIndex ADS tokens equate to 2
    zIndex: 2,
    paddingInline: 'space.100'
});
const $c3b04bb9f1405694$export$4e8024263ace498b = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ children: children, align: align, testId: testId, backgroundColor: backgroundColor, xcss: customXcss, scope: scope = 'col', tableType: tableType = (0, $iOD6S.TableType).input, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iBkJn.TH), {
        ...props,
        scope: scope,
        align: align,
        testId: testId,
        ref: ref,
        xcss: [
            $c3b04bb9f1405694$var$HeadCellStyle,
            tableType === (0, $iOD6S.TableType).inventory && $c3b04bb9f1405694$var$InventoryHeadStyle,
            tableType === (0, $iOD6S.TableType).input && $c3b04bb9f1405694$var$InputHeadStyle,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- this is inline with what atlaskit primitives do.
            customXcss
        ],
        backgroundColor: backgroundColor,
        children: children
    });
});

});
parcelRegister("iBkJn", function(module, exports) {

$parcel$export(module.exports, "TH", () => $7b22f3e559363ada$export$2b39a3648955dd09);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $v1ofh = parcelRequire("v1ofh");
const $7b22f3e559363ada$export$2b39a3648955dd09 = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $v1ofh.BaseCell), {
        as: "th",
        ref: ref,
        ...props
    });
});

});


parcelRegister("k5ODG", function(module, exports) {

$parcel$export(module.exports, "SortIcon", () => $9951220f6b402ec3$export$72820c4f313d7b94);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $7U1nR = parcelRequire("7U1nR");

var $5wA5J = parcelRequire("5wA5J");
const $9951220f6b402ec3$var$styles = (0, $3jLHL.css)({
    display: 'flex',
    alignSelf: 'center',
    opacity: 1,
    transition: 'opacity 100ms ease-in-out'
});
const $9951220f6b402ec3$var$SortableIconClassName = 'sortable-icon';
const $9951220f6b402ec3$export$72820c4f313d7b94 = /*#__PURE__*/ (0, $gwFzn.memo)(({ sortDirection: sortDirection, isCurrentSort: isCurrentSort })=>{
    const primaryColor = isCurrentSort ? "var(--ds-icon-brand, #0C66E4)" : "var(--ds-text-disabled, #091E424F)";
    const showSortUp = !isCurrentSort || isCurrentSort && sortDirection === 'asc';
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: $9951220f6b402ec3$var$styles,
        className: $9951220f6b402ec3$var$SortableIconClassName
    }, showSortUp ? /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5wA5J))), {
        label: "ascending",
        color: primaryColor,
        spacing: "compact"
    }) : /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7U1nR))), {
        label: "descending",
        color: primaryColor,
        spacing: "compact"
    })));
});

});

parcelRegister("jurwU", function(module, exports) {

let $e3062c7f3ab3af8f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $e3062c7f3ab3af8f$var$load("d0wJC"),
    $e3062c7f3ab3af8f$var$load("6hrnI")
]).then(()=>parcelRequire('daD3F'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});




parcelRegister("28Rio", function(module, exports) {

$parcel$export(module.exports, "TBody", () => $e70636abc50199e7$export$7005b8a93a167348);
/* body.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1Whri = parcelRequire("1Whri");

var $kFxTL = parcelRequire("kFxTL");
const $e70636abc50199e7$var$bodyStyles = {
    root: "_19itglyw _kqswh2mm"
};
const $e70636abc50199e7$export$7005b8a93a167348 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef(({ children: children, xcss: customXcss, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kFxTL.TBody), {
        xcss: (0, $1Whri.cx)($e70636abc50199e7$var$bodyStyles.root, customXcss),
        ref: ref,
        ...props,
        children: children
    });
});

});
parcelRegister("kFxTL", function(module, exports) {

$parcel$export(module.exports, "TBody", () => $c4694209f032805c$export$7005b8a93a167348);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $gdv5Z = parcelRequire("gdv5Z");
const $c4694209f032805c$export$7005b8a93a167348 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        as: "tbody",
        ...props,
        ref: ref,
        children: children
    }));

});


parcelRegister("cYjS3", function(module, exports) {

$parcel$export(module.exports, "Row", () => $b0705fe2b482cee0$export$b59bdbef9ce70de2);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dOMrE = parcelRequire("dOMrE");

var $ecnYn = parcelRequire("ecnYn");

var $guDfp = parcelRequire("guDfp");
const $b0705fe2b482cee0$var$bodyRowStyles = (0, $ecnYn.xcss)({
    height: '44px',
    ':hover': {
        backgroundColor: 'elevation.surface.raised.hovered'
    },
    ':focus-visible::after': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        boxShadow: undefined
    },
    position: 'relative',
    border: 'none',
    borderImageWidth: 0,
    borderSpacing: 0,
    backgroundColor: 'elevation.surface'
});
const $b0705fe2b482cee0$var$compactRow = (0, $ecnYn.xcss)({
    height: '36px'
});
const $b0705fe2b482cee0$export$b59bdbef9ce70de2 = /*#__PURE__*/ (0, $gwFzn.memo)(/*#__PURE__*/ (0, $gwFzn.forwardRef)(({ children: children, testId: testId, spacing: spacing, xcss: customXcss, isSelected: isSelected, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dOMrE.default), {
        isInset: true,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $guDfp.TR), {
            ref: ref,
            isSelected: isSelected,
            testId: testId,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- this is inline with what atlaskit primitives do.
            xcss: [
                $b0705fe2b482cee0$var$bodyRowStyles,
                spacing === 'compact' && $b0705fe2b482cee0$var$compactRow,
                customXcss
            ],
            ...props,
            children: children
        })
    });
}));

});

parcelRegister("6fw8B", function(module, exports) {

$parcel$export(module.exports, "RowCell", () => $2030077b886f9b1c$export$502da2b9cfd708e5);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $ecnYn = parcelRequire("ecnYn");

var $aZrok = parcelRequire("aZrok");

var $iOD6S = parcelRequire("iOD6S");
const $2030077b886f9b1c$var$InputCellStyle = (0, $ecnYn.xcss)({
    borderInlineEnd: '1px solid',
    borderColor: 'color.border'
});
const $2030077b886f9b1c$var$InventoryCellStyle = (0, $ecnYn.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-of-type': {
        borderInlineEnd: '1px solid',
        borderColor: 'color.border'
    }
});
const $2030077b886f9b1c$var$RowCellStyle = (0, $ecnYn.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':first-of-type': {
        paddingInlineStart: 'space.200',
        borderInlineStart: '1px solid',
        borderColor: 'color.border',
        paddingBlock: 'space.0'
    },
    paddingInlineStart: 'space.200',
    borderBlockEndWidth: '1px',
    borderBlockEndStyle: 'solid',
    paddingBlock: 'space.0',
    borderColor: 'color.border',
    whiteSpace: 'nowrap',
    background: 'inherit'
});
const $2030077b886f9b1c$export$502da2b9cfd708e5 = /*#__PURE__*/ (0, $gwFzn.memo)(/*#__PURE__*/ (0, $gwFzn.forwardRef)(({ children: children, testId: testId, xcss: customXcss, tableType: tableType = (0, $iOD6S.TableType).input, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aZrok.TD), {
        testId: testId,
        xcss: [
            $2030077b886f9b1c$var$RowCellStyle,
            tableType === (0, $iOD6S.TableType).inventory && $2030077b886f9b1c$var$InventoryCellStyle,
            tableType === (0, $iOD6S.TableType).input && $2030077b886f9b1c$var$InputCellStyle,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- this is inline with what atlaskit primitives do.
            customXcss
        ],
        ref: ref,
        ...props,
        children: children
    });
}));

});

parcelRegister("hGblJ", function(module, exports) {

$parcel$export(module.exports, "Table", () => $dd0830a1b76a5e9a$export$54ec01a60f47d33d);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $8e0So = parcelRequire("8e0So");
const $dd0830a1b76a5e9a$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ children: children, testId: testId, xcss: customXcss, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8e0So.Table), {
        testId: testId,
        xcss: customXcss,
        ref: ref,
        ...props,
        children: children
    });
});

});
parcelRegister("8e0So", function(module, exports) {

$parcel$export(module.exports, "Table", () => $18ceeb1d0ac0a4d7$export$54ec01a60f47d33d);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
const $18ceeb1d0ac0a4d7$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ children: children, testId: testId, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        as: "table",
        testId: testId,
        ref: ref,
        ...props,
        children: children
    });
});

});


parcelRegister("gl38E", function(module, exports) {

$parcel$export(module.exports, "THead", () => $1812ae9ad97e6d29$export$c4c2bc57f2e82919);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $ecnYn = parcelRequire("ecnYn");

var $bos7t = parcelRequire("bos7t");
const $1812ae9ad97e6d29$var$THeadBaseStyles = (0, $ecnYn.xcss)({
    position: 'sticky',
    //@ts-expect-error suggested options do not have value equivalent to 2
    zIndex: 2,
    inset: 'space.0',
    border: 'none',
    backgroundColor: 'color.background.input.hovered',
    borderTopLeftRadius: '7px',
    borderTopRightRadius: '7px',
    overflow: 'hidden',
    '::before': {
        content: '""',
        position: 'absolute',
        top: 'space.0',
        left: 'space.0',
        backgroundColor: 'color.background.neutral'
    }
});
const $1812ae9ad97e6d29$export$c4c2bc57f2e82919 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ children: children, xcss: customXcss, ...props }, ref)=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- this is inline with what atlaskit primitives do.
    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bos7t.THead), {
        xcss: [
            $1812ae9ad97e6d29$var$THeadBaseStyles,
            customXcss
        ],
        ref: ref,
        ...props,
        children: children
    }));
});

});
parcelRegister("bos7t", function(module, exports) {

$parcel$export(module.exports, "THead", () => $d4991935fe406082$export$c4c2bc57f2e82919);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
const $d4991935fe406082$export$c4c2bc57f2e82919 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ children: children, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        as: "thead",
        ...props,
        ref: ref,
        children: children
    });
});

});


parcelRegister("zfg5A", function(module, exports) {

$parcel$export(module.exports, "useConvertCharlieTableToTanStack", () => $9cb2c03bb7ad2029$export$c430cf84aab272ac);
/* eslint-disable no-console */ 
var $gwFzn = parcelRequire("gwFzn");

var $cBPBN = parcelRequire("cBPBN");

var $3p6wB = parcelRequire("3p6wB");
const $9cb2c03bb7ad2029$export$c430cf84aab272ac = (options)=>{
    const columnHelper = (0, $cBPBN.createColumnHelper)();
    const stableEmptyTanArray = (0, $gwFzn.useMemo)(()=>[], []);
    const stableEmptyCharlesArray = (0, $gwFzn.useMemo)(()=>[], []);
    const mapRowsToData = (0, $gwFzn.useCallback)((rows)=>{
        return rows.map((row)=>({
                ...row.data,
                isExpandable: row.isExpandable,
                isDefaultExpanded: row.isDefaultExpanded,
                isDisabled: row.isDisabled,
                isHidden: row.isHidden,
                groupKey: row.groupKey,
                groupValue: row.groupValue,
                overrideRender: row.overrideRender,
                subRows: row.subRows ? mapRowsToData(row.subRows) : undefined
            }));
    }, []);
    const mappedRowToData = (0, $gwFzn.useMemo)(()=>{
        return mapRowsToData(options.rows ?? stableEmptyCharlesArray);
    }, [
        mapRowsToData,
        options.rows,
        stableEmptyCharlesArray
    ]);
    // Memoize columns
    const memoizedColumns = (0, $gwFzn.useMemo)(()=>{
        return options.columnDefs ?? options.columns?.map((oldColumn)=>{
            if ($9cb2c03bb7ad2029$var$isCharlieTableColumn(oldColumn)) return columnHelper.accessor((row)=>row, {
                id: oldColumn.key,
                enableSorting: oldColumn.isSortable,
                header: ()=>oldColumn.content,
                minSize: oldColumn.minWidth,
                size: oldColumn.width,
                maxSize: oldColumn.maxWidth,
                cell: (props)=>oldColumn.cell.render(props.getValue()),
                meta: {
                    description: oldColumn.description,
                    sortDescription: oldColumn.sortDescription
                }
            });
            return oldColumn;
        });
    }, [
        columnHelper,
        options.columns,
        options.columnDefs
    ]);
    const data = (0, $gwFzn.useMemo)(()=>{
        return $9cb2c03bb7ad2029$var$hasCharlieParam(options, 'rows') ? mappedRowToData : options.data ?? stableEmptyTanArray;
    }, [
        options,
        mappedRowToData,
        stableEmptyTanArray
    ]);
    const sortingOption = $9cb2c03bb7ad2029$var$hasTanstackParam(options, 'onSortingChange') ? {
        onSortingChange: options.onSortingChange
    } : $9cb2c03bb7ad2029$var$hasCharlieParam(options, 'onSortChange') ? {
        onSortingChange: $9cb2c03bb7ad2029$var$handleSortChange(options)
    } : {};
    // Convert CharlieTableHook options to TanStack TableOptions
    // @ts-expect-error have to translate between types. will be deleted
    const tanStackOptions = {
        ...options,
        columns: memoizedColumns ?? [],
        data: data,
        initialState: {
            ...options.initialState?.columnOrder && {
                columnOrder: options.initialState?.columnOrder,
                columnVisibility: options.initialState.columnVisibility ?? memoizedColumns?.reduce((acc, col)=>{
                    if (col.id) {
                        if (options.state?.columnOrder?.includes(col.id)) acc[col.id] = true; // Set all columns to visible by default
                        else acc[col.id] = false;
                    }
                    return acc;
                }, {})
            },
            ...options.initialState?.columnVisibility && {
                columnVisibility: options.initialState.columnVisibility
            },
            ...options.initialState?.sorting && {
                sorting: $9cb2c03bb7ad2029$var$convertToSortingState(options.initialState?.sorting)
            },
            ...options.initialState?.expanded && {
                expanded: options.initialState?.expanded
            },
            ...options.initialState?.rowSelection && {
                rowSelection: options.initialState?.rowSelection
            },
            ...options.initialState?.columnWidths && {
                columnSizing: options.initialState?.columnWidths
            },
            ...options.initialState?.columnSizing && {
                columnSizing: options.initialState?.columnSizing
            },
            ...options.initialState?.columnPinning && {
                columnPinning: $9cb2c03bb7ad2029$var$convertToColumnPinningState(options.initialState?.columnPinning)
            }
        },
        state: {
            ...options.state?.columnOrder && {
                columnOrder: options.state?.columnOrder,
                columnVisibility: options.state.columnVisibility ?? memoizedColumns?.reduce((acc, col)=>{
                    if (col.id) {
                        if (options.state?.columnOrder?.includes(col.id)) acc[col.id] = true; // Set all columns to visible by default
                        else acc[col.id] = false;
                    }
                    return acc;
                }, {})
            },
            ...options.state?.columnVisibility && {
                columnVisibility: options.state.columnVisibility
            },
            ...options.state?.sorting && {
                sorting: $9cb2c03bb7ad2029$var$convertToSortingState(options.state?.sorting)
            },
            ...options.state?.expanded && {
                expanded: options.state?.expanded
            },
            ...options.state?.rowSelection && {
                rowSelection: options.state?.rowSelection
            },
            ...options.state?.columnWidths && {
                columnSizing: options.state?.columnWidths
            },
            ...options.state?.columnSizing && {
                columnSizing: options.state?.columnSizing
            },
            ...options.state?.grouping && {
                grouping: options.state.grouping
            },
            ...options.state?.columnPinning && {
                columnPinning: $9cb2c03bb7ad2029$var$convertToColumnPinningState(options.state?.columnPinning)
            },
            ...options.state?.columnVisibility && {
                columnVisibility: options.state.columnVisibility
            }
        },
        ...options.onColumnOrderChange && {
            onColumnOrderChange: options.onColumnOrderChange
        },
        ...sortingOption,
        //these are the charlieParams if they're still be used
        ...$9cb2c03bb7ad2029$var$hasCharlieParam(options, 'defaultColumnWidths') && {
            defaultColumn: {
                size: options.defaultColumnWidths?.width,
                maxSize: options.defaultColumnWidths?.maxWidth,
                minSize: options.defaultColumnWidths?.minWidth
            }
        },
        ...$9cb2c03bb7ad2029$var$hasCharlieParam(options, 'onSelectionChange') && {
            onRowSelectionChange: options.onSelectionChange
        },
        ...$9cb2c03bb7ad2029$var$hasCharlieParam(options, 'onColumnWidthsChange') && {
            onColumnSizingChange: options.onColumnWidthsChange
        },
        ...$9cb2c03bb7ad2029$var$hasCharlieParam(options, 'rows') && $9cb2c03bb7ad2029$var$hasCharlieParam(options, 'getRowId') && {
            // @ts-expect-error deleting once charliehook is deprecated
            getRowId: (row, index)=>options.getRowId({
                    row: {
                        data: row
                    },
                    index: index
                })
        },
        ...$9cb2c03bb7ad2029$var$hasCharlieParam(options, 'rows') && {
            getSubRows: (row)=>row.subRows
        },
        ...$9cb2c03bb7ad2029$var$hasCharlieParam(options, 'onExpandChange') && {
            onExpandedChange: options.onExpandChange
        },
        ...$9cb2c03bb7ad2029$var$hasCharlieParam(options, 'rows') && {
            //@ts-expect-error deleting once charliehook is deprecated
            getRowCanExpand: (row)=>row.original.isExpandable === true
        },
        //tanstack params will overwrite any charlie params
        ...$9cb2c03bb7ad2029$var$hasTanstackParam(options, 'onRowSelectionChange') && {
            onRowSelectionChange: options.onRowSelectionChange
        },
        ...$9cb2c03bb7ad2029$var$hasTanstackParam(options, 'onColumnSizingChange') && {
            onColumnSizingChange: options.onColumnSizingChange
        },
        ...$9cb2c03bb7ad2029$var$hasTanstackParam(options, 'getSubRows') && !$9cb2c03bb7ad2029$var$hasCharlieParam(options, 'rows') && {
            getSubRows: options.getSubRows
        },
        ...$9cb2c03bb7ad2029$var$hasTanstackParam(options, 'defaultColumn') && {
            defaultColumn: options.defaultColumn
        },
        ...$9cb2c03bb7ad2029$var$hasTanstackParam(options, 'onExpandedChange') && {
            onExpandedChange: options.onExpandedChange
        },
        ...!$9cb2c03bb7ad2029$var$hasCharlieParam(options, 'rows') && $9cb2c03bb7ad2029$var$hasTanstackParam(options, 'getRowId') && {
            getRowId: options.getRowId
        },
        ...!$9cb2c03bb7ad2029$var$hasCharlieParam(options, 'rows') && $9cb2c03bb7ad2029$var$hasTanstackParam(options, 'getSubRows') && {
            getSubRows: options.getSubRows
        },
        ...$9cb2c03bb7ad2029$var$hasTanstackParam(options, 'getRowCanExpand') && {
            getRowCanExpand: options.getRowCanExpand
        },
        enableSortingRemoval: options.enableSortingRemoval ?? false,
        enableRowSelection: options.enableRowSelection,
        getCoreRowModel: (0, $cBPBN.getCoreRowModel)(),
        getExpandedRowModel: (0, $cBPBN.getExpandedRowModel)(),
        getGroupedRowModel: options.enableServerSideGrouping ? (0, $3p6wB.manualGroupedRowModel)() : (0, $cBPBN.getGroupedRowModel)(),
        getSortedRowModel: (0, $cBPBN.getSortedRowModel)()
    };
    return tanStackOptions;
};
function $9cb2c03bb7ad2029$var$isCharlieTableColumn(column) {
    return column && column.key != null && column.content != null && column.cell && typeof column.cell.render === 'function';
}
const $9cb2c03bb7ad2029$var$convertToColumnPinningState = (pinning)=>{
    if (!pinning) return {
        left: [],
        right: []
    };
    if ('start' in pinning || 'end' in pinning) return {
        left: pinning.start ?? [],
        right: pinning.end ?? []
    };
    return pinning;
};
const $9cb2c03bb7ad2029$var$convertToSortingState = (sorting)=>{
    if (Array.isArray(sorting)) return sorting;
    else if (sorting?.field) return [
        {
            id: sorting.field,
            desc: sorting.direction === 'desc'
        }
    ];
    // If sorting is undefined, return an empty array.
    return [];
};
function $9cb2c03bb7ad2029$var$hasCharlieParam(options, parameter) {
    const isUsingCharles = parameter in options;
    return isUsingCharles;
}
function $9cb2c03bb7ad2029$var$hasTanstackParam(options, parameter) {
    return parameter in options;
}
const $9cb2c03bb7ad2029$var$handleSortChange = (options)=>{
    return (sortUpdator)=>{
        if ($9cb2c03bb7ad2029$var$hasCharlieParam(options, 'onSortChange') && options.onSortChange) {
            // Convert Tanstack sorting to original format
            const sortingValue = (0, $cBPBN.functionalUpdate)(sortUpdator, $9cb2c03bb7ad2029$var$convertToSortingState(options.state?.sorting));
            const convertedSort = sortingValue && sortingValue.length > 0 ? {
                field: sortingValue[0].id,
                direction: sortingValue[0].desc ? 'desc' : 'asc'
            } : undefined;
            options.onSortChange(convertedSort);
        }
        return undefined;
    };
};

});
parcelRegister("3p6wB", function(module, exports) {

$parcel$export(module.exports, "manualGroupedRowModel", () => $9ccd9ab808f7ec92$export$bfec7ec94303aa98);

var $cBPBN = parcelRequire("cBPBN");
function $9ccd9ab808f7ec92$export$bfec7ec94303aa98() {
    return (table)=>(0, $cBPBN.memo)(()=>[
                table.getState().grouping,
                table.getPreGroupedRowModel()
            ], (grouping, rowModel)=>{
            try {
                if (!rowModel.rows.length || !grouping.length) return rowModel;
                // Filter the grouping list down to columns that exist
                const existingGrouping = grouping.filter((columnId)=>table.getColumn(columnId));
                const groupedFlatRows = [];
                const groupedRowsById = {};
                // Recursively group the data
                const groupUpRecursively = (rows, depth = 0, parentId)=>{
                    // Grouping depth has been been met
                    // Stop grouping and simply rewrite thd depth and row relationships
                    if (depth >= existingGrouping.length) return rows.map((row)=>{
                        row.depth = depth;
                        groupedFlatRows.push(row);
                        groupedRowsById[row.id] = row;
                        if (row.subRows.length) row.subRows = groupUpRecursively(row.subRows, depth + 1, row.id);
                        return row;
                    });
                    const columnId = existingGrouping[depth];
                    if (!columnId) throw new Error('Column not found');
                    return rows.map((row)=>{
                        const groupingValue = row.getGroupingValue(columnId);
                        const id = row.id;
                        const subRows = groupUpRecursively(row.subRows, depth + 1, id);
                        const leafRows = depth ? (0, $cBPBN.flattenBy)(row.subRows, (row)=>row.subRows) : row.subRows;
                        const groupedRow = (0, $cBPBN.createRow)(table, id, row.original, 0, depth, undefined, parentId);
                        return Object.assign(groupedRow, {
                            groupingColumnId: columnId,
                            groupingValue: groupingValue,
                            subRows: subRows,
                            leafRows: leafRows
                        });
                    });
                };
                const groupedRows = groupUpRecursively(rowModel.rows, 0);
                groupedRows.forEach((subRow)=>{
                    groupedFlatRows.push(subRow);
                    groupedRowsById[subRow.id] = subRow;
                });
                return {
                    rows: groupedRows,
                    flatRows: groupedFlatRows,
                    rowsById: groupedRowsById
                };
            } catch (error) {
                return rowModel;
            }
        }, (0, $cBPBN.getMemoOptions)(table.options, 'debugTable', 'getGroupedRowModel', ()=>{
            table._queue(()=>{
                table._autoResetExpanded();
                table._autoResetPageIndex();
            });
        }));
}

});


parcelRegister("1MT74", function(module, exports) {

let $14d5066fe33fd41e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $14d5066fe33fd41e$var$load("d0wJC").then(()=>parcelRequire('iXELe'));

});



//# sourceMappingURL=shortcut-pro-tip.3c9d2bc7.js.map
